// Qt.include("GGBomExport.js")
// Qt.include("../../Project/Funcs.js")
// Qt.include("LayoutToolNew.js")
// Qt.include("../MaterialBill/MaterialFuncs.js")
// Qt.include("../../JavaScriptHttpRequest.js")
import { translateLang } from '@/data/i18n/translateLang'
import {
  uniquePlankNum as createUniquePlankNum,
  dealNumber,
  getFlipObject,
  isOtherSideMachineHole,
  isOtherSideMachineSlot,
  isSideMachineMillInfo,
  toDecimal,
} from '@/util/commonFuncs'
import { getPlateKnifeDiameter } from '@/util/dealPaibanData.js'
// import { rolloverPlank } from '@/util/LayoutFuncs.js'
import { expandPath } from '@/util/dealPlankDataFuncs'
import {
  compositeTexturePlanks,
  decompositeTexturePlanks,
  forEachTextureChild,
  isTextureAlignmentPlank,
  isVirtualCompositePlank,
  transformTextureGroup,
} from '@/util/plankAlignTexture'
import {
  dealEdgeInfoChange,
  dealFormerEdgeChange,
  dealLineSlotPointB,
  dealPathToBasePoint,
  flipPath,
  getPathMinMaxPoint,
  sumPiercedCurveHolesAreaDedupeNested,
} from '@/util/plankCommonFuncs'
import { nanoid } from 'nanoid'

import store from '../store'
import { exterPathEdgeForPart } from './LayoutTool'
import {
  adjustHoleDirection,
  dealExpandSlot,
  rotate180Part,
  rotatePart,
} from './LayoutTool.js'
import { isLongPlateProcessing } from './createTag'
import { dealPlankHoleSlotCSide } from './dealPaibanData.js'
import { ggidEncodeList } from './ggid'
import { compareNumbers } from './graphCalc'
import { recordTransform } from './recordTransform'

var ncSettings
var dataForAll
var yunLayoutFirstData
var layoutCount
var roomInfos
var preLayoutData
var layoutPatchData
var surplusRect
var cutDirection
var throughTowSideToCut
var xyReverse
var startPosition
var initialCutDirection
var initialThroughTowSideToCut
var initialXyReverse
var initialStartPosition
var cutKnifeRadius
var plankWidth
var plankHeight
var plankEdgeOff
var layoutGap
let sawGap = 0
var layoutData
var plankSizeList
var layoutMode
var ncSettings = {}
let yCutKnifeRadius = 0 // 这里保存一下全局的锯片刀

export let allSaw = false
export let allNoSaw = false
export let mixedSaw = false

const strentchHingSetList = new Set([
  'STRENTCH',
  'STRENTCHTWO',
  'MIDSTRENTCH',
  'HINGE',
]) // 拉直槽和铰链孔
let specialRuleMap = new Map()
// 特殊孔槽常规孔槽
let specialRuleNormalHoleList = []
let specialRuleNormalSlotList = []
/** 贴着板子，从板件外边下到的槽 */
const specialSymbol = [
  'STRENTCHTWO',
  'MORTISE',
  'CCBTSlot',
  'CCBTSlot2',
  'CCBTSlot2_trape',
]
/** 优先使用指定刀的槽 */
const specialRuleSymbol = ['CCBTSlot2']
const matchNormalSlot = new Map()
const matchNormalHole = new Map()
// 自定义特殊孔槽
const custSpecialSet = new Set([
  'lightSlot',
  'CCPXHole',
  'ALS',
  'straightener_slots_and_hinged_cup_holes',
])
export {
  layoutGap,
  plankEdgeOff,
  cutKnifeRadius,
  startPosition,
  ncSettings,
  specialSymbol,
  specialRuleSymbol,
}

function initProducionLine() {
  var config = ['默认生产线']
  //目前是只有生产线条数line_count大于0，produceLinePermits才有值
  var produceLinePermits = libGG.getGlobalVariable('bought_line_count')
  if (produceLinePermits !== 1) {
    exNcConfig = curTech.techParams.ExNCConfig
    for (var i in exNcConfig) {
      var name = exNcConfig[i].name
      config.push(name)
    }
  }
  productionLineCB.model = config
  productionLineCB.enabled =
    restrictedPopup.boughtLineEnabled() && produceLinePermits !== 1
}

// 拆分封边 ←A↓B→C↑D => left:A bottom:B right:C top:D
export function splitEdgeInfo(edgeInfo) {
  var left = Number(
    edgeInfo.substring(edgeInfo.indexOf('←') + 1, edgeInfo.indexOf('↓'))
  )
  var bottom = Number(
    edgeInfo.substring(edgeInfo.indexOf('↓') + 1, edgeInfo.indexOf('→'))
  )
  var right = Number(
    edgeInfo.substring(edgeInfo.indexOf('→') + 1, edgeInfo.indexOf('↑'))
  )
  var top = Number(edgeInfo.substring(edgeInfo.indexOf('↑') + 1))
  return {
    left: left,
    right: right,
    top: top,
    bottom: bottom,
  }
}

/**
 * 封边展示拼接预铣宽度：仅 appliedSides 对应边数值非 0 时加 (width)；
 * 无 appliedSides 时四边均加（兼容旧数据）。
 * @param {string} edgeInfo ←A↓B→C↑D
 * @param {{ width?: number, appliedSides?: { left?: number, right?: number, top?: number, bottom?: number } }} [edgePreMillingInfo]
 * @returns {string}
 */
export function appendPreMillingToEdgeInfoDisplay(
  edgeInfo,
  edgePreMillingInfo
) {
  if (!edgeInfo || typeof edgeInfo !== 'string') {
    return edgeInfo || ''
  }
  const preWidth = Number(edgePreMillingInfo?.width)
  if (!edgePreMillingInfo || !Number.isFinite(preWidth) || preWidth === 0) {
    return edgeInfo
  }
  const { left, right, top, bottom } = splitEdgeInfo(edgeInfo)
  const applied = edgePreMillingInfo.appliedSides

  function sideSuffix(sideKey) {
    if (!applied) {
      return '(' + preWidth + ')'
    }
    var n = Number(applied[sideKey])
    if (!Number.isFinite(n) || n === 0) {
      return ''
    }
    return '(' + preWidth + ')'
  }

  return (
    '←' +
    left +
    sideSuffix('left') +
    '↓' +
    bottom +
    sideSuffix('bottom') +
    '→' +
    right +
    sideSuffix('right') +
    '↑' +
    top +
    sideSuffix('top')
  )
}

//保留一定位数小数字
export function keepDecimalNumBySetting(ncConfig, num, isExpand, n) {
  if (!n || n !== 0) {
    n = Number(ncConfig.decimal)
    if (typeof n != 'number') {
      n = 2
    }
  }

  var result = parseFloat(num)
  if (typeof num != 'number') {
    return 0
  }

  var a = Math.pow(10, n)
  if (!isExpand) {
    result = Math.round(num * a) / a
  } else {
    result = Math.ceil(num * a) / a
  }

  return result
}

/**
 * @param dataForAll 排版数据
 * @param
 */
//初始化
export async function init(val, data) {
  //收集roomInfo
  fetchLayoutRoomInfos(val)

  layoutCount = dataForAll.length
  // preLayoutData = await startLayoutUseJson(roomInfos);
  preLayoutData = data
  uniquePlankNum(preLayoutData)

  return preLayoutData
}

function getLayoutQueue() {
  if (getCurrentTaskName() !== '批量输出') {
    return
  }
  if (!layoutToolChoose.visible) {
    return
  }

  libGG.layoutIndex = getCurrentTaskIndex()
  curPageIndex = getCurrentTaskIndex()
  if (libGG.dataForAll) {
    dataForAll = dataForAll.concat(libGG.dataForAll)
    libGG.dataForAll = []
  }
}

function initLayoutQueue() {
  if (
    libGG.layoutIndex &&
    libGG.layoutIndex >= 0 &&
    libGG.layoutIndex === curPageIndex
  ) {
    libGG.layoutIndex = -1
    libGG.dataForAll = []
  }
}

function fetchLayoutRoomInfos(val) {
  roomInfos = []
  var layoutQueue = []
  dataForAll = val
  for (var i in dataForAll) {
    var oneProject = dataForAll[i]
    var project = oneProject['projectInfo']
    var roomNames = []
    if (oneProject.hasOwnProperty('roomIds')) {
      var rIds = oneProject['roomIds']
      for (var j in rIds) {
        var rInfo = findRoomInfo(project, rIds[j])
        if (rInfo) {
          rInfo['remark'] = project['remark']
          rInfo['order_code'] = project['order_code']
          rInfo['buyer_address'] = project['buyer_address']
          rInfo['pname'] = project['name']
          rInfo['create_time'] = project['create_time']
          rInfo['customer_name'] = project['customer_name']
          rInfo['oId'] = project['id']

          roomNames.push(rInfo['name'])
          roomInfos.push(rInfo)
        }
      }
    } else {
      for (j in project['room']) {
        rInfo = project['room'][j]
        rInfo['remark'] = project['remark']
        rInfo['order_code'] = project['order_code']
        rInfo['buyer_address'] = project['buyer_address']
        rInfo['pname'] = project['name']
        rInfo['create_time'] = project['create_time']
        rInfo['customer_name'] = project['customer_name']
        rInfo['oId'] = project['id']
        roomNames.push(rInfo['name'])
        roomInfos.push(rInfo)
      }
    }
    layoutQueue.push({
      index: i,
      buyerAddress: project['buyer_address'],
      roomNames: roomNames,
    })
  }
  // taskRep.model = layoutQueue;
  layoutCount = layoutQueue.length
}

function findRoomInfo(pi, rid) {
  var rooms = pi['room']
  for (var i in rooms) {
    if (rid == rooms[i]['id']) {
      return rooms[i]
    }
  }
  return null
}
// complementList为补件信息, 可以从后端获取
function fetchComplementPlankKeys() {
  for (var i in complementList) {
    var tmpMap = complementList[i]
    var texture = tmpMap['texture'].slice(0, 6)
    var matCode = tmpMap['matCode']
    var thick = tmpMap['thick']
    var curKey = texture + ':' + matCode + ':' + thick
    if (plankKeysList.indexOf(curKey) == -1) {
      plankKeysList.push(curKey)
    }
  }
  for (var i in complementOrders) {
    var order = complementOrders[i]
    var plates = order['plates']

    for (var k in plates) {
      var plateInfo = plates[k]['plate_info']
      var size = plateInfo['size']
      var thick = Number(size.split('*')[2])

      var mat = plateInfo['color'] + ':' + plateInfo['matCode'] + ':' + thick
      if (plankKeysList.indexOf(mat) == -1) {
        plankKeysList.push(mat)
      }
    }
  }
}

//设置cutKnifeRadius
function setCutKnifeRadius() {
  var cut = ncSettings['cut']
  var knives = ncSettings['knives']
  var cutKnife = knives[cut['cutKnife']]
  if (cutKnife) {
    if (cutKnife['diameter'] !== '') {
      cutKnifeRadius = parseFloat(cutKnife['diameter']) / 2
    }
  }
}

//获取对穿孔检测
function getIgnoreThroughHole() {
  var ignoreThroughHole = false
  var settingInfo = settingService.getSettingByName('throughHole')
  if (settingInfo !== null && settingInfo !== undefined) {
    var tips = settingInfo['tips']
    if (tips !== null && tips !== undefined) {
      ignoreThroughHole = tips
    }
  }
  return ignoreThroughHole
}

//排版函数调用发送的信号 连接
function signalConnect() {
  timeRecord = getActualTime()
  gg.sLayoutPartial.connect(handleLayoutPartial)
  gg.sLayoutFinished.connect(handleLayoutFinish)
  gg.sLayoutError.connect(handlLayoutError)
  gg.sUpdateProcess.connect(handleUpdateProcess)
  gg.sAddOtherLayoutResult.connect(handleAddOtherLayoutResult)
}

//排版函数调用发送的信号 断开连接
function signalDisconnect() {
  gg.sLayoutPartial.disconnect(handleLayoutPartial)
  gg.sLayoutFinished.disconnect(handleLayoutFinish)
  gg.sLayoutError.disconnect(handlLayoutError)
  gg.sUpdateProcess.disconnect(handleUpdateProcess)
  gg.sAddOtherLayoutResult.disconnect(handleAddOtherLayoutResult)
  progressInfo.close(1)
}

//******************************************* 排版完成 各信号对应函数 **************************************************************
function handleLayoutPartial(oKey, oPriority, oResultMap, mLeftLayout) {
  if (!root || (offlineLayoutError && !isYunLayout)) {
    return
  }
  if (!layoutPlans[oPriority - 1]) {
    layoutPlans[oPriority - 1] = {}
  }
  var afterMap = T.partialProcess(oKey, oResultMap, layoutData)

  if (isYunLayout) {
    T.getYunLayoutPercent(oKey, afterMap, yunResultData)
  }

  layoutPlans[oPriority - 1][oKey] = afterMap

  partialLayoutResultHandle(afterMap, 4)
  progressInfo.updateProgress(1)
  layoutView.repaint()
}

function handleLayoutFinish() {
  if (offlineLayoutError && !isYunLayout) {
    hasFinished = true
    return
  }
  var layoutUseTime = getActualTime()
  var timeCoust = layoutUseTime - timeRecord
  setLayoutUseTime(timeCoust / 1000)

  var l = layoutResult.length
  for (var k in blockedBigPlates) {
    var stock = blockedBigPlates[k]
    k *= 1
    l *= 1
    stock['stockNum'] = k + l
    stock['block'] = true
    var parts = stock['parts']
    for (var j in parts) {
      var part = parts[j]
      part['stockNum'] = k + l
      var realRect = part['realRect']
      var realW = realRect.width
      var realH = realRect.height
      smallPlateArea += realH * realW
    }
    layoutResult.push(stock)
  }

  blockedStockIdx = []
  flushView()

  progressInfo.close(1)

  if (!root) {
    return
  }

  if (layoutMode !== 'complement') {
    ggData = generator(layoutData, 1)
  }

  ifHoleandSlotError(layoutResult)

  for (var i in layoutResult) {
    var stock = layoutResult[i]
    var parts = stock['parts']
    var area = 0
    for (var p in parts) {
      var part = parts[p]
      var pWidth = part['plankWidth']
      var pHeight = part['plankHeight']
      T.rotatePlankWhenSlotAtTheEdge(part, pWidth, pHeight)
    }
  }
  rollCount = T.getRollCount(layoutResult)
  layoutResult = T.sortTheStock(layoutResult)
  for (var i in layoutResult) {
    stock = layoutResult[i]
    if (stock['block']) {
      blockedStockIdx.push(i * 1)
    }
  }

  layoutView.repaint()

  hasFinished = true
  initLayoutQueue()

  //电子开料锯排版排完了 打开对应文件夹
  if (onlyNormalPlate) {
    gg.openLocalPath(chooseElecType.path)
  }
  yunLayoutFirstData = libGG.parseJson(JSON.stringify(layoutView.layoutList))

  //自动保存到本地
  //        (function(){
  //            var  file = gg.getTempRoot() + "layoutLocalSave/layoutPlan/" + getNowDate(true) + ".json";
  //            curlocalLayoutPath = file;

  //            if(!gg.isExistFile(file)) {

  //                var obj = {
  //                    smallPlateArea:smallPlateArea,
  //                    bigPlateArea:bigPlateArea,
  //                    total:total,
  //                    rollCount:rollCount,
  //                    statisticObj:JSON.stringify(statisticObj),
  //                    layoutResult:JSON.stringify(layoutResult),
  //                    timeCoust:s,
  //                    recordDate:getNowDate(false),
  //                    isUploaded:false
  //                }

  //                gg.saveStringToFile(JSON.stringify(obj), file);
  //            }
  //        })()
  loadIndicator1.close()
}

function handlLayoutError(oErrorInfo, oPriority) {
  if (!root) {
    return
  }
  offlineLayoutError = true
  layoutResult = []
  bigPlateArea = 0
  smallPlateArea = 0
  rollCount = 0
  if (!layoutPlans[oPriority - 1]) {
    layoutPlans[oPriority - 1] = {}
  }
  flushView()
  main_msgTips.open(oErrorInfo, 'fail', true)
}

function handleUpdateProcess(oValue, oTotal) {
  if (!root) {
    return
  }
  loadIndicator.updateProgress(oValue / oTotal)
}

function handleAddOtherLayoutResult(oPriority, oResultLst) {
  if (!root) {
    return
  }
  if (!layoutPlans[oPriority - 1]) {
    layoutPlans[oPriority - 1] = {}
  }
  layoutPlans[oPriority - 1] = T.afterProcess(oResultLst, layoutData)

  //        if(oPriority !== 1) {
  //            gg.generateOtherLayoutResult(layoutRectMap, layoutHoleMap,
  //                                         layoutConfig, 1);
  //        }
}

function partialLayoutResultHandle(resultMap, index) {
  var tmp = T.handlePartialResult(resultMap, index % 2)
  var testPath = gg.getTempRoot() + 'yuntest_cut.ini'
  if (isYunLayout) {
    layoutResult = layoutResult.concat(tmp)
  } else {
    for (var i in tmp) {
      var part = tmp[i]
      part['plankWidth'] += (plankEdgeOff - cutKnifeRadius) * 2 - layoutGap
      part['plankHeight'] += (plankEdgeOff - cutKnifeRadius) * 2 - layoutGap
    }

    layoutResult = layoutResult.concat(setCutPriority(tmp))
  }

  blockedStockIdx = []
  flushView()
}

//******************************************* 排版完成 各信号对应函数 以上 **************************************************************

//使用layoutResult生产GGBom
function genGGDataUseLayoutResult(layoutResult) {
  var planks = []

  //搜集小板
  for (var i in layoutResult) {
    //大板
    var bigPlate = layoutResult[i]
    var bParts = bigPlate['parts']
    if (!bParts) {
      continue
    }
    planks = planks.concat(bParts)
  }

  ggData = generator(planks, 1)
}

//设置下刀点
function setCutPriority(data) {
  if (isYunLayout == true) {
    return PYUN.setCutPriority(data)
  }

  if (isTestLayoutPlank == true) {
    return PV3.setCutPriority(data)
  }

  if (priorityVer == '1.0') {
    return P.setCutPriority(data)
  } else if (priorityVer == '2.0') {
    return PV2.setCutPriority(data)
  }
}

//排版调用函数
function loadLayout() {
  // 重置板件的宽高
  plankWidth = store.state.selectStandardPlank.plankWidth
  plankHeight = store.state.selectStandardPlank.plankHeight
  plankEdgeOff = store.state.selectStandardPlank.plankEdgeOff
  layoutGap = store.state.ncSetting.panelSize.layoutGap
  // 门套切割 排版间隙为0
  const isDoorFrame =
    store.state.ncSetting.sawSetting.mentaoji_enable &&
    store.state.ncSetting.sawSetting.processType == 'doorFrame' &&
    isSawPaiban(store)
  if (isDoorFrame) {
    layoutGap = 0
  }
  sawGap = store.state.ncSetting.sawSetting.sawBoardGap
  return {
    layout: layout(),
    userNcPlankInfo: ncSettings,
  }
}

function doYunLayout(type) {
  layoutPlans = []
  layoutResult = []
  bigPlateArea = 0
  smallPlateArea = 0
  rollCount = 0

  var data = layoutWorker(true)
  if (!data) {
    loadIndicator.hide()
    loadIndicator1.close()
    return
  }

  if (!gg.checkSizeLimit(data)) {
    main_msgTips.open('存在过大的板!', 'fail')
    loadIndicator.hide()
    loadIndicator1.close()
    return
  }
  judgeUseSurplus(data['layoutRectMap'], data['layoutConfig'])
  //    startYunLayout(data)
}

function startYunLayout(data) {
  signalDisconnect()
  signalConnect()

  var type = yunLayoutType
  var surplus = surplusList

  //班鲁NC暂不调整下刀点
  // if (initialIsBluenOutput && !initialXyReverse) {
  if (true && !initialXyReverse) {
    data['layoutConfig']['changeKnifePosition'] = false
  }

  //获取工厂单号
  var order_code = []
  var oids = []

  if (layoutMode !== 'complement') {
    for (var i in dataForAll) {
      var tmpId = dataForAll[i]['projectInfo']['id']
      var tmpCode = dataForAll[i]['projectInfo']['order_code']
      if (order_code.indexOf(tmpCode) < 0) {
        order_code.push(tmpCode)
      }
      if (oids.indexOf(tmpId) < 0) {
        oids.push(tmpId)
      }
    }
  } else {
    for (i in complementOrders) {
      tmpId = complementOrders[i]['oid']
      tmpCode = complementOrders[i]['order_code']
      if (order_code.indexOf(tmpCode) < 0) {
        order_code.push(tmpCode)
      }
      if (oids.indexOf(tmpId) < 0) {
        oids.push(tmpId)
      }
    }
    for (i in complementList) {
      tmpCode = complementList[i]['order_code']
      if (order_code.indexOf(tmpCode) < 0) {
        order_code.push(tmpCode)
      }
    }
  }

  //顺带补件的工厂单号
  for (i in layoutPatchData) {
    tmpId = layoutPatchData[i]['oid']
    tmpCode = layoutPatchData[i]['orderNo']
    if (order_code.indexOf(tmpCode) < 0) {
      order_code.push(tmpCode)
    }
    if (tmpId && oids.indexOf(tmpId) < 0) {
      oids.push(tmpId)
    }
  }

  var load = dbProjectObj.yunLayoutNew({
    oids: oids.join(','),
    id: order_code.join(','),
    uid: userService.uid,
    layout_data: data,
    type: type,
    surplus: surplus,
    cutDirection: cutDirection,
  })
  loadIndicator1.start(load, null, 1, plankKeysList.length * 200 + 100)
}

//获取累计排版数量
function statisticsPaiban(day) {
  day = day ? day : 1
  var param = {
    uid: userService.uid,
    recent_day: day,
  }
  globalJSTool.statisticsPaiban(param, function (oData) {
    if (oData.status === 1) {
      secondMenuTab.yunRankCount = oData.data.paiban_count
    }
  })
}

function layoutFromYunToLocal() {
  isYunLayout = false
}

//单个房间排版
function layout() {
  getLayoutData()

  var layoutPlans = []
  var layoutResult = []
  var bigPlateArea = 0
  var smallPlateArea = 0
  var rollCount = 0
  return layoutWorker(true)
  // visible = true;
}

//获取排版使用的数据
function getLayoutData() {
  // 聚类

  const dataGroup = preLayoutData.reduce((pre, cur) => {
    const curPartUniqueId = cur.partUniqueId
    if (pre[curPartUniqueId]) {
      pre[curPartUniqueId].amount = pre[curPartUniqueId].amount + 1
    } else {
      pre[curPartUniqueId] = cur
    }
    return pre
  }, {})

  const val = Object.values(dataGroup)

  layoutData = deepCopy(val)
  layoutData = layoutData.concat(layoutPatchData)
  for (let i = layoutData.length - 1; i >= 0; --i) {
    // 根据数量添加相同参数
    let amount = Number(layoutData[i].amount)
    if (Number(amount) > 1) {
      for (let k = 0; k < amount - 1; ++k) {
        let plank = deepCopy(layoutData[i])
        layoutData.push({
          ...plank,
          labelId: dealNumber(plank['labelIndexRangeArr'][0] + k + 1),
          oriPartUniqueId: plank.partUniqueId,
          partUniqueId: nanoid(),
        })
      }
    }
  }
  layoutData = compositeTexturePlanks(
    layoutData,
    0,
    false,
    false,
    store.state.ncSetting?.decimal ?? 2,
    true
  )
  for (var j in layoutData) {
    autoRollOver(layoutData[j], true)
  }
  layoutData = decompositeTexturePlanks(layoutData)
  // 多个不同材质刀，需要逐步添加
  if (store.state.isSinglePushPrePaibanData) {
    store.commit('setPrePaibanData', [
      ...store.state.prePaibanData,
      ...layoutData,
    ])
  } else {
    store.commit('setPrePaibanData', layoutData)
  }
}

function addedLayout(container) {
  layoutData = container

  layoutPlans = []
  layoutResult = []
  bigPlateArea = 0
  smallPlateArea = 0
  rollCount = 0
  layoutWorker()
  visible = true
}

// plankNum 去重
function uniquePlankNum(parts) {
  const { uniqueBarCode, uniqueBarCodeForPack } = store.state.ncSetting
  const hash = {}
  for (let i = 0; i < parts.length; ++i) {
    const part = parts[i]
    if (!part.oriPlankNum) part.oriPlankNum = ''
    let { _plankNum: oriPlankNum, guid, roomName } = part
    oriPlankNum += ''
    if (!Reflect.has(hash, oriPlankNum)) {
      hash[oriPlankNum] = { guid, roomName, count: 1 } // 记录出现次数
      continue
    } else if (
      hash[oriPlankNum].guid === guid &&
      hash[oriPlankNum].roomName === roomName &&
      !uniqueBarCode &&
      !uniqueBarCodeForPack
    ) {
      // guid roomName相同的板件保证PlankNum相同
      continue
    }
    if (uniqueBarCodeForPack) {
      part.plankNum = `${oriPlankNum}${hash[oriPlankNum].count}`
      part.oriPlankNum = `${oriPlankNum}${hash[oriPlankNum].count}`
      hash[oriPlankNum].count += 1 // 增加计数
    } else {
      const plankNum = createUniquePlankNum.createUniquePlankNum()
      part.plankNum = plankNum
      part.oriPlankNum = plankNum
    }
    // hash[oriPlankNum] = {}
    hash[oriPlankNum] = { guid, roomName, count: hash[oriPlankNum].count } // 更新hash
  }
  createUniquePlankNum.plankNumCollect.clear()
}

export function noRepeatPlankNum(paibanData) {
  const keysArr = Object.keys(paibanData)

  const paibanDataLengthArr = keysArr.map(
    (key) => paibanData[key].data[0].length
  )
  const partsArr = keysArr.map((key) => paibanData[key].data[0]).flat(1)
  uniquePlankNum(partsArr)

  keysArr.forEach((key, index) => {
    const countLength = !index
      ? 0
      : arrItemSum(paibanDataLengthArr.slice(0, index))
    paibanData[key].data[0] = partsArr.slice(
      countLength,
      countLength + paibanDataLengthArr[index]
    )
  })
}

// 数组元素求和
export function arrItemSum(arr) {
  return arr.reduce((a, b) => a + b)
}

//排版保存到本地
function saveLayoutDataToLocalWithNc() {
  var result = getNameList(projectInfo, roomInfos, layoutType)

  var layoutName
  if (result) {
    var projectNameList = result['projectNameList']
    var roomNameList = result['roomNameList']
    var room_id = result['room_id']

    if (room_id) {
      layoutName =
        projectNameList.join('+') +
        '-' +
        roomNameList.join('   ') +
        '-' +
        getNowDate(false)
    } else {
      layoutName =
        projectNameList.join('+') + '-' + '批量生产' + '-' + getNowDate(false)
    }
  }

  var file = gg.getTempRoot() + 'layout/layout.json'
  var obj = {
    smallPlateArea: smallPlateArea,
    bigPlateArea: bigPlateArea,
    total: total,
    rollCount: rollCount,
    statisticObj: JSON.stringify(statisticObj),
    layoutResult: JSON.stringify(layoutResult),
    timeCoust: layoutUseTime,
    recordDate: getNowDate(false),
    isUploaded: false,
    layoutName: layoutName,
    version: gg.getLocalConfig('version'),
    psd: gg.getGlobalProperty('pwdtoWeb'),
    phone: gg.getGlobalProperty('nametoWeb'),
  }

  gg.saveStringToFile(JSON.stringify(obj), file)
}

function judgeNeedRoll(layoutData) {
  if (!store.state.isSurplusNoRoll) return layoutData.needRoll
  let {
    apertureSlotConcentrated,
    holeConcentrated,
    xyReverse,
    highgloss_direction,
  } = store.state.ncSetting
  let isThroughHole = layoutData.holes.some(
    (hole) => hole.deep >= layoutData.thick
  )
  let isThroughSlot = layoutData.slots.some(
    (slot) => slot.deep >= layoutData.thick
  )
  if (layoutData.curveHoles == undefined) layoutData.curveHoles = []
  if (layoutData.millInfo == undefined) layoutData.millInfo = []
  let isThroughcurveHole = layoutData.curveHoles.some(
    (curve) => curve.deep >= layoutData.thick
  )
  let isThroughMill = layoutData.millInfo.some(
    (mill) => (mill.deep ?? mill.depth) >= layoutData.thick
  )
  let slots = layoutData.slots
  let holes = layoutData.holes
  let curveHoles = layoutData.curveHoles ?? []
  let millInfo = layoutData.millInfo ?? []
  let handleSlopes = layoutData.handleSlopes ?? []
  let isOnlyFront =
    slots.every((slot) => slot.side == 1) &&
    holes.every((hole) => hole.side == 1) &&
    curveHoles.every((curve) => curve.side == 1) &&
    millInfo.every((mill) => mill.side == 1)
  // handleSlopes.every((mill) => mill.side == 1)
  let isOnlyback =
    holes.every((hole) => hole.side == -1) &&
    slots.every((slot) => slot.side == -1) &&
    curveHoles.every((curve) => curve.side == -1) &&
    millInfo.every((mill) => mill.side == -1)
  // handleSlopes.every((mill) => mill.side == 1)

  let hasHoleSlot =
    holes.length || slots.length || curveHoles.length || millInfo.length
  // handleSlopes.length
  let ishighGloss = layoutData.is_high_gloss_plank
  let isOnlyThroughSlot =
    !layoutData.holes.length &&
    slots.every((slot) => slot.deep >= layoutData.thick) &&
    millInfo.every((info) => info.deep >= layoutData.thick)
  // handleSlopes.every((slope) => slope.depth >= layoutData.thick) &&
  // 按槽的孔集中面,否则用孔的集中面
  let concentrated = layoutData.slots.length
    ? apertureSlotConcentrated
    : holeConcentrated
  //  打穿孔槽不可用
  if (
    isThroughHole ||
    isThroughSlot ||
    (ishighGloss && isThroughcurveHole && isThroughMill)
  )
    return true
  // 无孔无槽可用
  if (!hasHoleSlot) return false
  if (!xyReverse) {
    if (ishighGloss) {
      if (isOnlyThroughSlot) return false
      if (highgloss_direction == 'front') return isOnlyFront ? false : true
      return isOnlyFront ? false : true
    }
    if (concentrated == 'back' && !isOnlyFront) return true
    if (!isOnlyFront) return true
  } else {
    if (ishighGloss) {
      if (isOnlyThroughSlot) return false
      if (highgloss_direction == 'front') return isOnlyback ? false : true
      return isOnlyback ? false : true
    }
    if (store.state.isSurplusNoRoll) {
      let {
        apertureSlotConcentrated,
        holeConcentrated,
        xyReverse,
        highgloss_direction,
      } = store.state.ncSetting
      let isThroughHole = layoutData.holes.some(
        (hole) => hole.deep >= layoutData.thick
      )
      let isThroughSlot =
        slots.some((slot) => slot.deep >= layoutData.thick) ||
        millInfo.some((info) => info.deep >= layoutData.thick)
      // handleSlopes.some((slope) => slope.deep >= layoutData.thick) ||
      let isOnlyFront =
        slots.every((slot) => slot.side == 1) &&
        holes.every((hole) => hole.side == 1) &&
        curveHoles.every((curve) => curve.side == 1) &&
        millInfo.every((mill) => mill.side == 1)
      // handleSlopes.every((slope) => slope.side == 1)
      let isOnlyback =
        holes.every((hole) => hole.side == -1) &&
        slots.every((slot) => slot.side == -1) &&
        curveHoles.every((curve) => curve.side == -1) &&
        millInfo.every((mill) => mill.side == -1)
      // handleSlopes.every((slope) => slope.side == -1)
      let hasHoleSlot =
        holes.length || slots.length || curveHoles.length || millInfo.length
      // handleSlopes.length
      let ishighGloss = layoutData.is_high_gloss_plank
      let isOnlyThroughSlot =
        !holes.length &&
        slots.every((slot) => slot.deep >= layoutData.thick) &&
        millInfo.every((mill) => mill.depth >= layoutData.thick)
      // handleSlopes.every((slope) => slope.depth >= layoutData.thick) &&
      // 按槽的孔集中面,否则用孔的集中面
      let concentrated = layoutData.slots.length
        ? apertureSlotConcentrated
        : holeConcentrated
      //  打穿孔槽不可用
      if (isThroughHole || (ishighGloss && isThroughSlot)) return true
      // 无孔无槽可用
      if (!hasHoleSlot) return false
      if (!xyReverse) {
        if (ishighGloss) {
          if (isOnlyThroughSlot) return false
          if (highgloss_direction == 'front') return isOnlyFront ? false : true
          return isOnlyFront ? false : true
        }
        if (concentrated == 'back' && !isOnlyFront) return true
        if (!isOnlyFront) return true
      } else {
        if (ishighGloss) {
          if (isOnlyThroughSlot) return false
          if (highgloss_direction == 'front') return isOnlyback ? false : true
          return isOnlyback ? false : true
        }
        if (concentrated == 'front' && isOnlyFront) return true
        if (!isOnlyback) return true
      }
      if (concentrated == 'front' && isOnlyFront) return true
      if (!isOnlyback) return true
    }
    return false
  }
}
// 确保路径闭合
function ensureClosed(path) {
  if (path.length < 3) return path
  const first = path[0],
    last = path[path.length - 1]
  if (first.x !== last.x || first.y !== last.y) {
    return [...path, { x: first.x, y: first.y }]
  }
  return path
}
/**
 * 将槽数据合并到path中
 * 骨骼线槽需求 需要将异形上所有的槽合并到path里，然后传给排版接口（柜柜那边支持槽画到板件外面，我们这边异形嵌套的时候需要预留出槽的位置防止切到其他板）
 * @param {Array} paths
 * @param {Array} slots
 */
export function dealUnionPathSlots(paths, slots, ncSetting) {
  let copyPaths = JSON.parse(JSON.stringify(paths))
  const { decimal } = ncSetting
  // 缩放因子
  const scale = 1000
  // 创建clipper对象
  const clipper = new window.ClipperLib.Clipper()
  // 保留共线顶点
  clipper.PreserveCollinear = true
  // 将paths路径添加进clipper 只需要外部轮廓
  // ptSubject表示‌主体路径‌，即需要被裁剪或执行布尔运算的主要多边形。在运算中作为基准几何对象存在
  clipper.AddPath(
    ensureClosed(copyPaths[0]).map((p) => ({
      X: toDecimal(p.x, decimal) * scale,
      Y: toDecimal(p.y, decimal) * scale,
    })),
    window.ClipperLib.PolyType.ptSubject,
    true
  )
  const precision = 0.0001
  // 生成槽完整的矩形路径
  slots.forEach((slot) => {
    let { pt1, pt2 } = slot
    let slotPath = []
    // 横槽
    if (Math.abs(pt1.y - pt2.y) <= precision) {
      slotPath = [
        {
          X: toDecimal(slot.pt1.x, decimal) * scale,
          Y: toDecimal(slot.pt1.y - slot.width / 2, decimal) * scale,
        },
        {
          X: toDecimal(slot.pt2.x, decimal) * scale,
          Y: toDecimal(slot.pt1.y - slot.width / 2, decimal) * scale,
        },
        {
          X: toDecimal(slot.pt2.x, decimal) * scale,
          Y: toDecimal(slot.pt1.y + slot.width / 2, decimal) * scale,
        },
        {
          X: toDecimal(slot.pt1.x, decimal) * scale,
          Y: toDecimal(slot.pt1.y + slot.width / 2, decimal) * scale,
        },
        {
          X: toDecimal(slot.pt1.x, decimal) * scale,
          Y: toDecimal(slot.pt1.y - slot.width / 2, decimal) * scale,
        },
      ]
    }
    // 竖槽
    if (Math.abs(pt1.x - pt2.x) <= precision) {
      slotPath = [
        {
          X: toDecimal(slot.pt1.x - slot.width / 2, decimal) * scale,
          Y: toDecimal(slot.pt1.y, decimal) * scale,
        },
        {
          X: toDecimal(slot.pt1.x - slot.width / 2, decimal) * scale,
          Y: toDecimal(slot.pt2.y, decimal) * scale,
        },
        {
          X: toDecimal(slot.pt1.x + slot.width / 2, decimal) * scale,
          Y: toDecimal(slot.pt2.y, decimal) * scale,
        },
        {
          X: toDecimal(slot.pt1.x + slot.width / 2, decimal) * scale,
          Y: toDecimal(slot.pt1.y, decimal) * scale,
        },
        {
          X: toDecimal(slot.pt1.x - slot.width / 2, decimal) * scale,
          Y: toDecimal(slot.pt1.y, decimal) * scale,
        },
      ]
    }
    // 将槽路径添加到 clipper中
    // ptClip 表示‌裁剪路径‌，用于修改主体路径的辅助多边形。在布尔操作中扮演工具角色，例如在差集运算中会切除与主体路径重叠的部分
    clipper.AddPath(slotPath, window.ClipperLib.PolyType.ptClip, true)
  })
  // 定义合并结果
  let unionResult = new window.ClipperLib.Paths()
  // 执行合并 ctUnion表示并集
  const success = clipper.Execute(
    window.ClipperLib.ClipType.ctUnion,
    unionResult,
    window.ClipperLib.PolyFillType.pftEvenOdd,
    window.ClipperLib.PolyFillType.pftEvenOdd
  )
  // 为true 代表合并成功
  if (success) {
    // 结果大于1 表示不是单一路径 然后再次执行SimplifyPolygons合并相邻区域
    if (unionResult.length > 1) {
      window.ClipperLib.Clipper.SimplifyPolygons(
        unionResult,
        window.ClipperLib.PolyFillType.pftEvenOdd
      )
    }
    copyPaths[0] = ensureClosed(
      unionResult[0].map((p) => ({ x: p.X / scale, y: p.Y / scale }))
    )
  }
  return copyPaths
}
export function dealPlankExpandKnife(part, ncSetting, noPath, layoutData) {
  // 无 path 或仅一段外轮廓时无需把多段 path 拆进 curveHoles
  if (part['path']?.length > 1) {
    part['path'].forEach((val, index) => {
      if (index) {
        part['curveHoles'].push({
          path: val,
          native_path: val,
          deep: part.thick,
          side: 1,
          through: true,
        })
      }
    })
    part['path'] = part['path'].slice(0, 1)
  }
  const prePaibanData = store.state.prePaibanData
  ncSetting = ncSetting ?? store.state.ncSetting

  const sawToLayout =
    ncSetting.sawSetting.mentaoji_enable &&
    ncSetting.sawSetting.sawToLayout &&
    ncSetting.sawSetting.processType === 'weldingPlank' &&
    isSawPaiban(store)

  // 刀半径 是否需要在此处使用多材质下料刀 需要排查全部逻辑后更改
  // let cutKnifeRadius = 0
  const layoutGap = ncSetting.panelSize.layoutGap ?? 0.1

  if (ncSetting.knife.diameter && ncSetting.knife.diameter != '') {
    cutKnifeRadius = Number(ncSetting.knife.diameter) / 2
    if (ncSetting.cuttingEquipment === 'glassEquip') {
      cutKnifeRadius = 0
    }
  }
  cutKnifeRadius = part.isUseSaw ? getSawKnife(ncSetting) / 2 : cutKnifeRadius
  // 待排版库也会走这里，这个时候的layoutData却又是undefined的，不懂
  allSaw = layoutData?.every((part) => part.isUseSaw)
  allNoSaw = layoutData?.every((part) => !part.isUseSaw)
  mixedSaw = !allSaw && !allNoSaw

  // 暂且保留，后续上线后可删除
  // // 处理超长门板扩刀逻辑
  // let {
  //   longPlankMinLength: longSide,
  //   longPlankShortMinLength: shortSide,
  //   longPlankExpandedSize: lpes,
  //   longPlankShortExpandedSize: lpses,
  //   longPlankCuttingEnable,
  //   desMaterialList,
  //   desMaterialSwitch,
  //   curveSecondCutEnable,
  //   cutSingleDoor,
  //   cutGeneralPlank,
  //   generalPlankThick,
  //   specified_board_secondary_cutting,
  //   secondary_cutting_board_list,
  //   single_door_thick,
  // } = ncSetting.longPlankCuttingSetting
  // let longPlankExpandedSize = Number(lpes)
  // let longPlankShortExpandedSize = Number(lpses)
  // const rectWH = [part.rect.width, part.rect.height]
  // const partLongSide = Math.max(...Object.values(rectWH))
  // const partShortSide = Math.min(...Object.values(rectWH))

  // // 指定材质的超长板件才能扩版！不满足的不能扩版
  // let longPlankIsExpose = longPlankCuttingEnable
  // // 对异形板件 若 curveSecondCutEnable (异形二次切割未生效） 则不扩板
  // const isShape = part?.path && Array.isArray(part.path) && part.path.length
  // // 板件名称 (指定板件名称二次切割开关开启后，小板名称包含指定的板件名称则生效二次切割)
  // const partName = part.partName || part.name || ''
  // if (longPlankCuttingEnable && isShape && !curveSecondCutEnable) {
  //   longPlankIsExpose = false
  // }
  // // 如果打开按材质扩版 并且 选择了指定材质 则 继续下面的判断 只有满足指定材质的的才扩(不考虑是否高光)
  // else if (
  //   longPlankCuttingEnable &&
  //   desMaterialList?.length &&
  //   desMaterialSwitch
  // ) {
  //   longPlankIsExpose = desMaterialList.some((item) => {
  //     const temp_matCode = part.matCode.replace(/高光_/g, '')
  //     return temp_matCode === item
  //   })
  // }

  // if (
  //   !(longPlankIsExpose && partLongSide > longSide && partShortSide > shortSide)
  // ) {
  //   longPlankExpandedSize = 0
  //   longPlankShortExpandedSize = 0
  // }
  // // todo
  // if (
  //   cutSingleDoor &&
  //   part.type === 'SingleDoor' &&
  //   part.thick >= Number(single_door_thick)
  // ) {
  //   666 // 门板板件扩张
  // } else if (
  //   (part.type !== 'SingleDoor' &&
  //     cutGeneralPlank &&
  //     part.thick >= generalPlankThick) ||
  //   (specified_board_secondary_cutting &&
  //     secondary_cutting_board_list.some((item) => partName.includes(item)))
  // ) {
  //   666 // 常规板板件扩张
  // } else {
  //   longPlankExpandedSize = 0
  //   longPlankShortExpandedSize = 0
  // }
  let longPlankExpandedSize = 0
  let longPlankShortExpandedSize = 0
  const { longPlankMinLength: longSide, longPlankShortMinLength: shortSide } =
    ncSetting.longPlankCuttingSetting
  const rectWH = [part.rect.width, part.rect.height]
  if (isLongPlateProcessing(part, ncSetting)) {
    longPlankExpandedSize = Number(
      ncSetting.longPlankCuttingSetting.longPlankExpandedSize
    )
    longPlankShortExpandedSize = Number(
      ncSetting.longPlankCuttingSetting.longPlankShortExpandedSize
    )
  }

  let expandedX, expandedY
  // 判断赋予x和y长边放量还是短边放量
  if (rectWH[0] > rectWH[1]) {
    expandedX = longPlankExpandedSize
    expandedY = longPlankShortExpandedSize
  } else if (rectWH[0] < rectWH[1]) {
    expandedX = longPlankShortExpandedSize
    expandedY = longPlankExpandedSize
  } else {
    // 宽高相等进行判断
    if (rectWH[0] > longSide) {
      expandedX = longPlankExpandedSize
      expandedY = longPlankExpandedSize
    } else if (rectWH[0] > shortSide) {
      expandedX = longPlankShortExpandedSize
      expandedY = longPlankShortExpandedSize
    } else {
      expandedX = 0
      expandedY = 0
    }
  }
  if (!part.plankNum) {
    if (part.oriPlankNum) {
      part.plankNum = part.oriPlankNum
    } else {
      // 生成oriPlankNum
      const date = new Date()
      const time = date.getTime()
      const plankNum = ('' + time).slice(-12)
      const strArr = plankNum.split('')
      let num1 = 0
      let num2 = 0
      for (let i = 0; i < strArr.length; ++i) {
        if (i == 0) {
          if (strArr[i] == '0') {
            strArr[i] = Math.floor(Math.random() * 9 + 1)
          }
        }
        if ((i + 1) % 2) {
          num2 += Number(strArr[i])
        } else {
          num1 += Number(strArr[i])
        }
      }
      let finalNum = (10 - ((num1 * 3 + num2) % 10)) % 10
      strArr.push(finalNum)
      part.plankNum = strArr.join('')
      part.oriPlankNum = strArr.join('')
    }
  }
  // 记录原始路径尺寸，需要和扩张后的路径进行对比得到孔槽的偏移量，只考虑异型只有异型会存在问题（默认是矩形板件）,且只考虑扩展后minx，miny
  let oriPathSize = [0, 0]
  // 记录当前路径尺寸，也就是扩张后的尺寸
  let cutPathSize = []
  if (part.rect) {
    var minX = 0,
      minY = 0,
      maxX = part.rect.width,
      maxY = part.rect.height
    function expandPolygon(iPoly, offset) {
      var out = []
      var dpList = [],
        ndpList = []
      var count = iPoly.length

      if (
        Math.abs(iPoly[0]['x'] - iPoly[count - 1]['x']) < 0.0001 &&
        Math.abs(iPoly[0]['y'] === iPoly[count - 1]['y'])
      ) {
        --count
        if (iPoly[0]['b']) iPoly.pop()
        else iPoly.splice(0, 1)
      }

      function dot(fPoint, sPoint) {
        return fPoint.x * sPoint.x + fPoint.y * sPoint.y
      }
      function cross(fPoint, sPoint) {
        return fPoint.x * sPoint.y - fPoint.y * sPoint.x
      }
      function subtraction(fPoint, sPoint) {
        // return Qt.point(fPoint.x-sPoint.x, fPoint.y-sPoint.y)
        return {
          x: fPoint.x - sPoint.x,
          y: fPoint.y - sPoint.y,
        }
      }
      function addition(fPoint, sPoint) {
        // return Qt.point(fPoint.x+sPoint.x, fPoint.y+sPoint.y)
        return {
          x: fPoint.x + sPoint.x,
          y: fPoint.y + sPoint.y,
        }
      }
      function multiplication(point, num) {
        // return Qt.point(point.x*num, point.y*num)
        return {
          x: point.x * num,
          y: point.y * num,
        }
      }
      function segmentsIntr(a, b, c, d) {
        var nx1 = b.y - a.y,
          ny1 = a.x - b.x
        var nx2 = d.y - c.y,
          ny2 = c.x - d.x
        var denominator = nx1 * ny2 - ny1 * nx2
        if (denominator == 0) {
          return false
        }

        var distC_N2 = nx2 * c.x + ny2 * c.y
        var distA_N2 = nx2 * a.x + ny2 * a.y - distC_N2
        var distB_N2 = nx2 * b.x + ny2 * b.y - distC_N2

        if (distA_N2 * distB_N2 >= 0) {
          return false
        }
        var distA_N1 = nx1 * a.x + ny1 * a.y
        var distC_N1 = nx1 * c.x + ny1 * c.y - distA_N1
        var distD_N1 = nx1 * d.x + ny1 * d.y - distA_N1
        if (distC_N1 * distD_N1 >= 0) {
          return false
        }

        //计算交点坐标
        var fraction = distA_N2 / denominator
        var dx = fraction * ny1,
          dy = -fraction * nx1
        var res = { x: a.x + dx, y: a.y + dy }

        return res
      }

      for (var i = 0; i < count; i++) {
        var next = i === count - 1 ? 0 : i + 1
        // var curPoint = Qt.point(iPoly[i]["x"], iPoly[i]["y"]);
        var curPoint = {
          x: iPoly[i]['x'],
          y: iPoly[i]['y'],
        }
        // var nextPoint =  Qt.point(iPoly[next]["x"], iPoly[next]["y"]);
        var nextPoint = {
          x: iPoly[next]['x'],
          y: iPoly[next]['y'],
        }
        dpList.push(subtraction(nextPoint, curPoint))
        var unitLen = 1.0 / Math.sqrt(dot(dpList[i], dpList[i]))
        unitLen = isNaN(0 * unitLen) ? 0 : unitLen
        ndpList.push(multiplication(dpList[i], unitLen))
      }

      var lastXOffset = 0
      var lastYOffset = 0
      for (i = 0; i < count; i++) {
        var startIndex = i === 0 ? count - 1 : i - 1
        var endIndex = i
        var sinTheta = cross(ndpList[startIndex], ndpList[endIndex])
        var orientVector = subtraction(ndpList[endIndex], ndpList[startIndex]) //i.e. PV2-V1P=PV2+PV1
        var temp_out = {}

        // sinTheta = jjFixed2(sinTheta)
        sinTheta = Number(sinTheta.toFixed(2))
        if (sinTheta !== 0) {
          lastXOffset = (offset / sinTheta) * orientVector.x
          lastYOffset = (offset / sinTheta) * orientVector.y
          if (Math.abs(lastYOffset) > Math.abs(offset)) {
            lastYOffset =
              Math.abs(offset) * (lastYOffset / Math.abs(lastYOffset))
          }
          if (Math.abs(lastXOffset) > Math.abs(offset)) {
            lastXOffset =
              Math.abs(offset) * (lastXOffset / Math.abs(lastXOffset))
          }

          iPoly[i]['x'] = iPoly[i]['x'] + lastXOffset
          iPoly[i]['y'] = iPoly[i]['y'] + lastYOffset
        } else {
          iPoly[i]['x'] = iPoly[i]['x'] + lastXOffset
          iPoly[i]['y'] = iPoly[i]['y'] + lastYOffset
        }
      }

      for (i = 0; i < count && count >= 4; i++) {
        var startIndexA = i === 0 ? count - 1 : i - 1
        var endIndexA = i

        var startIndexB = i === count - 1 ? 0 : i + 1
        var endIndexB = i === count - 1 ? 1 : i === count - 2 ? 0 : i + 2

        var res = segmentsIntr(
          iPoly[startIndexA],
          iPoly[endIndexA],
          iPoly[startIndexB],
          iPoly[endIndexB]
        )
        if (res) {
          iPoly[endIndexA]['x'] = res.x
          iPoly[endIndexA]['y'] = res.y
          iPoly.splice(startIndexB, 1)
          --i
          --count
        }
      }
      var minX = 999999
      var minY = 999999

      for (i in iPoly) {
        var py = iPoly[i]
        minX = Math.min(minX, py['x'])
        minY = Math.min(minY, py['y'])
      }
      return [minX, minY]
    }
    if (part['cutCurve'] && part['cutCurve'].length) {
      var cutCurve = part['cutCurve']
      var cutCurveEx = part['cutCurveEx']
      var minValue = expandPolygon(cutCurve, cutKnifeRadius)
      for (var ci in cutCurve) {
        cutCurve[ci]['x'] -= minValue[0]
        cutCurve[ci]['y'] -= minValue[1]
      }
      for (var ei in cutCurveEx) {
        cutCurve = cutCurveEx[ei]
        expandPolygon(cutCurve, -cutKnifeRadius)
        for (ci in cutCurve) {
          cutCurve[ci]['x'] -= minValue[0]
          cutCurve[ci]['y'] -= minValue[1]
        }
      }
    }
    // 处理玻璃切割机补偿设置
    const { cuttingEquipment, glass_setting } = ncSetting
    let contour_size_recoup = glass_setting && glass_setting.contour_size_recoup
    if (cuttingEquipment !== 'glassEquip' || !contour_size_recoup) {
      contour_size_recoup = 0
    }
    if (!part.hasOwnProperty('path')) {
      maxX = part.rect.width + expandedX * 2 + contour_size_recoup * 2
      maxY = part.rect.height + expandedY * 2 + contour_size_recoup * 2
      // for(let i = 0; i < part.holes.length; ++i){
      //   let hole = part.holes[i]
      //   hole.center.x += longPlankExpandedSize
      //   hole.center.y += longPlankExpandedSize
      // }
      // for(let i = 0; i < part.slots.length; ++i){
      //   let slot = part.slots[i]
      //   slot.pt1.x += longPlankExpandedSize
      //   slot.pt1.y += longPlankExpandedSize
      //   slot.pt2.x += longPlankExpandedSize
      //   slot.pt2.y += longPlankExpandedSize
      // }
    } else {
      // 异形统一使用长边放量
      expandedX = longPlankExpandedSize
      expandedY = longPlankExpandedSize
      let paths = JSON.parse(JSON.stringify(part.path))

      let len = paths.length
      // 如果存在异形孔则将孔位随着其他异形一起处理,后单独取出来
      if (part['curveHoles']) {
        part['curveHoles'].forEach((k) => {
          k['native_path'] = JSON.parse(JSON.stringify(k['path']))
          // 牛角槽，不算作一个内部异形且在柜门数据传输过来就已扩刀，不需要在进行内缩扩张
          if (k.knifeName) return
          paths.push(k['path'])
        })
      }
      for (let i in paths) {
        for (let j in paths[i]) {
          paths[i][j].X = paths[i][j].x
          paths[i][j].Y = paths[i][j].y
        }
      }
      let resArr = []

      // 判断是否使用锯片刀进行扩张
      // 条件1：启用了锯片排版（sawToLayout）
      // 条件2：板件边缘不包含顶边和底边（避免上下两边都用锯片刀的情况）
      const isUseSawKnifeExpand =
        sawToLayout &&
        !(part.pathEdge?.includes('top') && part.pathEdge?.includes('bottom'))

      const sawKnifeR = getSawKnife(ncSetting) / 2

      // 特殊扩张距离 刀半径 + 长板放量 + 玻璃切割机放量
      const specialExpandDistance =
        (part?.isUseSaw ? Number(sawKnifeR) : Number(cutKnifeRadius)) +
        Number(longPlankExpandedSize) +
        Number(contour_size_recoup)
      // 是否开启内异形自动选刀
      const isInnerShapeAutoSelectKnife =
        store.state.preferencesSetting.setting.inner_shape_tool_match

      const isLaser = ncSetting.laser_enable || false

      // 获取所有非牛角槽的内部异形（用于判断打穿）
      const internalCurveHoles =
        part['curveHoles']?.filter((k) => !k.knifeName) || []

      // 旧逻辑
      // paths.forEach((val, index) => {
      //   debugger
      //   // 外轮廓(小板轮廓)为扩张，正的刀半径 / 内轮廓(内部异形)为内缩,负的刀半径
      //   // cutKnifeRadius 在这之前会因为板件是否使用锯片刀而改变，而内部异性只能用下料刀
      //   const cutKnifeR = Number(ncSetting.knife.diameter) / 2
      //   const offset = !index ? specialExpandDistance : -cutKnifeR
      //   // 扩张路径
      //   const result = expandPath(offset, val)
      //   // 取最后结果中面积最大的一个数组作为板件的path
      //   const resultAreas = result.map((arr) =>
      //     Math.abs(window.ClipperLib.Clipper.Area(arr))
      //   )
      //   const maxIndex = resultAreas.indexOf(Math.max(...resultAreas))
      //   // 增加空数组默认值，避免当异形被缩没以后，同时是高光板，高光板排在正面时， 使用curveholes中的path报错
      //   resArr.push(result[maxIndex] ?? [])
      //   // 如果没有开启异形自动选刀，并且这个异形被缩没了，则收集这个板件,用于提示用户
      //   if (!isInnerShapeAutoSelectKnife && !result[maxIndex]) {
      //     store.commit('setErrorPathPlankID', part.plankID)
      //   }
      // })

      paths.forEach((val, index) => {
        // 外轮廓(小板轮廓)为扩张，正的刀半径 / 内轮廓(内部异形)为内缩,负的刀半径
        // cutKnifeRadius 在这之前会因为板件是否使用锯片刀而改变，而内部异性只能用下料刀
        let offset = specialExpandDistance
        // const  cutKnifeR = Number(ncSetting.knife.diameter) / 2
        // let offset = !index ? specialExpandDistance : -cutKnifeR
        // 判断是否是内部异形（index >= len 表示是内部异形）
        // const isInternalShape = index >= len
        const isInternalShape = Boolean(index)
        if (isInternalShape) {
          // 找到对应的 curveHole（内部异形在 paths 中的索引对应 curveHoles 中的索引）
          // const curveHoleIndex = index - len
          const curveHoleIndex = index - 1
          const curveHole = internalCurveHoles[curveHoleIndex]
          if (curveHole) {
            // 判断是否打穿：深度 >= 板厚 - 0.01
            const deep = curveHole.deep ?? curveHole.depth
            const isThroughInternalShape = Number(deep) + 0.01 >= part.thick
            if (isLaser) {
              // 开启激光一体机 不需要考虑多材质
              // 如果是打穿的内部异形，使用激光刀
              if (isThroughInternalShape) {
                // 打穿的内部异形使用激光刀，使用激光刀的半径进行内缩
                // 因为正反面刀库激光刀刀径必定是一致的 所以这样处理也无所谓
                const laserKnife =
                  curveHole.side === 1
                    ? Object.values(ncSetting.knives || {}).find(
                        (k) => k.type === 'laser'
                      )
                    : Object.values(ncSetting.back_knives || {}).find(
                        (k) => k.type === 'laser'
                      )
                if (laserKnife && laserKnife.diameter) {
                  const laserKnifeR = Number(laserKnife.diameter) / 2
                  offset = -laserKnifeR
                } else {
                  console.error('找不到激光刀', curveHole)
                }
              } else {
                // 未打穿的内部异形 使用下料刀（需要内缩）
                // 因为正反面刀库下料刀刀径必定是一致的 所以这样处理也无所谓
                const knife =
                  curveHole.side === 1
                    ? Object.values(ncSetting.knives || {}).find(
                        (k) => k.cutable === true
                      )
                    : Object.values(ncSetting.back_knives || {}).find(
                        (k) => k.cutable === true
                      )
                if (knife && knife.diameter) {
                  offset = -Number(knife.diameter) / 2
                  // 内部异形未打穿 记录下料刀刀径
                  curveHole.diameter = -offset * 2
                } else {
                  console.log('找不到下料刀', curveHole)
                }
              }
            } else {
              // 未开启激光一体机
              // 判断是否需要获取多材质不同下料刀刀径
              const plate_knife_map = ncSetting.plate_knife_map ?? {}
              const hasPlateKnifeMap = Object.keys(plate_knife_map).length > 0

              if (hasPlateKnifeMap) {
                // 开启了多材质下料刀，使用 getPlateKnifeDiameter 获取对应材质的刀径
                const stockKey = `${part.texture}:${part.matCode}:${part.thick}`
                const knifeDiameter = getPlateKnifeDiameter(stockKey, ncSetting)
                if (knifeDiameter) {
                  const cutKnifeR = Number(knifeDiameter) / 2
                  offset = -cutKnifeR
                } else {
                  // 如果获取不到刀径，使用默认刀径
                  offset = -Number(ncSetting.knife.diameter) / 2
                }
              } else {
                // 没有开启多材质下料刀，使用默认刀径
                offset = -Number(ncSetting.knife.diameter) / 2
              }
            }
          }
        }

        // 扩张路径
        const result = expandPath(offset, val)
        // 取最后结果中面积最大的一个数组作为板件的path
        const resultAreas = result.map((arr) =>
          Math.abs(window.ClipperLib.Clipper.Area(arr))
        )
        const maxIndex = resultAreas.indexOf(Math.max(...resultAreas))
        // 增加空数组默认值，避免当异形被缩没以后，同时是高光板，高光板排在正面时， 使用curveholes中的path报错
        resArr.push(result[maxIndex] ?? [])
        // 如果没有开启异形自动选刀，并且这个异形被缩没了，则收集这个板件,用于提示用户
        if (!isInnerShapeAutoSelectKnife && !result[maxIndex]) {
          store.commit('setErrorPathPlankID', part.plankID)
        }
      })
      // 记录小板轮廓最小的x和y
      ;[minX, minY, maxX, maxY] = getPathMinMaxPoint(resArr[0])
      // 原始的小板轮廓最小的x
      // 扩展后的大小
      cutPathSize = getPathMinMaxPoint(resArr[0])
      // [锯切异形] 测量绿路径(resArr[0]) 相对 srcPath(part.path[0]，此处尚未被覆盖) 外接矩形在各方向的扩张量
      // 用于后续 paibanDataToView 修正 startX/startY 为绿框左上角；必须在 afterExpendPathOffset 归一化前测量
      if (part.isUseSaw && part.path && part.path[0] && part.path[0].length) {
        const srcMM = getPathMinMaxPoint(part.path[0])
        part.__sawExtension = {
          left: srcMM[0] - minX,
          top: srcMM[1] - minY,
          right: maxX - srcMM[2],
          bottom: maxY - srcMM[3],
        }
      }
      resArr.forEach((path) => {
        afterExpendPathOffset(path, minX, minY, part)
      })
      // 对原始内部异形路径做偏移（为了后端在缩刀之后可以得到和前端处理异形的路径相同）
      part['curveHoles']?.forEach((curveHole) => {
        const { native_path } = curveHole
        afterExpendPathOffset(native_path, minX, minY, part)
      })
      // 记录异型路径的原始大小
      oriPathSize = getPathMinMaxPoint(part.path[0])
      // 将异形长圆孔和板件异形分离
      part.path = resArr.slice(0, len)

      if (part['curveHoles']) {
        let curArr = resArr.slice(len)
        const specialCurveHoles = []
        const curveHoles = []
        // 区分特殊长圆孔(牛角槽)
        part['curveHoles'].forEach((item) => {
          if (item.knifeName) {
            specialCurveHoles.push(item)
          } else {
            curveHoles.push(item)
          }
        })
        curveHoles.forEach((item, idx) => {
          if (item.path) {
            let o = curArr[idx]
            item['path'] = o
          }
        })
        // 特殊长圆孔(牛角槽)由于板件扩张Y轴需要位移两个扩张距离
        specialCurveHoles.forEach((item) => {
          // 如牛角槽在板件右侧则需要将X轴也进行偏移
          const isOffsetX = item.path.some((it) => it.x >= part.oRect.width)
          // 如牛角槽在板件下侧则需要将Y轴也进行偏移
          const isOffsetY = item.path.some((it) => it.y >= part.oRect.height)
          item.path = item.path.map((it) => {
            it.y += longPlankExpandedSize
            it.x += longPlankExpandedSize
            if (isOffsetX) {
              it.x += Math.abs(cutKnifeRadius) * 2
            }
            if (isOffsetY) {
              it.y += Math.abs(cutKnifeRadius) * 2
            }
            return it
          })
          return
        })
      }
    }
  }
  var rectWid = maxX - minX
  var rectHei = maxY - minY
  if (part.hasOwnProperty('path')) {
    var lx = 0,
      ly = 0,
      sx = 10000,
      sy = 10000
    var nPath = []
    var p = {}
    if (part.path.length > 0) {
      p = part.path[0]
    }

    for (var k in p) {
      var pt = JSON.parse(JSON.stringify(p[k]))
      var x = pt.x,
        y = pt.y
      if (x > lx) {
        lx = x
      }
      if (y > ly) {
        ly = y
      }
      if (x < sx) {
        sx = x
      }
      if (y < sy) {
        sy = y
      }
    }
    for (var m in p) {
      var t = JSON.parse(JSON.stringify(p[m]))

      var o = {
        x: t.x - sx,
        y: t.y - sy,
      }

      var pointm = JSON.parse(JSON.stringify(o))
      nPath.push(pointm)
    }
    part.path[0] = nPath
  }
  //对拉直器样式2的板子进行扩张

  /** 是否生产线是预排版 */
  const isPreLayout = ncSetting.isPreLayout
  // 所有刀
  const allKnifes = isPreLayout
    ? null
    : store.state.ncSetting && store.state.ncSetting.knives
  // 指定刀直径
  let selectKnifeDiameter = isPreLayout ? cutKnifeRadius * 2 : 0
  // 拉直器
  const symbol = [
    'STRENTCHTWO',
    'MORTISE',
    'CCBTSlot',
    'noSymbol',
    'lightSlot',
    'normalSlot',
    'gratingSlot',
    'BP',
    'CCSlot',
    'exSlot',
  ]
  const finalExtendDisMap = dealExpandSlot(part, ncSetting, cutKnifeRadius)
  part.finalExtendDisMap = finalExtendDisMap
  const extendW = finalExtendDisMap
    ? Number(finalExtendDisMap.left) + Number(finalExtendDisMap.right)
    : 0
  const extendH = finalExtendDisMap
    ? Number(finalExtendDisMap.top) + Number(finalExtendDisMap.bottom)
    : 0

  if (part.rect) {
    if (part.hasOwnProperty('path')) {
      part.rect = {
        x: part.rect.x,
        y: part.rect.y,
        width: rectWid,
        height: rectHei,
      }

      if (extendW || extendH) {
        // 用于排版的扩张板件
        part.expandRect = {
          x: part.rect.x,
          y: part.rect.y,
          width: rectWid + extendW,
          height: rectHei + extendH,
        }
      }
    } else {
      /**
       * 解释：
       * 为什么此处还在加上刀径，因为槽的扩刀是考虑是否需要扩，内部减去刀径也是为了计算否都需要这一段距离
       * 如果距离小于下料损耗则是不需要扩张的，此处加上的刀径是其原本应该下料的损耗，槽扩刀逻辑返回值里面是将这块损耗减去的
       */
      const offsetX = 2 * cutKnifeRadius + extendW
      const offsetY = 2 * cutKnifeRadius + extendH
      // 获取到矩形最终扩张的大小，用二次切割和其他条件扩大后的大小减去当前大小，最后加上刀径等扩张大小的值减半则能得到minx miny
      cutPathSize = [
        (rectWid - part.rect.width + 2 * cutKnifeRadius) / 2,
        (rectHei - part.rect.height + 2 * cutKnifeRadius) / 2,
      ]
      part.rect = {
        x: part.rect.x,
        y: part.rect.y,
        width: rectWid + 2 * cutKnifeRadius,
        height: rectHei + 2 * cutKnifeRadius,
      }
      if (extendW || extendH) {
        part.expandRect = {
          x: part.rect.x,
          y: part.rect.y,
          width: rectWid + offsetX,
          height: rectHei + offsetY,
        }
      }
      prePaibanData.forEach((p) => {
        if (p.partUniqueId == part.partUniqueId) {
          p.expandRect = part.expandRect
        }
      })
    }
  }
  store.commit('setPrePaibanData', prePaibanData)

  function test(arr) {
    var maxx = -10000,
      maxy = -10000,
      minx = 10000,
      miny = 10000
    for (var k in arr[0]) {
      //
      var pt = arr[0][k]

      if (pt.x > maxx) {
        maxx = pt.x
      }
      if (pt.y > maxy) {
        maxy = pt.y
      }
      if (pt.x < minx) {
        minx = pt.x
      }
      if (pt.y < miny) {
        miny = pt.y
      }
    }
    for (var k in arr) {
      for (var j in arr[k]) {
        arr[k][j].x -= minx
        arr[k][j].y -= miny
      }
    }
    return {
      maxx: maxx,
      minx: minx,
      maxy: maxy,
      miny: miny,
    }
  }
  var dx = 0
  var dy = 0
  var dx2 = part.oRect.width
  var dy2 = part.oRect.height
  if (part.hasOwnProperty('path')) {
    var res = test(part.oPath)
    dx = -res.minx
    dy = -res.miny
    dx2 = res.maxx
    dy2 = res.maxy
    //
  } else {
    if (part['oRect']) {
      if (!part['fullSize']) {
        part['fullSize'] = {
          width: 0,
          height: 0,
        }
      }
      part['fullSize']['width'] = part['oRect'].width
      part['fullSize']['height'] = part['oRect'].height
    }
  }
  for (let i = 0; i < part.sslots.length; i++) {
    const sslot = part.sslots[i]
    if (['TENON', 'CCTENON', 'CCDTENON'].includes(sslot.symbol)) {
      dx = 0
      dy = 0
      break
    }
  }
  // 最终使用的孔槽偏移X
  const finalOffsetX = Math.abs(cutPathSize[0]) - oriPathSize[0]
  // 最终使用的孔槽偏移Y
  const finalOffsetY = Math.abs(cutPathSize[1]) - oriPathSize[1]

  if (part.lineSlots) {
    part.lineSlots.forEach((slot) => {
      slot.path = slot.path.map((p) => {
        return {
          ...p,
          x: p.x + finalOffsetX,
          y: p.y + finalOffsetY,
        }
      })
    })
  }
  part.holes.forEach(function (hole) {
    if (hole.holeType && hole.holeType === 'exHole') {
      //该孔与异形路径绑定，不需要再根据异形路径做平移
      hole.center = {
        x: hole.center.x + finalOffsetX,
        y: hole.center.y + finalOffsetY,
      }
      hole.ocenter = {
        x: hole.ocenter.x + dx,
        y: hole.ocenter.y + dy,
      }
    } else {
      hole.center = {
        x: hole.center.x + finalOffsetX,
        y: hole.center.y + finalOffsetY,
      }
    }
  })
  part.slots.forEach(function (slot) {
    if (slot.slotType && slot.slotType === 'exSlot') {
      slot.pt1 = {
        x: slot.pt1.x + finalOffsetX,
        y: slot.pt1.y + finalOffsetY,
      }
      slot.pt2 = {
        x: slot.pt2.x + finalOffsetX,
        y: slot.pt2.y + finalOffsetY,
      }
    } else {
      slot.pt1 = {
        x: slot.pt1.x + finalOffsetX,
        y: slot.pt1.y + finalOffsetY,
      }
      slot.pt2 = {
        x: slot.pt2.x + finalOffsetX,
        y: slot.pt2.y + finalOffsetY,
      }
    }

    slot.opt1 = {
      x: slot.opt1.x + dx,
      y: slot.opt1.y + dy,
    }
    slot.opt2 = {
      x: slot.opt2.x + dx,
      y: slot.opt2.y + dy,
    }

    part.rect.left = part.rect.x
    part.rect.right = part.rect.x + part.rect.width
    part.rect.top = part.rect.y
    part.rect.bottom = part.rect.height

    // 避免拉槽伤到其他板
    if (slot.pt1.x < part.rect.left) slot.pt1.x = part.rect.left
    if (slot.pt2.x < part.rect.left) slot.pt2.x = part.rect.left

    if (slot.pt1.y < part.rect.top) slot.pt1.y = part.rect.top
    if (slot.pt2.y < part.rect.top) slot.pt2.y = part.rect.top

    if (slot.pt1.x > part.rect.right) slot.pt1.x = part.rect.right
    if (slot.pt2.x > part.rect.right) slot.pt2.x = part.rect.right

    if (slot.pt1.y > part.rect.bottom) slot.pt1.y = part.rect.bottom
    if (slot.pt2.y > part.rect.bottom) slot.pt2.y = part.rect.bottom
  })
  // 斜封边拉手
  part.handleSlopes &&
    part.handleSlopes.forEach(function (slot) {
      if (slot.slotType && slot.slotType === 'exSlot') {
        slot.pt1 = {
          x: slot.pt1.x + cutKnifeRadius + expandedX,
          y: slot.pt1.y + cutKnifeRadius + expandedY,
        }
        slot.pt2 = {
          x: slot.pt2.x + cutKnifeRadius + expandedX,
          y: slot.pt2.y + cutKnifeRadius + expandedY,
        }
      } else {
        slot.pt1 = {
          x: slot.pt1.x + finalOffsetX,
          y: slot.pt1.y + finalOffsetY,
        }
        slot.pt2 = {
          x: slot.pt2.x + finalOffsetX,
          y: slot.pt2.y + finalOffsetY,
        }
      }

      slot.opt1 = {
        x: slot.opt1.x + dx,
        y: slot.opt1.y + dy,
      }
      slot.opt2 = {
        x: slot.opt2.x + dx,
        y: slot.opt2.y + dy,
      }

      part.rect.left = part.rect.x
      part.rect.right = part.rect.x + part.rect.width
      part.rect.top = part.rect.y
      part.rect.bottom = part.rect.height

      // 避免拉槽伤到其他板
      if (slot.pt1.x < part.rect.left) slot.pt1.x = part.rect.left
      if (slot.pt2.x < part.rect.left) slot.pt2.x = part.rect.left

      if (slot.pt1.y < part.rect.top) slot.pt1.y = part.rect.top
      if (slot.pt2.y < part.rect.top) slot.pt2.y = part.rect.top

      if (slot.pt1.x > part.rect.right) slot.pt1.x = part.rect.right
      if (slot.pt2.x > part.rect.right) slot.pt2.x = part.rect.right

      if (slot.pt1.y > part.rect.bottom) slot.pt1.y = part.rect.bottom
      if (slot.pt2.y > part.rect.bottom) slot.pt2.y = part.rect.bottom
    })

  var oldSize = part.oRect
  if (part.path) {
    oldSize = part.oldSize
  }

  if (part.sholes) {
    part.sholes.forEach(function (shole) {
      if (shole.side * 1 === 2) {
        var tmpValue = -(oldSize.width - dx2)
        shole.center = {
          x: shole.center.x + tmpValue,
          y: shole.center.y,
          z: shole.center.z,
        }
      } else if (shole.side * 1 === 1) {
        tmpValue = -(oldSize.height - dy2)
        shole.center = {
          x: shole.center.x + tmpValue,
          y: shole.center.y,
          z: shole.center.z,
        }
      } else if (shole.side * 1 === 3) {
        shole.center = {
          x: shole.center.x + dy,
          y: shole.center.y,
          z: shole.center.z,
        }
      } else {
        shole.center = {
          x: shole.center.x + dx,
          y: shole.center.y,
          z: shole.center.z,
        }
      }
      shole.ocenter = {
        x: shole.ocenter.x + dx,
        y: shole.ocenter.y + dy,
        z: shole.ocenter.z,
      }
    })
  }

  if (part.sslots) {
    part.sslots.forEach(function (sslot) {
      if (sslot.side * 1 === 2) {
        var tmpValue = -(oldSize.width - dx2)
        sslot.pt1 = {
          x: sslot.pt1.x + tmpValue,
          y: sslot.pt1.y,
          z: sslot.pt1.z,
        }
        sslot.pt2 = {
          x: sslot.pt2.x + tmpValue,
          y: sslot.pt2.y,
          z: sslot.pt2.z,
        }
      } else if (sslot.side * 1 === 1) {
        tmpValue = -(oldSize.height - dy2)
        sslot.pt1 = {
          x: sslot.pt1.x + tmpValue,
          y: sslot.pt1.y,
          z: sslot.pt1.z,
        }
        sslot.pt2 = {
          x: sslot.pt2.x + tmpValue,
          y: sslot.pt2.y,
          z: sslot.pt2.z,
        }
      } else if (sslot.side * 1 === 3) {
        sslot.pt1 = {
          x: sslot.pt1.x + dy,
          y: sslot.pt1.y,
          z: sslot.pt1.z,
        }
        sslot.pt2 = {
          x: sslot.pt2.x + dy,
          y: sslot.pt2.y,
          z: sslot.pt2.z,
        }
      } else {
        sslot.pt1 = {
          x: sslot.pt1.x + dx,
          y: sslot.pt1.y,
          z: sslot.pt1.z,
        }
        sslot.pt2 = {
          x: sslot.pt2.x + dx,
          y: sslot.pt2.y,
          z: sslot.pt2.z,
        }
      }

      sslot.opt1 = {
        x: sslot.opt1.x + dx,
        y: sslot.opt1.y + dy,
      }
      sslot.opt2 = {
        x: sslot.opt2.x + dx,
        y: sslot.opt2.y + dy,
      }
    })
  }
}

/** 是否使用了锯切排版，包括了少翻板中的锯切 */
export const isSawPaiban = (store) => {
  return (
    ['paiban', 'paiban_roll'].filter((way) =>
      store.state.activePaibanWay.includes(way)
    ).length > 0
  )
}

/** 获取锯切刀 */
export function getSawKnife(ncSetting) {
  const { sawSetting } = ncSetting
  let finalSawKnife = 0
  const sawKnives = sawSetting.mentaoji_saws
  if (sawKnives) {
    const hSawKnives = sawKnives
      .filter((item) => item.saw_direction == 'H')
      .map((item) => item.saw_width)
    finalSawKnife = Number(Math.min(...hSawKnives)) || 0
  } else {
    // 预排版里面的 横切刀直径
    finalSawKnife = Number(ncSetting.sawSetting?.horizontalWidth) || 0
  }
  return finalSawKnife
}

/** 获取当前排版板件涉及的所有下料刀直径（含多材质下料刀） */
export function getCutKnifeDiameterList(ncSetting, layoutData = []) {
  const diameterSet = new Set()

  if (layoutData?.length) {
    const stockKeySet = new Set()
    layoutData.forEach((part) => {
      const stockKey = `${part.texture}:${part.matCode}:${part.thick}`
      stockKeySet.add(stockKey)
    })
    stockKeySet.forEach((stockKey) => {
      const knifeDiameter = Number(getPlateKnifeDiameter(stockKey, ncSetting))
      if (knifeDiameter) {
        diameterSet.add(knifeDiameter)
      }
    })
  } else {
    const defaultDiameter = Number(ncSetting.knife?.diameter)
    if (defaultDiameter) {
      diameterSet.add(defaultDiameter)
    }
  }

  return [...diameterSet].filter((diameter) => diameter > 0)
}

/**
 * 旋转 前封边、原边
 * 1、启用锯切
 * 2、启用锯片厚度排版
 * 3、勾选已封好不再切的大板边 要把前封边旋转到所选不再切的大板边  新增会把原边旋转到所选不再切的大板边
 * @param {*} layoutData
 */
export function rotateFrontEdge(layoutData) {
  // 映射封边信息和位置关系
  const dirDataMap = {
    '←': 'left',
    '↓': 'bottom',
    '→': 'right',
    '↑': 'top',
  }
  const dirArr = ['top', 'right', 'bottom', 'left']
  if (
    store.state.ncSetting.sawSetting.mentaoji_enable &&
    store.state.ncSetting.sawSetting.sawToLayout &&
    store.state.ncSetting.sawSetting.processType === 'weldingPlank' &&
    store.state.ncSetting.sawSetting.edgeNoSaw &&
    isSawPaiban(store)
  ) {
    layoutData.forEach((part) => {
      // 这里将原边进行旋转
      if (part.smoothEdge) {
        const rotateDir = dirArr.indexOf(
          store.state.ncSetting.sawSetting.edgeNoSawSide
        )
        const smoothEdge = dirArr.indexOf(part.smoothEdge)
        part.isRotateFrontEdge = true
        let deg
        if (rotateDir - smoothEdge == 1 || rotateDir - smoothEdge == -3) {
          deg = 90
        } else if (Math.abs(rotateDir - smoothEdge) == 2) {
          deg = 180
        } else if (
          rotateDir - smoothEdge == 3 ||
          rotateDir - smoothEdge == -1
        ) {
          deg = 270
        }
        switch (deg) {
          case 180:
            rotate180Part(part, 'rotateFrontEdge')
            break
          case 270:
            rotatePart(
              rotate180Part(part, 'rotateFrontEdge'),
              'rotateFrontEdge'
            )
            break
          case 90:
            rotatePart(part, 'rotateFrontEdge')
            break
          default:
            break
        }
      } else if (part.model_front_edge) {
        const frontEdge = dirArr.indexOf(dirDataMap[part.model_front_edge])
        const rotateDir = dirArr.indexOf(
          store.state.ncSetting.sawSetting.edgeNoSawSide
        )
        part.isRotateFrontEdge = true
        let deg
        if (rotateDir - frontEdge == 1 || rotateDir - frontEdge == -3) {
          deg = 90
        } else if (Math.abs(rotateDir - frontEdge) == 2) {
          deg = 180
        } else if (rotateDir - frontEdge == 3 || rotateDir - frontEdge == -1) {
          deg = 270
        }
        // 无纹理板才进行90,270旋转，其它纹理只进行180旋转
        switch (deg) {
          case 180:
            part = rotate180Part(part, 'rotateFrontEdge')
            break
          case 270:
            if (part.texDir == 'notcare') {
              part = rotatePart(
                rotate180Part(part, 'rotateFrontEdge'),
                'rotateFrontEdge'
              )
            }
            break
          case 90:
            if (part.texDir == 'notcare') {
              part = rotatePart(part, 'rotateFrontEdge')
            }
            break
          default:
            break
        }
      }
    })
  }
}

/**
 * 小板旋转后，将小板的path的坐标以(0,0)为中心
 * @param {*} part
 */
function recoverPath(part) {
  for (let i = 0; i < part?.path?.length; i++) {
    for (let j = 0; j < part.path[i].length; j++) {
      part.path[i][j].x =
        part.path[i][j].x + (0 - Math.min(...part.path[i].map((it) => it.x)))
      part.path[i][j].y =
        part.path[i][j].y + (0 - Math.min(...part.path[i].map((it) => it.y)))
    }
  }
}

/**
 * 判断是否是合并后的骨骼门板件
 * @param {*} part 板件数据
 * @returns 是否是合并后的骨骼门板件
 */
export function judgeIsMergeFrameDoor(part) {
  return (
    part?.frame_door &&
    Array.isArray(part?.frame_door_children) &&
    part?.frame_door_children?.length === 5
  )
}

/**
 * 骨骼门拼接处理
 * 骨骼门是由一个基板和4个小条子组成，开料清单是5个单板，需合成一个板件进行排版
 * 有frame_door字段就代表是骨骼门，当有5个相同的值时，代表是一组骨骼门，可进行拼接（若没有5个相同的值，则不进行拼接）
 * 拼接板件的宽高为：基板宽度 + 小条子宽度（小条子的宽度应该是相同的） * 2 + 刀径 * 2
 * @param {*} data 板件数据
 * @param {*} diameter 刀径
 * @returns 拼接后的板件数据
 */
export function dealFrameDoorSplice(data, diameter) {
  const getPartAmount = (part) => {
    const amount = Number(part?.amount)
    return Number.isFinite(amount) && amount > 0 ? amount : 1
  }
  const frameDoorPartMap = new Map()

  data.forEach((part) => {
    const hasFrameDoor =
      part &&
      Object.prototype.hasOwnProperty.call(part, 'frame_door') &&
      part.frame_door !== undefined &&
      part.frame_door !== null &&
      part.frame_door !== ''

    if (!hasFrameDoor) return

    const frameDoorKey = part.frame_door
    if (!frameDoorPartMap.has(frameDoorKey)) {
      frameDoorPartMap.set(frameDoorKey, [])
    }
    frameDoorPartMap.get(frameDoorKey).push(part)
  })
  const frameDoorMergedPartMap = new Map()
  frameDoorPartMap.forEach((framePartList) => {
    const mergedPartList = []
    const canMergeCount = Math.floor(framePartList.length / 5)

    for (let i = 0; i < canMergeCount; i++) {
      const children = framePartList.slice(i * 5, i * 5 + 5)
      // 基板
      const basePart = children.find((part) => part.plankType === 'SingleDoor')
      if (!basePart) continue
      // 小条子有横条、竖条，横条 specWidth 为长边不能当条宽；需使用竖条（成品高大于宽）算条宽
      const stripParts = children.filter(
        (part) => part.plankType !== 'SingleDoor'
      )
      if (!stripParts.length) {
        mergedPartList.push(...children)
        continue
      }
      // 合并数量取基板与四条小条数量的最小值
      const minStripAmount = Math.min(
        ...stripParts.map((part) => getPartAmount(part))
      )
      const mergeAmount = Math.min(getPartAmount(basePart), minStripAmount)
      if (mergeAmount <= 0) {
        mergedPartList.push(...children)
        continue
      }
      const isVerticalFrameStrip = (part) =>
        Number(part.specHeight) > Number(part.specWidth)
      let notBasePart = stripParts.find(isVerticalFrameStrip) || stripParts[0]
      // 合并板件真实的 rect宽高
      const realWidth =
        basePart.rect.width + notBasePart.rect.width * 2 + diameter * 2
      const realHeight =
        basePart.rect.height + notBasePart.rect.width * 2 + diameter * 2

      const baseRect = basePart.rect
      const notBaseWidth = notBasePart.rect.width
      // 构造线槽数据（模拟骨骼门路径）
      // 中间的矩形线槽
      const rectLinePath = [
        { x: notBaseWidth, y: notBaseWidth },
        { x: notBaseWidth + baseRect.width, y: notBaseWidth },
        { x: notBaseWidth + baseRect.width, y: notBaseWidth + baseRect.height },
        { x: notBaseWidth, y: notBaseWidth + baseRect.height },
        { x: notBaseWidth, y: notBaseWidth },
      ]
      // 左上线槽
      const lTLinePath = [
        { x: 0, y: 0 },
        { x: notBaseWidth, y: notBaseWidth },
      ]
      // 右上线槽
      const rTLinePath = [
        { x: notBaseWidth + baseRect.width, y: notBaseWidth },
        { x: realWidth, y: 0 },
      ]
      // 左下线槽
      const lBLinePath = [
        { x: notBaseWidth, y: notBaseWidth + baseRect.height },
        { x: 0, y: realHeight },
      ]
      // 右下线槽
      const rBLinePath = [
        { x: notBaseWidth + baseRect.width, y: notBaseWidth + baseRect.height },
        { x: realWidth, y: realHeight },
      ]

      // 构造合并板件数据
      const mergedPart = {
        ...basePart,
        // 合并板生成新的唯一id （不生成新的在修改基板数量进行合并后会聚类成同一条数据）
        partUniqueId: nanoid(),
        oriPartUniqueId: basePart.partUniqueId || basePart.oriPartUniqueId,
        amount: mergeAmount,
        specWidth:
          basePart.specWidth + notBasePart.specWidth * 2 + diameter * 2,
        specHeight:
          basePart.specHeight + notBasePart.specWidth * 2 + diameter * 2,
        fullSize: {
          width:
            basePart.fullSize.width +
            notBasePart.fullSize.width * 2 +
            diameter * 2,
          height:
            basePart.fullSize.height +
            notBasePart.fullSize.width * 2 +
            diameter * 2,
        },
        oRect: {
          x: 0,
          y: 0,
          width:
            basePart.rect.width +
            (notBasePart.rect.width + basePart.leftEdge) * 2 +
            diameter * 2,
          height:
            basePart.rect.height +
            (notBasePart.rect.width + basePart.leftEdge) * 2 +
            diameter * 2,
        },
        oldSize: {
          width:
            basePart.oldSize.width +
            notBasePart.oldSize.width * 2 +
            diameter * 2,
          height:
            basePart.oldSize.height +
            notBasePart.oldSize.width * 2 +
            diameter * 2,
        },
        realRect: {
          x: 0,
          y: 0,
          width: realWidth,
          height: realHeight,
        },
        rect: {
          x: 0,
          y: 0,
          width: realWidth,
          height: realHeight,
        },
        holes: [],
        slots: [],
        sholes: [],
        sslots: [],
        lineSlots: [
          {
            deep: 5,
            depth: 5,
            side: 1,
            symbol: 'lineSlot',
            uniqueId: nanoid(),
            path: rectLinePath,
            oPath: rectLinePath,
            oriPath: rectLinePath,
            shape: rectLinePath,
          },
          {
            deep: 5,
            depth: 5,
            side: 1,
            symbol: 'lineSlot',
            uniqueId: nanoid(),
            path: lTLinePath,
            oPath: lTLinePath,
            oriPath: lTLinePath,
            shape: lTLinePath,
          },
          {
            deep: 5,
            depth: 5,
            side: 1,
            symbol: 'lineSlot',
            uniqueId: nanoid(),
            path: rTLinePath,
            oPath: rTLinePath,
            oriPath: rTLinePath,
            shape: rTLinePath,
          },
          {
            deep: 5,
            depth: 5,
            side: 1,
            symbol: 'lineSlot',
            uniqueId: nanoid(),
            path: lBLinePath,
            oPath: lBLinePath,
            oriPath: lBLinePath,
            shape: lBLinePath,
          },
          {
            deep: 5,
            depth: 5,
            side: 1,
            symbol: 'lineSlot',
            uniqueId: nanoid(),
            path: rBLinePath,
            oPath: rBLinePath,
            oriPath: rBLinePath,
            shape: rBLinePath,
          },
        ],
      }
      // 需保留原始的板件数据
      mergedPart.frame_door_children = deepCopy(children)
      // 合并骨骼门无纹理时也不允许排版旋转
      mergedPart.matRotatable = false
      mergedPartList.push(mergedPart)
      // 回退未参与合并的余量 且清除骨骼门标识
      children.forEach((part) => {
        const remainAmount = getPartAmount(part) - mergeAmount
        if (remainAmount > 0) {
          mergedPartList.push({
            ...part,
            amount: remainAmount,
            frame_door: undefined,
            frame_door_children: undefined,
          })
        }
      })
    }

    const remainStartIndex = canMergeCount * 5
    if (remainStartIndex < framePartList.length) {
      mergedPartList.push(...framePartList.slice(remainStartIndex))
    }

    // 将拼接后的板件数据存储到map中，key为骨骼门key，value为拼接后的板件数据列表
    const frameDoorKey = framePartList?.[0]?.frame_door
    frameDoorMergedPartMap.set(frameDoorKey, mergedPartList)
  })

  const result = []
  const emittedFrameDoorSet = new Set()
  data.forEach((part) => {
    const hasFrameDoor =
      part &&
      Object.prototype.hasOwnProperty.call(part, 'frame_door') &&
      part.frame_door !== undefined &&
      part.frame_door !== null &&
      part.frame_door !== ''

    if (!hasFrameDoor) {
      result.push(part)
      return
    }

    const frameDoorKey = part.frame_door
    if (emittedFrameDoorSet.has(frameDoorKey)) return

    emittedFrameDoorSet.add(frameDoorKey)
    result.push(...(frameDoorMergedPartMap.get(frameDoorKey) || []))
  })
  return result
}

function layoutWorker(isYunLayout, passLayout) {
  var offlineLayoutError = false
  uniquePlankNum(layoutData)
  var result = checkBackPlank(layoutData)
  if (result.length > 0) {
    // main_msgTips.open(gg.getTrans("房间数据错误，请重新保存房间，避免生产损失" + "\n" + JSON.stringify(result)), "fail");
    return null
  }

  plankSizeList = []

  //过滤掉非异形的板件
  // if (onlyNormalPlate) {
  // layoutData = filtrationNomalPlank(layoutData);
  // }

  // 找到 width 最大的板件并标记
  const maxWidth = Math.max(...layoutData.map((part) => part.rect.width))
  layoutData.forEach((part) => {
    part.isMaxWidth = part.rect.width === maxWidth // 标记最大宽度的板件
  })

  if (!store.state.ncSetting.isPreLayout) {
    const isNoKnifeToProcessList = layoutData.map((part) => {
      return part.slots.map((slot) => {
        const knife = slot.knifeName
        if (knife) {
          const k = ncSettings.knives[knife]
          if (!k || !k.diameter || k.diameter < 0) {
            return knife
          } else return false
        } else {
          return false
        }
      })
    })

    const knifeList = Array.from(
      new Set(isNoKnifeToProcessList.flat(Infinity).filter((k) => k))
    )

    if (knifeList.length && false) {
      return {
        isErr: true,
        errMsg: translateLang(
          '缺失槽指定加工刀具，请检查生产线设置！【{msg}】',
          {
            msg: knifeList.join('、'),
          }
        ),
      }
    }
  }

  // 扩张
  store.commit('clearErrorPathPlankID')
  let samePartArr = []
  const noPath = layoutData.every((part) => !part.hasOwnProperty('path'))
  // 焊接板中是否有异形
  const noPathForWelPlank = layoutData
    .filter((part) => part.isWeldingPlank || part.matCode === '焊接板')
    .every((part) => !part.hasOwnProperty('path'))
  /** 是否有错误的内部路径 */
  let hasErrPathList = []
  // 旋转前封边
  rotateFrontEdge(layoutData)
  const ncSetting = store.state.ncSetting
  const sawKnives = ncSetting.sawSetting?.mentaoji_saws
  const sawCutOnlyWeld =
    ncSetting.sawSetting.sawCutOnlyWeld &&
    ncSetting.sawSetting.processType === 'weldingPlank'
  const sawToLayout =
    ncSetting.sawSetting.mentaoji_enable &&
    ncSetting.sawSetting.sawToLayout &&
    ncSetting.sawSetting.processType === 'weldingPlank' &&
    isSawPaiban(store)

  // 门套切割 下料刀半径（不能）>锯片厚度 且不支持异形排版
  const isDoorFrame =
    ncSetting.sawSetting.mentaoji_enable &&
    ncSetting.sawSetting.processType === 'doorFrame' &&
    isSawPaiban(store)
  if (isDoorFrame) {
    const sawKnife = getSawKnife(ncSetting)
    const knifeDiameters = getCutKnifeDiameterList(ncSetting, layoutData)
    const hasKnifeRadiusGT = knifeDiameters.some(
      (diameter) => diameter / 2 > sawKnife
    )
    if (hasKnifeRadiusGT) {
      return {
        isDoorFrameErr: true,
        errMsg: translateLang(
          '您已开启“锯切雕刻机-门套切割”功能，下料刀半径大于了锯片厚度，无法进行排版！'
        ),
      }
    }
    if (!noPath) {
      return {
        isDoorFrameErr: true,
        errMsg: translateLang(
          '您已开启“锯切雕刻机-门套切割”功能，该功能暂不支持异形板件排版！'
        ),
      }
    }
  }

  layoutData.forEach((part) => {
    part.isUseSaw = false
    // 使用锯切刀逻辑
    /**
     * 1、启用锯切雕刻机
     * 2、启用锯片厚度排版 或 门套切割(锯切 加工工艺勾选门套)
     * 3、锯片刀库至少存在一条不为空的横切刀
     * 4、下料刀半 <= 横切刀直径
     * 5、所有小板中没有异形板
     */
    // 添加一个字段代表是否使用锯切刀
    if (
      (sawToLayout || isDoorFrame) &&
      ((sawKnives &&
        sawKnives.some(
          (item) => item.saw_direction == 'H' && item.saw_width
        )) ||
        ncSetting.sawSetting?.horizontalWidth)
    ) {
      yCutKnifeRadius = getSawKnife(ncSetting)
      if (sawCutOnlyWeld) {
        part.isUseSaw = true
        // 锯切排版只排焊接板 这里其他材质小板，就不能使用电子锯了
        if (!isWeldingPart(part)) {
          part.isUseSaw = false
        }
      } else {
        part.isUseSaw = true
      }
    }
  })

  layoutData.forEach(async function (part) {
    // 这里是因为旋转前封边后，矩形小板的path会变成undefined,而矩形小板就不应该存在path
    if (part && part.path === undefined) {
      delete part.path
    }
    // 这里将layoutData传入，是为了在dealPlankExpandKnife中判断是否需要使用锯片刀,但是这里会每次遍历，都会在遍历的过程中再便利一次layoutData
    await dealPlankExpandKnife(
      part,
      ncSettings ?? store.state.ncSetting,
      noPath,
      layoutData
    )
    if (part.curveHoles) {
      const hasErrPath = part.curveHoles.some(
        (hole) => !window.ClipperLib.JS.AreaOfPolygon(hole.path)
      )
      if (hasErrPath) {
        hasErrPathList.push(part.plankID)
      }
    }
    if (part.ggid && part.amount > 1) {
      samePartArr.push(part.ggid)
    }
  })
  if (hasErrPathList.length) {
    return {
      isErr: true,
      errMsg: '内部异形数据错误,请检查是否符合刀具规格!',
      hasErrPathList,
    }
  }
  // 旋转前封边
  rotateFrontEdge(layoutData)
  samePartArr = Array.from(new Set(samePartArr))
  // 板件多套（开料清单数量大于1）的情况下，ggid添加两位序号
  for (let i in samePartArr) {
    let count = 0
    for (let j in layoutData) {
      if (samePartArr[i] === layoutData[j].ggid) {
        if (layoutData[j].ggid) {
          layoutData[j].ggid += `0${ggidEncodeList()[count % 92]}`
          count += 1
        }
      }
    }
  }

  // 提取矩形数据
  var rectMap = {}

  // 锯切刀
  const sawKnifeR = getSawKnife(ncSettings)
  // 下料刀
  const diameter = Number(ncSettings.knife.diameter) / 2
  const isSurNotLayoutMat =
    store.state.preferencesSetting?.setting?.isSurNotLayoutMat
  const isSurNotLayout = store.state.preferencesSetting?.setting?.isSurNotLayout
  const plankNames = store.state.preferencesSetting?.setting?.plankNames
  const realSurNotLayout = isSurNotLayout && isSurNotLayoutMat
  const getKey = (plank) => {
    var thick = plank.thick
    var texture = plank.texture
    var matCode = plank.matCode
    const isHighPlank = plank.is_high_gloss_plank
    matCode = isHighPlank
      ? !matCode.includes('高光_')
        ? '高光_' + matCode
        : matCode
      : matCode
    let key = texture + ':' + matCode + ':' + thick
    if (plank.brandName && plank.supplierName) {
      key += ':' + plank.brandName + ':' + plank.supplierName
    }
    return key
  }
  /** @description 生成排版单个小板的矩形信息 */
  const genRectMapInfo = (plank, key, options = {}) => {
    // 区分内外异性和外部异性增加异形边的描述
    exterPathEdgeForPart(plank)
    var rect = plank.expandRect ?? plank.rect
    const realRect = plank.realRect
    if (!rect) {
      return
    }
    if (!rectMap.hasOwnProperty(key)) {
      rectMap[key] = []
    }

    if (
      store.state.ncSetting.highgloss_direction == 'front' &&
      plank.is_high_gloss_plank &&
      // 虚拟板翻面子板随之翻面，所以单独的子板不再处理
      !isTextureAlignmentPlank(plank)
    ) {
      if (store.state.ncSetting.high_gloss_plank_no_rotate) {
        reversalPlank(plank)
      } else {
        rolloverPlank(plank)
      }
    }
    dealSideForThroughHoleAndSlot(plank, store.state.ncSetting)
    forEachTextureChild(plank, (child) =>
      dealSideForThroughHoleAndSlot(child, store.state.ncSetting)
    )
    plank.needRoll = judgeNeedRoll(plank)
    var needRoll = plank.needRoll
    var rectInfo = {}
    const { usedArea } = caclPartArea(plank)
    rectInfo['usedArea'] = usedArea
    // 用的哪一把刀，锯切还是下料刀
    const useKnife = plank['isUseSaw'] ? sawKnifeR : diameter * 2
    // 宽度上用 realRect，高度上rect-r
    if (
      sawToLayout &&
      ((sawCutOnlyWeld && plank.isWeldingPlank) || !sawCutOnlyWeld)
    ) {
      // 槽扩的值
      const finalExtendDisMap = plank['finalExtendDisMap'] ?? {
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
      }

      const expandHeight = finalExtendDisMap.top + finalExtendDisMap.bottom
      const expandWidth = finalExtendDisMap.left + finalExtendDisMap.right
      rectInfo['rect'] = {
        x1: rect.x,
        y1: rect.y,
        x2: realRect.width + expandWidth,
        y2: realRect.height + expandHeight,
      }
    } else {
      rectInfo['rect'] = {
        x1: rect.x,
        y1: rect.y,
        x2: rect.width,
        y2: rect.height,
      }
    }
    rectInfo['isWeldingPlank'] = plank['isWeldingPlank']
    rectInfo['pathEdge'] = plank['pathEdge']
    rectInfo['needRoll'] = needRoll
    const isRotateForSmooth =
      plank?.smoothEdge &&
      store.state.ncSetting.sawSetting.mentaoji_enable &&
      store.state.ncSetting.sawSetting.sawToLayout &&
      store.state.ncSetting.sawSetting.processType === 'weldingPlank' &&
      store.state.ncSetting.sawSetting.edgeNoSaw &&
      isSawPaiban(store)
    const sameWidthPlank =
      store.state.ncSetting.sawSetting.mentaoji_enable &&
      store.state.ncSetting.sawSetting.sameWidthPlank &&
      store.state.ncSetting.sawSetting.sawToLayout &&
      store.state.ncSetting.sawSetting.processType === 'weldingPlank'
    // 开启相同宽度并且是锯切排版，异形的宽度要用锯片刀扩
    const useSawPaiban =
      ['paiban', 'paiban_roll'].filter((way) =>
        store.state.activePaibanWay.includes(way)
      ).length > 0

    rectInfo['rotate'] = isRotateForSmooth
      ? false
      : plank.texDir == 'notcare' && !plank.isRotateFrontEdge
      ? true
      : false
    if (sawToLayout) {
      // 锯切直排焊接板则不需要限制
      if ((sawCutOnlyWeld && plank.isWeldingPlank) || !sawCutOnlyWeld) {
        rectInfo['rotate'] = false
      }
    }
    // 对纹虚拟板件不可旋转，不可翻面
    if (isVirtualCompositePlank(plank)) {
      rectInfo['rotate'] = false
      rectInfo['needRoll'] = false
    }
    // 合并骨骼门即使无纹理也不允许旋转（结构方向固定）
    if (judgeIsMergeFrameDoor(plank)) {
      rectInfo['rotate'] = false
    }
    rectInfo['ggid'] = plank.ggid
    rectInfo['partUniqueId'] = plank.oriPartUniqueId ?? plank.partUniqueId
    if (plank.path && !!plank.path.length) {
      let paths = plank.path
      if (plank.slots?.length) {
        let slots = plank.slots
        paths = dealUnionPathSlots(paths, slots, store.state.ncSetting)
        // 将path合并槽之后的路径保存到 unionPath中
        plank.unionPath = paths
      }
      if (store.state.paibanInfo.isSpecialShape) {
        rectInfo['cutCurve'] = [...paths]
        let curvePathList = plank.curveHoles
          ?.filter((it) => compareNumbers(it.deep, plank.thick))
          .map((curve) => curve.path)
        if (curvePathList && curvePathList.length && !!curvePathList[0]) {
          rectInfo['cutCurve'].push(...curvePathList)
        }
      }
    }
    // 添加不排指定小板标识 模糊匹配
    const partName = plank.partName || plank.name || ''
    if (
      realSurNotLayout &&
      plankNames.some((name) => partName.includes(name))
    ) {
      rectInfo['isSurNotLayoutMat'] = true
    }

    // 添加品牌和供应商信息
    if (plank.brandName && plank.supplierName) {
      rectInfo['brandName'] = plank.brandName
      rectInfo['supplierName'] = plank.supplierName
    }

    // 对纹信息需要重新组合
    forEachTextureChild(plank, (child) => {
      const childKey = getKey(child)
      // 对纹的板件在开始就已经决定的其位置
      const targetPoint = plank._virtualCompositePlanksPos?.find(
        (it) => it.partUniqueId === child.partUniqueId
      )
      // 对纹板件不可旋转，不可翻面
      const childRectInfo = genRectMapInfo(child, childKey, {
        rotate: false,
        needRoll: false,
        startX: targetPoint?.x ?? 0,
        startY: targetPoint?.y ?? 0,
      })
      if (!childRectInfo) return
      if (!rectInfo.children) {
        rectInfo.children = []
      }
      rectInfo.children.push(childRectInfo)
    })
    // 对纹虚拟板添加标识
    if (isVirtualCompositePlank(plank)) {
      rectInfo._isVirtualCompositePlank = true
    }
    // 唯一 ID
    rectInfo.id = plank.partUniqueId
    return Object.assign(rectInfo, options)
  }
  // 组合虚拟板（排版扩板后需要偏移）
  const layoutGap = store.state.ncSetting?.panelSize?.layoutGap ?? 0
  layoutData = compositeTexturePlanks(
    layoutData,
    layoutGap,
    true,
    true,
    store.state.ncSetting?.decimal ?? 2,
    true
  )
  for (var i in layoutData) {
    const key = getKey(layoutData[i])
    const rectInfo = genRectMapInfo(layoutData[i], key)
    if (!rectInfo) continue
    rectMap[key].push(rectInfo)
    layoutData[i].index = i + 1
    layoutData[i].rectInd = rectMap[key].length
  }
  layoutData = decompositeTexturePlanks(layoutData)
  if (passLayout) {
    return
  }

  var decimal = Number(ncSettings.decimal)
  if (typeof decimal != 'number') {
    decimal = 2
  }
  // 这里是针对于锯片排班的，只有全部使用了锯片才会将刀换成锯片刀，其他情况都是用下料刀
  // 以上注释不生效了，现如今是宽度排版后全部用锯片刀
  // 第二点上之后用这个
  let knifeR = Number(ncSettings.knife.diameter) / 2

  // 提取配置信息
  var config = {
    outWidth: plankWidth,
    outHeight: plankHeight,
    margin: plankEdgeOff,
    gap: layoutGap,
    knifeR: knifeR,
    sawKnifeR: sawKnifeR > 0 ? sawKnifeR / 2 : null,
    startPosition: startPosition,
    changeKnifePosition: initialXyReverse,
    xyReverse: initialXyReverse,
    decimal: decimal,
    surplus_no_roll: store.state.isSurplusNoRoll,
    stacking_method:
      store.state?.preferencesSetting?.setting?.stacking_method ?? 'short',
    isSurNotLayoutMat: store.state.isSurNotLayoutMat,
  }
  if (isYunLayout) {
    var data = {}
    data['layoutRectMap'] = rectMap
    data['layoutHoleMap'] = {}
    data['layoutConfig'] = config
    // yunlayoutData = data;
    return {
      data: data,
      layout_data: layoutData,
    }
  } else {
    judgeUseSurplus(rectMap, config)
  }
}

/**
 * @description 用于判断一个小板是否是焊接板
 * @param part 接收一个小板
 * @returns { Boolean }
 *  */
export const isWeldingPart = (part) => {
  return part.isWeldingPlank
}

// 计算每个小板的面积
export function caclPartArea(part) {
  let areaAll = 0
  let insideArea = 0
  part.path?.forEach((poly, index) => {
    if (index) {
      insideArea += Math.abs(window.ClipperLib.Clipper.Area(poly))
    }
  })
  if (part.curveHoles?.length) {
    insideArea += sumPiercedCurveHolesAreaDedupeNested(
      part.curveHoles,
      part.thick
    )
  }
  if (!part.surplusPath) {
    if (part.path) {
      const arr = part.path[0].map((it) => ({
        x: Number(it.x.toFixed(2)),
        y: Number(it.y.toFixed(2)),
      }))
      areaAll += Math.abs(window.ClipperLib.Clipper.Area(arr)) - insideArea
    } else {
      areaAll +=
        Number(part.rect.width.toFixed(2)) *
          Number(part.rect.height.toFixed(2)) -
        insideArea
    }
  }
  return { usedArea: areaAll }
}

// 处理扩张后的偏移
function afterExpendPathOffset(path, minX, minY, part) {
  try {
    path.forEach((point) => {
      if (minY < 0) {
        point.y += Math.abs(minY)
      }
      if (minX < 0) {
        point.x += Math.abs(minX)
      }
    })
    path[0] && path.push({ ...path[0] })
  } catch (error) {
    store.commit('setErrorPathPlankID', part.plankID)
  }
}

export function layoutStart(ncSetting, noSurplus, data) {
  ncSettings = ncSetting
  layoutPatchData = []
  return doLayout(noSurplus)
}

function doLayout(noSurplus) {
  cutDirection = ncSettings.cutDirection
  throughTowSideToCut = ncSettings.throughTowSideToCut
  xyReverse = ncSettings.xyReverse
  startPosition = ncSettings.startPosition

  initialCutDirection = ncSettings.cutDirection
  initialThroughTowSideToCut = ncSettings.throughTowSideToCut
  initialXyReverse = ncSettings.xyReverse
  initialStartPosition = ncSettings.startPosition
  const diameter = ncSettings.knife.diameter
  if ((diameter && diameter != '') || Number(diameter) === 0) {
    cutKnifeRadius = Number(diameter) / 2
    if (ncSettings.cuttingEquipment === 'glassEquip') {
      cutKnifeRadius = 0
    }
    return loadLayout()
  } else {
    return false
  }
}

function directYunLayout() {
  var modelLst = buttonRepeater.model
  for (var index = 0; index < modelLst.length; ++index) {
    var tmpData = modelLst[index]
    if (tmpData['name'] === gg.getTrans('云排版(优化率最高)')) {
      tmpData['checked'] = true
    } else {
      tmpData['checked'] = false
    }
  }
  buttonRepeater.model = modelLst
  isYunLayout = true

  root.layoutStart()
}

//**************************************************** 余料利用相关 **************************************************************

//加载余料清单
function loadSurplusList(p) {
  dbProjectObj.loadSurplusListPostData(p) //POST加载数据
}

//余料使用，数据
function getUseSurplusData(list) {
  isDataWrong = false
  var useData = {}
  for (var i in list) {
    var item = list[i]
    var texture = item['color'],
      matCode = item['type'],
      thick = item['thick']
    var key = texture + ':' + matCode + ':' + thick

    var dataItem = {}
    dataItem['width'] = item['width']
    dataItem['height'] = item['long']
    dataItem['area'] = item['area']
    dataItem['id'] = item['id']

    if (item['shape'] === 0) {
      //0是矩形余料
      if (dataItem['width'] && dataItem['height']) {
        if (!useData.hasOwnProperty(key)) {
          useData[key] = []
        }
        useData[key].push(dataItem)
      } else {
        continue
      }
    } else if (item['shape'] == 1) {
      //1是L形余料
      dataItem['area'] = item['area']
      dataItem['id'] = item['id']
      dataItem['shape'] = 'lshape'
      dataItem['x3'] = item['min_width'] * 1
      dataItem['y3'] = item['long'] * 1
      dataItem['x4'] = item['min_width'] * 1
      dataItem['y4'] = item['min_long'] * 1
      dataItem['x5'] = item['width'] * 1
      dataItem['y5'] = item['min_long'] * 1
      dataItem['path'] = item['path']
      if (item['width'] && item['long']) {
        if (!useData.hasOwnProperty(key)) {
          useData[key] = []
        }
        useData[key].push(dataItem)
      } else {
        continue
      }
    } else {
      // 特殊异形余料
      dataItem['shape'] = 'specialShape'
      if (dataItem['width'] && dataItem['height']) {
        if (!useData.hasOwnProperty(key)) {
          useData[key] = []
        }
        useData[key].push(dataItem)
      } else {
        continue
      }
    }
  }
  return useData
}

//余料使用：进行排版
function conductLayout(rectMap, config, surplus) {
  config.surplus_no_roll = store.state.isSurplusNoRoll
  var surplusMargin = curTech.techParams.plankInfo.panelSize.surplusMargin
  //        var surplusTrim = curTech.techParams.plankInfo.surplusTrim

  dbProjectObj.sLoadSurplusPostData.disconnect(loadSurplusData)
  mode = gg.getTrans('排版图')

  //    progressInfo.open(Object.keys(rectMap).length, "排版中2:", 1);
  hasFinished = false

  if (isYunLayout) {
    var yunData = {}
    yunData['layoutRectMap'] = rectMap
    yunData['layoutHoleMap'] = {}
    yunData['layoutConfig'] = config
    startYunLayout(yunData)
    return
  }
  if (isTestLayoutPlank == true) {
    gg.generateLayoutInformation(
      rectMap,
      {},
      config,
      surplus,
      false,
      true,
      surplusMargin
    )
  } else {
    gg.generateLayoutInformation(rectMap, {}, config, surplus)
  }
}

//加载余料仓信息
function loadSurplusData(oData) {
  var list = []
  var count = 0
  var canUseCount = 0
  for (var i in oData) {
    var item = oData[i]
    var user_num = item['user_num']
    count += item['amount'] * 1

    if (user_num > 0) {
      if (user_num > 1) {
        for (var aInd = 0; aInd < user_num; aInd++) {
          list.push(item)
        }
      } else {
        list.push(item)
      }
    }
  }

  surplusUseData = getUseSurplusData(list)

  for (var i in surplusUseData) {
    var item = surplusUseData[i]
    if (plankKeysList && plankKeysList.indexOf(i) != -1) {
      canUseCount += item.length
    }
  }
  surplusDataLoad = true
  surplusRow.surplusCount = count
  surplusRow.canSurplus = canUseCount
}

//判断是否有能使用的余料
function judgeUseSurplus(rectMap, config) {
  var worker = function () {
    if (fromPurchase) {
      conductLayout(rectMap, config, surplusList)
    }
    //进入排版页面
    else if (Object.keys(surplusUseData).length > 0) {
      var data = {}
      for (var skey in surplusUseData) {
        if (rectMap.hasOwnProperty(skey)) {
          data[skey] = surplusUseData[skey]
        }
      }

      surplusList = data

      if (surplusList && Object.keys(surplusList).length > 0) {
        confirmUsePop.rectMap = rectMap
        confirmUsePop.config = config
        if (surplusCheckBtn.checked || useSurps == true) {
          confirmUsePop.useSurplus()
        } else {
          confirmUsePop.open()
        }
      } else {
        conductLayout(rectMap, config, surplusList)
      }
    } else {
      conductLayout(rectMap, config, surplusList)
    }
  }

  // 板件数量有差异
  // if (preverify) {
  if (false) {
    function fixed(num, n) {
      return Math.round(num * Math.pow(10, n)) / Math.pow(10, n)
    }

    var eList = []
    var cList = []

    var params = {
      filter_data: [],
    }

    var itemObj = {}
    itemObj['order_id'] = projectInfo['id']
    itemObj['room_id'] = []

    for (var rInd in roomInfos) {
      var roomItem = roomInfos[rInd]
      var curRoomId = roomItem['id']
      itemObj['room_id'].push(curRoomId)
    }

    params['filter_data'].push(itemObj)

    globalJSTool.postJSON(
      'http://ggtools.thinkerx.com/get_material_bill',
      params,
      function success(result) {
        result = JSON.parse(result)

        if (result['status'] === 1) {
          var data = result['data']
          if (data.hasOwnProperty('wardrobe')) {
            var planks = data['wardrobe']['plank_obj']
            for (var i = 0; i < planks.length; ++i) {
              var plank = planks[i]
              var spec = plank['spec']
              var amount = plank['amount']
              var plankID = plank['plkId']
              var roomName = plank['roomName']
              var plankName = plank['plankName']
              var partMaskName = plank['partMaskName']

              if (!roomName) {
                roomName = '-'
              }

              if (!partMaskName) {
                partMaskName = roomName + '_' + plankName
              }

              for (var j = 0; j < amount; ++j) {
                if (plank['matCode'] === gg.getTrans('占位板')) {
                  continue
                }

                eList.push({
                  desc:
                    '#' +
                    plankID +
                    ' ' +
                    roomName +
                    ' ' +
                    partMaskName +
                    ' ' +
                    spec,
                  checked: false,
                })
              }
            }
          }
          if (data.hasOwnProperty('panel')) {
            var panels = data['panel']['panel_obj']
            for (var i = 0; i < panels.length; ++i) {
              var panel = panels[i]
              var spec = panel['spec']
              var name = panel['name']
              var style = panel['style']
              var amount = panel['amount']
              var plankID = panel['plkId']
              var roomName = panel['roomName']
              var parentName = panel['parentName']
              var wardrobeName = panel['wardrobeName']
              var partMaskName = panel['partMaskName']

              if (!roomName) {
                roomName = '-'
              }

              if (!partMaskName) {
                partMaskName =
                  roomName + '_' + wardrobeName + '_' + parentName + '_' + name
              }

              if (style === '板式门') {
                for (var j = 0; j < amount; ++j) {
                  if (panel['matCode'] === gg.getTrans('占位板')) {
                    continue
                  }

                  eList.push({
                    desc:
                      '#' +
                      plankID +
                      ' ' +
                      roomName +
                      ' ' +
                      partMaskName +
                      ' ' +
                      spec,
                    checked: false,
                  })
                }
              }
            }
          }
        }
      }
    )

    // 添加补件板件
    layoutPatchData.forEach(function (part) {
      var plankID = part['plankID']
      var roomName = part['roomName']
      var partName = part['partName']
      var fullSize = part['fullSize']
      var thick = part['thick']

      var rect = part['rect']

      if (!rect) {
        return
      }

      eList.push({
        desc:
          '#' +
          plankID +
          ' ' +
          roomName +
          ' ' +
          partName +
          ' ' +
          (fixed(fullSize.width, 1) +
            '*' +
            fixed(fullSize.height, 1) +
            '*' +
            thick),
        checked: false,
      })
    })

    layoutData.forEach(function (part) {
      var plankID = part['plankID']
      var roomName = part['roomName']
      var partName = part['partName']
      var fullSize = part['fullSize']
      var thick = part['thick']

      var rect = part['rect']

      if (!rect) {
        return
      }

      cList.push({
        desc:
          '#' +
          plankID +
          ' ' +
          roomName +
          ' ' +
          partName +
          ' ' +
          (fixed(fullSize.width, 1) +
            '*' +
            fixed(fullSize.height, 1) +
            '*' +
            thick),
        checked: false,
      })
    })

    // 添加锁定排版板件
    ignorePlankList.forEach(function (part) {
      var plankID = part['plankID']
      var roomName = part['roomName']
      var partName = part['partName']
      var fullSize = part['fullSize']
      var thick = part['thick']

      var rect = part['rect']

      if (!rect) {
        return
      }

      cList.push({
        desc:
          '#' +
          plankID +
          ' ' +
          roomName +
          ' ' +
          partName +
          ' ' +
          (fixed(fullSize.width, 1) +
            '*' +
            fixed(fullSize.height, 1) +
            '*' +
            thick),
        checked: false,
      })
    })

    if (eList.length <= 0 && cList.length > 0) {
      main_msgTips.open(gg.getTrans('多板漏板检测失败!'), 'fail')
      return
    }

    if (eList.length !== cList.length) {
      differentPlankList = []

      var fList = []
      var sList = []

      if (eList.length > cList.length) {
        fList = eList
        sList = cList
      } else {
        fList = cList
        sList = eList
      }

      fList.forEach(function (fPart) {
        var fDesc = fPart['desc']
        var fPartName = fDesc.split(' ')[2]

        for (var k in sList) {
          var sPart = sList[k]
          var sChecked = sPart['checked']
          if (sChecked) {
            continue
          }

          var sDesc = sPart['desc']
          var sPartName = sDesc.split(' ')[2]
          if (
            sPartName.indexOf(fPartName) >= 0 ||
            fPartName.indexOf(sPartName) >= 0
          ) {
            sPart['checked'] = true
            return
          }
        }

        differentPlankList.push(fDesc)
      })

      warningDialog.actual = cList.length
      warningDialog.estimated = eList.length
      warningDialog.callback = worker
      warningDialog.open()
      return
    }
  }

  // worker();
}

//余料使用数据保存——NC输出，余料数据扣减
function useSurplusSave() {
  var useSurplusCount = 0
  var usedSurpCount = {}
  for (var count in layoutResult) {
    if (layoutResult[count]['surplusInfo'] !== null) {
      var curInfo = layoutResult[count]['surplusInfo']
      var res = []
      var needBreak = false
      for (var index in Object.keys(usedSurpCount)) {
        var currentKey = Object.keys(usedSurpCount)[index]
        if (parseFloat(currentKey) == parseFloat(curInfo['id'])) {
          res = usedSurpCount[currentKey]
          res.push(curInfo)
          usedSurpCount[currentKey] = res
          needBreak = true
          continue
        }
      }
      if (needBreak) {
        continue
      }
      res.push(curInfo)
      usedSurpCount[curInfo['id']] = res
      useSurplusCount++
    }
  }
  var result = []
  for (var i in surplusRect) {
    var surplusItem = surplusRect[i]
    var currentID = surplusItem['id']

    var data = {}
    data['id'] = currentID
    data['num'] =
      usedSurpCount && usedSurpCount.hasOwnProperty(currentID)
        ? usedSurpCount[currentID].length
        : useSurplusCount
    var isBreak = false

    for (var rInd in result) {
      var rID = result[rInd]['id']
      if (parseFloat(rID) === parseFloat(currentID)) {
        result[rInd]['num']++
        isBreak = true
        continue
      }
    }

    if (isBreak) {
      continue
    }
    result.push(data)
  }

  var params = {}
  params['surplus'] = result
  dbProjectObj.useSurplusList(params)
}

//**************************************************** 余料利用相关 以上 **************************************************************

//检测孔槽是否在小板内
function checkHoleSlotsInPlank(checkData) {
  var cutR = cutKnifeRadius
  var hasError = false

  for (var i in checkData) {
    var row = deepCopy(checkData[i])
    var holes = row['holes']
    var slots = row['slots']
    var oRect = row['oRect']
    var rect = row['rect']
    var path = row['path']

    var edgeInfo = row['edgeInfo']
    var splitResut = splitEdgeInfo(edgeInfo)
    var left = splitResut.left
    var right = splitResut.right
    var top = splitResut.top
    var bottom = splitResut.bottom

    var qtPoints = []
    if (path) {
      for (var pi in path[0]) {
        qtPoints.push({ x: path[0][pi].x, y: path[0][pi].y })
      }
    } else {
      qtPoints = [
        { x: 0, y: 0 },
        { x: rect.width, y: 0 },
        { x: rect.width, y: rect.height },
        { x: 0, y: rect.height },
        { x: 0, y: 0 },
      ]
    }

    for (var hInd in holes) {
      var hole = holes[hInd]
      var center = { x: hole['center'].x, y: hole['center'].y }
      var inPlank = gg.isPointInPolygin(qtPoints, center)
      if (!inPlank) {
        checkData[i]['holeError'] = true
        hasError = true
        break
      }
    }

    if (checkData[i]['holeError']) {
      continue
    }

    for (var sInd in slots) {
      var slot = slots[sInd]
      var swidth = slot['width']
      var pt1 = { x: slot['pt1'].x, y: slot['pt1'].y }
      var pt2 = { x: slot['pt2'].x, y: slot['pt2'].y }

      var slotRect = []
      if (pt1.x === pt2.x) {
        slotRect = [
          { x: pt1.x - swidth / 2, y: pt1.y },
          { x: pt1.x - swidth / 2, y: pt2.y },
          { x: pt1.x + swidth / 2, y: pt2.y },
          { x: pt1.x + swidth / 2, y: pt1.y },
        ]
      }

      var intersected = gg.polyIntersected(qtPoints, slotRect)
      var error = false
      for (var ind in intersected) {
        var pt = intersected[ind]
        if (slotRect.indexOf(pt) === -1) {
          error = true
        }
      }
      if (error) {
        checkData[i]['holeError'] = true
        hasError = true
        break
      }
    }
  }
  return hasError
}

//wsl-将原来判断孔槽问题的函数提出来
function ifHoleandSlotError(layoutresult) {
  var checkData = []
  for (var i in layoutresult) {
    var layout = layoutresult[i]['parts']
    for (var jj in layout) {
      var row = layout[jj]
      var map = row
      delete map['item']
      checkData.push(map)
    }
  }

  var hasError = checkHoleSlotsInPlank(checkData)

  var result = gg.checkHoleSlots(checkData, cutKnifeRadius, null)
  var holeError = result['networkHoleErrors']
  for (i in layoutresult) {
    layout = layoutresult[i]['parts']
    for (jj in layout) {
      row = layout[jj]
      var ggid = row['ggid_short']
      if (ggid === undefined) ggid = row['ggid']
      if (holeError[ggid]) {
        row['holeError'] = true
      } else {
        ggid = row['oriPlankNum']
        if (holeError[ggid]) {
          row['holeError'] = true
        }
      }
      if (row['holeError']) {
        hasError = true
      }
    }
  }

  if (hasError) {
    layoutView.repaint()
    main_msgTips.open(gg.getTrans('检测到板件孔槽异常，请仔细核对后再生产！'))
    return true
  }
  return false
}

function findErrorHole(layoutResult) {
  for (var i in layoutResult) {
    var parts = layoutResult[i]['parts']
    for (var j in parts) {
      var part = parts[j]
      var holes = part['holes']

      for (var k in holes) {
        var hole = holes[k]
        var p = hole['center']

        if (p.x < 0 || p.y < 0) {
          return true
        }
      }
    }
    return false
  }
}

//*********************************************** 电子开料锯 **************************************************************

//新版料单数据加载
function initSplitNew() {
  loadIndicator.start()
  var param = {
    filter_data: [],
  }
  if (dataForAll) {
    for (var i in dataForAll) {
      var dItem = dataForAll[i]
      var pInfo = dItem['projectInfo']
      var curRoomIds = dItem['roomIds']
      var allRooms = pInfo.room
      var itemObj = {}
      projectInfo = pInfo

      //单个房间的输出
      if (curRoomIds) {
        layoutType = 'layout'
        param['filter_data'] = {}
        param['filter_data']['room_id'] = [curRoomIds[0]]

        break
      } else {
        layoutType = 'fromOneOrder'

        //多订单批量生产
        if (i * 1 > 1) {
          layoutType = 'fromOrders'
        }

        itemObj['order_id'] = pInfo['id']
        itemObj['room_id'] = []

        for (var rInd in allRooms) {
          var roomItem = allRooms[rInd]
          var curRoomId = roomItem['id']
          itemObj['room_id'].push(curRoomId)
        }

        param['filter_data'].push(itemObj)
      }
    }
  } else if (complementOrders) {
    var itemObj = { room_id: [] }
    for (var i in complementOrders) {
      var rooms = complementOrders[i]['plates']
      for (var j in rooms) {
        var rid = rooms[j]['rid']
        if (itemObj['room_id'].indexOf(rid) === -1) {
          itemObj['room_id'].push(rid)
        }
      }
    }
    param['filter_data'].push(itemObj)
  }

  loadSplitData(param)
  loadIndicator.hide()
}

//料单数据加载：批量生产
function loadSplitData(url) {
  if (Object.keys(url).length > 0) {
    var params = url

    globalJSTool.postJSON(
      'http://ggtools.thinkerx.com/get_material_bill',
      params,
      function success(result) {
        result = libGG.parseJson(result)

        if (result['status'] === 1) {
          var data = result['data']
          if (data.hasOwnProperty('wardrobe')) {
            materailBillData = getMaterialBiilData(data)
            return
          } else {
            main_msgTips.open(gg.getTrans(data), 'fail')
            return
          }
        }
        main_msgTips.open(gg.getTrans(result['msg']), 'fail')
      }
    )
  }
}

//*************************************************** 电子开料锯 以上 **********************************************************************

//新版料单——获取数据
function loadSplitViewNew() {
  if (!materailBillData || !materailBillData.length) {
    loadIndicator.start()
    initSplitNew()
    loadIndicator.hide()
  }

  wardrobeBillData = materailBillData
}

//获取开料清单的数据
function getMaterialBiilData(data) {
  var res = []

  //板件信息
  var wardrobeData = handleSplitInterfaceRet('wardrobe', data)
  for (var i in wardrobeData) {
    res.push(wardrobeData[i])
  }

  //板式门
  var doorData = handleSplitInterfaceRet('panel', data)
  for (var j in doorData) {
    res.push(doorData[j])
  }

  return res
}

//处理料单接口返回的数据
function handleSplitInterfaceRet(type, info) {
  var curData = info[type]
  if (type === 'wardrobe') {
    curData = curData['plank_obj']
  } else if (type === 'panel') {
    curData = curData['panel_obj']
  } else if (type === 'slidedoor') {
    curData = curData['slidedoor_obj']
  }

  var result = []

  for (var i in curData) {
    var item = curData[i]

    if (type === 'panel') {
      if (item['style'] === gg.getTrans('板式门')) {
        var row = getTypeRowData(item, 'panelSplit')
        result.push(row)
      }
    } else {
      var row = getTypeRowData(item, type)
      result.push(row)
    }
  }

  return result
}

function exportUnmanned(filters) {
  var savePath = ''

  if (path !== '') {
    savePath = gg.getStandardPath(path + '/无人线/')
  } else {
    userFlies.open()
    savePath = gg.getStandardPath(userFlieUrl.text + '/无人线/')
  }

  loadLayoutTianGong()

  var count = 1
  //        var roomInfo = roomInfos[0];
  //        if (roomInfo && roomInfo["parts"] && roomInfo["parts"][gg.getTrans("生产数量")]) {
  //            count = roomInfo["parts"][gg.getTrans("生产数量")];
  //        }

  ggData = GGBom.generator(layoutData, count)

  var address = projectInfo['buyer_address']
  if (address) {
    address = address
      .replace(/ /g, '-')
      .replace(/:/g, '-')
      .replace(new RegExp('[:<>/|:"*?]', 'g'), '')
  } else {
    address = '多订单打包'
  }

  savePath = UMD.generator(savePath, address, ggData, filters)

  if (UMD.errorLog.length > 0) {
    // 数据异常
    main_msgTips.open(UMD.errorLog.join('\r\n'), 'fail')
  } else {
    gg.openLocalPath(savePath)
  }

  // 单独启动排版
  if (UMD.addedLayoutContainer.length > 0) {
    var container = []

    for (var i in UMD.addedLayoutContainer) {
      var remain = UMD.addedLayoutContainer[i]

      for (var j in layoutData) {
        var part = layoutData[j]

        if (String(remain['gid']) === String(part['gid'])) {
          container.push(part)
          break
        }
      }
    }

    addedLayout(container)
  }

  // 上传到补件仓
  if (UMD.complementContainer.length > 0) {
    var container = {}

    for (var i in UMD.complementContainer) {
      var remain = UMD.complementContainer[i]

      for (var j in layoutData) {
        var part = layoutData[j]
        if (String(remain['gid']) === String(part['gid'])) {
          var roomID = part['roomID']
          var plankID = part['plankID']

          if (!container.hasOwnProperty(roomID)) {
            container[roomID] = []
          }

          container[roomID].push(plankID)
        }
      }
    }

    for (var key in container) {
      var value = container[key]
      if (value) {
        dbProjectObj.addPatch({ room_id: key, plank_id: value.join(',') })
      }
    }
  }
}

//**************************************************** 排版 NC 备份相关 **************************************************************

//加载备份信息
function loadBackupInfo() {
  var projectIDList = [],
    room_id = []
  var param = {}

  if (layoutType === 'fromOrders') {
    for (var i in multiList) {
      var projectInfo_orders = multiList[i]['projectInfo']
      projectIDList.push(getParam(projectInfo_orders, 'id', ''))
    }

    param = { oid: projectIDList }
  } else if (layoutType === 'fromOneOrder') {
    projectIDList.push(getParam(projectInfo, 'id', ''))
    param = { oid: projectIDList }
  } else {
    room_id = getParam(roomInfos[0], 'id', '')
    param = { room_id: room_id }
  }
  if (param['room_id'] !== '') dbProjectObj.loadNC(param)
}

//nc备份 保存排版 获取名称
function getNameList() {
  var roomNameList = [],
    projectNameList = []
  var projectIDList = []

  for (var i in dataForAll) {
    var oneProject = dataForAll[i]
    var project = oneProject['projectInfo']
    projectNameList.push(project['buyer_address'])
    projectIDList.push(project['id'])

    if (oneProject.hasOwnProperty('roomIds')) {
      var rIds = oneProject['roomIds']
      for (var j in rIds) {
        var rInfo = findRoomInfo(project, rIds[j])
        if (rInfo) {
          roomNameList.push(rInfo['name'])
        }
      }
    } else {
      for (j in project['room']) {
        rInfo = project['room'][j]
        roomNameList.push(rInfo['name'])
      }
    }
  }

  var result = {
    projectNameList: projectNameList,
    projectIDList: projectIDList,
    roomNameList: roomNameList,
  }

  return result
}

export function changeLayoutData(data) {
  preLayoutData = dealPlankHoleSlotCSide(data)
  uniquePlankNum(preLayoutData)
  layoutData = preLayoutData
}

//nc备份 保存排版 获取名称中的日期
function getNowDate(isSave) {
  var date = new Date()
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  var hour = date.getHours()
  var minutes = date.getMinutes()

  if (minutes < 10) {
    minutes = '0' + minutes
  }

  var str = ''
  if (isSave) {
    str = Date.parse(new Date())
  } else {
    str = year + '.' + month + '.' + day + ' ' + hour + ':' + minutes
  }

  return str
}

//加载历史排版信息
function loadSavedLayout(data) {
  rectColumn.width = 0
  rectColumn.visible = false
  backLayoutBtn.visible = true

  var urlList = data.split('/')
  var fileName = urlList[urlList.length - 1]
  fileName = gg.getTempRoot() + 'layout/layoutPlan/' + fileName

  if (!gg.isExistFile(fileName)) {
    fileSvc.downloadFile(data, fileName, 'none')
  }
  var newLayoutReault = libGG.parseJson(gg.loadFileToString(fileName))
  layoutResult = newLayoutReault

  surplusRect = []
  layoutView.repaint()
}

//导入排版文件
function importLayoutFile() {
  var result = getNameList(projectInfo, roomInfos, layoutType)
  var projectNameList = result['projectNameList']
  var roomNameList = result['roomNameList']
  var day = Qt.formatDateTime(new Date(), 'yyyy-MM-dd')
  var path = gg.getAppAbsolutePath() + 'nc' + '/' + day + '/'
  for (var i in projectNameList) {
    projectNameList[i] = projectNameList[i].replace(':', '-')
    projectNameList[i] = projectNameList[i].replace(':', '-')
  }
  if (projectNameList.length > 1) {
    path += projectNameList.join('_') + '/批量订单-排版文件.ggp'
  } else {
    var rooms = roomNameList[0].split(',')
    if (rooms.length > 1) {
      path += projectNameList[0] + '/' + projectNameList[0] + '-排版文件.ggp'
    } else {
      path +=
        projectNameList[0] + '_' + rooms[0] + '/' + rooms[0] + '-排版文件.ggp'
    }
  }
  path = path.replace(' ', '-')
  if (!gg.isExistFile(path)) {
    main_msgTips.open(gg.getTrans('暂无对应排版文件'), 'fail')
    return
  }

  var fileData = libGG.parseJson(gg.loadFileToString(path))
  var newLayoutReault = fileData['layout']
  layoutResult = newLayoutReault
  layoutView.repaint()
  main_msgTips.open(gg.getTrans('导入成功'), 'success')
}

//将表数据转换为excel格式
function getExcelData(dataList, roleList) {
  var list = []
  for (var m in dataList) {
    var item = []
    var listItem = dataList[m]

    for (var n in roleList) {
      var role = roleList[n]

      var keys = Object.keys(listItem)
      if (keys.indexOf(role) != -1) {
        item.push(listItem[role])
      } else {
        item.push('')
      }
    }
    list.push(item)
  }

  var result = ''
  for (var itm in list) {
    var istr = list[itm].join(',')
    istr = istr + '\n'
    result = result + istr
  }

  return result
}

//将数组转换为key:value对象
function convertListToJson(list, keyList) {
  var obj = {}
  for (var i in list) {
    for (var j in keyList) {
      if (i * 1 === j * 1) {
        if (list[i] === 'true' || list[i] === 'TRUE') {
          obj[keyList[j]] = true
        } else if (list[i] === 'false' || list[i] === 'FALSE') {
          obj[keyList[j]] = false
        } else {
          obj[keyList[j]] = list[i]
        }
      }
    }
  }
  return obj
}

//加载数据转化为mode
function changeDataToMode(data, headerRole) {
  var list = []
  for (var i in data) {
    if (i > 0) {
      var result = convertListToJson(data[i], headerRole)
      list.push(result)
    }
  }

  importPop.refresh(list)
  importData = list
}

//返回当前排版按钮visible
function changeReturnLayout(value) {
  backLayoutBtn.visible = value
}

//返回当前排版功能
function returnLayout() {
  resetPlank()
  rectColumn.width = outerRectangle.currentWidth
  rectColumn.visible = true
  backLayoutBtn.visible = false
  layoutToolChoose.visible = true

  returnBeforeLayout()
  layoutResult = beforeLayoutResult
  surplusRect = []
  layoutView.repaint()
}

//**************************************************** 排版 NC 备份相关 以上 **************************************************************

//设置板件ID
function setPlankNum() {
  var plankNum = ''
  var oriPlankNum = ''
  if (plankNum === '' || oriPlankNum === '') {
    oriPlankNum = gg.genEAN13CodeByTimestamp()
    plankNum = gg.genEAN13CheckCode(oriPlankNum)
  }
  return [plankNum, oriPlankNum]
}

//加载补件信息
function loadPatchInfo() {
  dbProjectObj.loadAppliesList({ uid: userService.uid })
  globalJSTool.getPatch(
    { uid: userService.uid },
    getPatchSucceed,
    getPatchFailed
  )
}

function getPatchSucceed(s) {
  if (s['status']) {
    var data = s['data']
    var orders = data['orders']
    var count = 0
    var patchMat = {}
    //能够补件板件id;
    var canId = []
    for (var i in orders) {
      var plates = orders[i]['plates']

      for (var k in plates) {
        var plateInfo = plates[k]['plate_info']
        var size = plateInfo['size']
        var thick = Number(size.split('*')[2])

        plates[k]['size'] = size
        plates[k]['thick'] = thick
        plates[k]['plankId'] = plateInfo['plKId']
        plates[k]['color'] = plateInfo['color']
        plates[k]['type'] = plateInfo['matCode']

        var mat = plateInfo['color'] + ':' + plateInfo['matCode'] + ':' + thick
        if (!patchMat.hasOwnProperty(mat)) {
          var matList = [plates[k]['id']]
          patchMat[mat] = matList
        } else {
          matList = patchMat[mat]
          if (matList.indexOf(plates[k]['id']) === -1) {
            matList.push(plates[k]['id'])
          }
          patchMat[mat] = matList
        }
      }
      count += plates.length
    }

    //计算可以顺便补件的板件
    //补件清单里有的旧数据(patchMat)会出现如{"T01.jpg:多层实木:17":[2279,2280,2640]}这样的。需要做处理才能匹配上
    var nObj = {}
    for (var key in patchMat) {
      var v = patchMat[key]
      //key --> T01.jpg:多层实木:17
      var arr = key.split(':')
      var colorCode = arr[0]
      var relColorCode = colorCode.split('.')[0]
      var relKey = [relColorCode, arr[1], arr[2]]
      relKey = relKey.join(':')
      if (!nObj.hasOwnProperty(relKey)) {
        nObj[relKey] = v
      } else {
        nObj[relKey] = nObj[relKey].concat(v)
      }
    }
    for (var i in plankKeysList) {
      //plankKeysList[i]是个类似这样的东西 --> T01:多层实木:17
      if (nObj.hasOwnProperty(plankKeysList[i])) {
        matList = nObj[plankKeysList[i]]
        canId = canId.concat(matList)
      }
    }

    complementOrders = orders
    patchRow.canPatchIdsByRenderJson = canId
  }
  patchDataLoadNew = true
}
function getPatchFailed(e) {
  //        main_msgTips.open(gg.getTrans("获取失败"), "fail")
}

//获取补件基础信息
function loadPatchSimpleInfo() {
  patchRow.patchCount = 0
  patchRow.canPatch = 0
  globalJSTool.getPatchSimpleInfo(
    { uid: userService.uid, new_data: 1 },
    getPatchInfoSucceed
  )
}

function getPatchInfoSucceed(s) {
  if (s['status']) {
    var data = s['data']
    var plates = data['plank_list']
    var count = data['num']
    var canPatchCount = 0
    var patchMat = {}

    for (var k in plates) {
      var plateInfo = plates[k]

      var mat =
        plateInfo['color'] + ':' + plateInfo['type'] + ':' + plateInfo['depth']
      if (!patchMat.hasOwnProperty(mat)) {
        patchMat[mat] = 1
      } else {
        var matCount = patchMat[mat]
        patchMat[mat] = matCount + 1
      }
    }

    for (var i in plankKeysList) {
      //plankKeysList[i]是个类似这样的东西 --> T01:多层实木:17
      if (patchMat.hasOwnProperty(plankKeysList[i])) {
        canPatchCount += patchMat[plankKeysList[i]]
      }
    }

    patchRow.patchCount = count
    patchRow.canPatch = canPatchCount
  }
}

function dealWithPatchInfo(mjson) {
  var num = 0
  var patchMat = {}
  var canId = []
  for (var k in mjson) {
    var plks = mjson[k]['plate']
    num += plks.length

    for (var i in plks) {
      var plateInfo = libGG.parseJson(plks[i]['plate_other'])
      var color = plks[i]['color']
      var type = plks[i]['type']
      var thick = plateInfo['thick']
      var mat = color + ':' + type + ':' + thick
      if (!patchMat.hasOwnProperty(mat)) {
        var matList = [plks[i]['id']]
        patchMat[mat] = matList
      } else {
        matList = patchMat[mat]
        matList.push(plks[i]['id'])
        patchMat[mat] = matList
      }
    }
  }
  for (var i in plankKeysList) {
    if (patchMat.hasOwnProperty(plankKeysList[i])) {
      matList = patchMat[plankKeysList[i]]
      canId = canId.concat(matList)
    }
  }

  patchRow.canPatchIds = canId
  patchDataLoadOld = true
}

//刷新界面
function flushView() {
  layoutView.visible = false
  outerRectangle.visible = false

  ncGenerator.visible = false
  labelGenerator.visible = false

  if (mode === gg.getTrans('排版图')) {
    //reLayoutBtn.visible = true
    layoutView.visible = true
    outerRectangle.visible = true
  } else if (mode === '标签') {
    labelGenerator.visible = true
  } else if (mode === '设备NC代码' || mode === '设备班鲁NC代码') {
    ncGenerator.loading = false
    ncGenerator.visible = true
    libGG.setGlobalVariable('updateNCConfigInExporting', false)
    //reLayoutBtn.visible = false;
    //if(blockLay.visible === true) {
    //  blockLay.visible = false;
    //}

    //是否显示备份次数
    loadBackupInfo()

    saveLayoutDataToLocalWithNc()
  }

  loadIndicator.hide()
}

function getSmallLayoutData(list) {
  var resultList = []
  for (var i in list) {
    var row = list[i]
    var tmpRow = {}
    tmpRow['stockKey'] = row['stockKey']
    tmpRow['plankWidth'] = row['plankWidth']
    tmpRow['plankHeight'] = row['plankHeight']
    var tmpParts = []
    var parts = row['parts']
    for (var j in parts) {
      var part = parts[j]
      var tmpPart = {}
      tmpPart['rect'] = part['rect']
      tmpPart['startX'] = part['startX']
      tmpPart['startY'] = part['startY']
      tmpPart['cutOrigin'] = part['cutOrigin']
      tmpPart['priority'] = part['priority']
      if (layoutView.userChangedList.indexOf(part['plankNum']) > -1)
        tmpPart['changed'] = 1
      else tmpPart['changed'] = 0
      tmpParts.push(tmpPart)
    }
    tmpRow['parts'] = tmpParts
    resultList.push(tmpRow)
  }
  return resultList
}

//深度拷贝
export function deepCopy(obj) {
  var result = Array.isArray(obj) ? [] : {}
  if (obj == null) {
    result = null
    return result
  } else if (obj == undefined) {
    result = undefined
    return result
  }

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object') {
        result[key] = deepCopy(obj[key]) //递归复制
      } else {
        result[key] = obj[key]
      }
    }
  }
  return result
}

//开料清单
function externLoadDataToLayout(iData) {
  var result = []
  for (var i in iData) {
    var plk = iData[i]
    var num = plk['num'] * 1

    if (plk['layoutData']) {
      var tData = {}
      var pData = plk['layoutData']
      tData['plankID'] = pData['plankID']
      tData['role'] = pData['role']
      tData['partName'] = pData['partName']
      tData['name'] = pData['name']
      tData['plkName'] = pData['plkName']
      tData['edgeInfo'] = pData['edgeInfo']
      tData['matCode'] = pData['matCode']
      tData['texture'] = pData['texture']
      tData['texDir'] = pData['texDir']
      tData['thick'] = pData['thick']
      tData['fullSize'] = pData['fullSize']
      tData['rect'] = pData['rect']
      tData['realRect'] = pData['realRect']
      tData['oRect'] = pData['oRect']
      tData['holes'] = pData['holes']
      tData['slots'] = pData['slots']
      tData['sholes'] = pData['sholes']
      tData['sslots'] = pData['sslots']
      tData['sholeInfo'] = pData['sholeInfo']
      tData['sslotInfo'] = pData['sslotInfo']
      tData['wardrobeName'] = pData['wardrobeName']
      tData['roomName'] = pData['roomName']
      tData['address'] = pData['address']
      tData['plankNum'] = pData['plankNum']
      tData['oriPlankNum'] = pData['oriPlankNum']
      tData['ggid'] = pData['ggid']
      tData['needRoll'] = pData['needRoll']
      tData['matRotatable'] = pData['matRotatable']

      for (var cind = 0; cind < num; ++cind) {
        result.push(tData)
      }
      continue
    }

    var texture = plk['texture']
    var spec = plk['spec']
    var size = plk['size']
    var texDir = plk['texDir']
    var plankNum = plk['number']
    var name = plk['name']
    var edges = plk['edgeInfo']
    var hsInfo = plk['hsInfo']

    var thick = 0
    var matCode = '多层实木'

    var width = 0,
      height = 0
    if (size && size.indexOf('=') !== -1) {
      var brr = size.split('=')
      var str = brr[0]
      if (str.indexOf('x') !== -1) {
        var crr = str.split('x')
        if (crr.length !== 3) {
          main_msgTips.open('错误的尺寸规则(WxHxT)', 'fail')
          return
        }
        height = crr[0]
        height *= 1
        width = crr[1]
        width *= 1
        var boolW = globalJSTool.isNumber(height) && height > 0
        var boolH = globalJSTool.isNumber(width) && width > 0
        if (!boolW) {
          main_msgTips.open('错误的尺寸规则(宽度)', 'fail')
          return
        }
        if (!boolH) {
          main_msgTips.open('错误的尺寸规则(高度)', 'fail')
          return
        }
      } else {
        main_msgTips.open('错误的尺寸规则(x)', 'fail')
        return
      }
    } else {
      main_msgTips.open('错误的尺寸规则(=)', 'fail')
      return
    }

    if (texDir === gg.getTrans('横纹')) {
      var temp = width
      width = height
      height = temp
    }

    if (spec && spec.indexOf('_') !== -1) {
      var xrr = spec.split('_')
      str = xrr[1]
      matCode = xrr[0]
      thick = str.split(matCode)[0]
      thick *= 1
      var boolT = globalJSTool.isNumber(thick) && thick > 0
      if (!boolT) {
        main_msgTips.open('错误的尺寸规则(厚度)', 'fail')
        return
      }
    } else {
      main_msgTips.open('错误的材质', 'fail')
    }

    var rwidth = width
    var rheight = height
    var edgeInfo = ''
    if (edges) {
      var edgeSplit = edges.split(':')
      if (edgeSplit.length !== 2) {
        main_msgTips.open('封边信息错误', 'fail')
        edgeInfo = ''
      } else if (edgeSplit.length === 2) {
        edges = edgeSplit[1].trim()
        edges = edges.split(/[^0-9.]/gi)
        var dirs = ['', '←', '↓', '→', '↑']
        for (var j = 1; j < edges.length; ++j) {
          edgeInfo += dirs[j] + edges[j]
          if (j % 2) {
            rwidth -= edges[j]
          } else {
            rheight -= edges[j]
          }
        }
      }
    }

    tData = {}
    tData['plankID'] = plankNum
    tData['role'] = 'Plank'
    tData['partName'] = name
    tData['name'] = name
    tData['plkName'] = name
    tData['edgeInfo'] = edgeInfo
    tData['matCode'] = matCode
    tData['texture'] = texture
    tData['texDir'] = texDir
    tData['thick'] = thick

    tData['fullSize'] = {
      width: width,
      height: height,
    }
    tData['rect'] = Qt.rect(0, 0, rwidth, rheight)
    tData['realRect'] = Qt.rect(0, 0, rwidth, rheight)
    tData['oRect'] = Qt.rect(0, 0, width, height)
    tData['holes'] = []
    tData['slots'] = []
    tData['sholes'] = []
    tData['sslots'] = []
    tData['sholeInfo'] = ''
    tData['sslotInfo'] = ''
    tData['wardrobeName'] = ''
    tData['roomName'] = ''
    tData['address'] = ''
    tData['oriPlankNum'] = gg.genEAN13CodeByTimestamp()
    tData['plankNum'] = gg.genEAN13CheckCode(tData['oriPlankNum'])
    tData['matRotatable'] = texDir === gg.getTrans('无纹理')

    for (var cind = 0; cind < num; ++cind) {
      result.push(tData)
    }
  }

  preLayoutData = result
  layoutStart()
}

function checkBackPlank(layoutData) {
  var result = []

  for (var i in layoutData) {
    var data = layoutData[i]
    var edgeInfo = data['edgeInfo']
    var rect = data['rect']
    var oRect = data['oRect']
    var partName = data['partName']
    var roomName = data['roomName']
    var splitResut = splitEdgeInfo(edgeInfo)
    var left = splitResut.left
    var right = splitResut.right
    var top = splitResut.top
    var bottom = splitResut.bottom

    var width = Number(rect['width'])
    var height = Number(rect['height'])
    var owidth = Number(oRect['width'])
    var oheight = Number(oRect['height'])
    // 排除异型的条件，由于clipper的扩张问题可能会导致出现大小的误差(在后端就已经出现了)
    // 封边预铣值这里rect 的值是后端处理过的， rect = rect + edgePreMillingInfo.width * 2
    let widthEdge = 0
    let heightEdge = 0
    const appliedSides = data.edgePreMillingInfo?.appliedSides ?? {
      right: 0,
      left: 0,
      top: 0,
      bottom: 0,
    }
    widthEdge += Number(appliedSides.right) + Number(appliedSides.left)
    heightEdge += Number(appliedSides.top) + Number(appliedSides.bottom)
    owidth += widthEdge
    oheight += heightEdge
    if (
      (Math.abs(width + left + right - owidth) > 0.1 ||
        Math.abs(height + top + bottom - oheight) > 0.1) &&
      !data.path
    ) {
      if (result.indexOf(roomName) === -1) {
        result.push(roomName)
      }
    }
  }
  return result
}

var plankKeysList

function getParam(obj, key, def) {
  if (obj !== undefined && obj !== null) {
    if (obj.hasOwnProperty(key)) {
      return obj[key]
    }
  }
  if (def !== undefined) {
    return def
  }
  return ''
}

// // 构造侧孔顺序
// function genSHoleInfo(sholes, isFront = true) {
//   var holeHash = {}
//   for (var i in sholes) {
//     var shole = sholes[i]
//     var side = shole['cSide'] ? shole['cSide'] : shole['side']

//     if (!holeHash.hasOwnProperty(side)) {
//       holeHash[side] = []
//     }

//     holeHash[side].push(shole)
//   }
//   let sholeInfo = isFront ? '' : '翻面'

//   if (isFront) {
//     Object.keys(holeHash).forEach(function (side, i) {
//       switch (side) {
//         case '1':
//           sholeInfo += i + 1 + '←'
//           break
//         case '2':
//           sholeInfo += i + 1 + '↓'
//           break
//         case '3':
//           sholeInfo += i + 1 + '→'
//           break
//         case '4':
//           sholeInfo += i + 1 + '↑'
//           break
//         default:
//           break
//       }
//     })
//   } else {
//     Object.keys(holeHash).forEach(function (side, i) {
//       switch (side) {
//         case '1':
//           sholeInfo += i + 1 + '←'
//           break
//         case '4':
//           sholeInfo += i + 1 + '↓'
//           break
//         case '3':
//           sholeInfo += i + 1 + '→'
//           break
//         case '2':
//           sholeInfo += i + 1 + '↑'
//           break
//         default:
//           break
//       }
//     })
//   }

//   return sholeInfo
// }
// // 构造侧槽顺序
// function genSSlotInfo(sslots, isFront = true) {
//   var slotHash = {}

//   for (var i in sslots) {
//     var sslot = sslots[i]
//     var side = sslot['cSide'] ? sslot['cSide'] : sslot['side']

//     if (!slotHash.hasOwnProperty(side)) {
//       slotHash[side] = []
//     }

//     slotHash[side].push(sslot)
//   }
//   let sslotInfo = isFront ? '' : '翻面'

//   if (isFront) {
//     Object.keys(slotHash).forEach(function (side, i) {
//       switch (side) {
//         case '1':
//           sslotInfo += i + 1 + '←'
//           break
//         case '2':
//           sslotInfo += i + 1 + '↓'
//           break
//         case '3':
//           sslotInfo += i + 1 + '→'
//           break
//         case '4':
//           sslotInfo += i + 1 + '↑'
//           break
//         default:
//           break
//       }
//     })
//   } else {
//     Object.keys(slotHash).forEach(function (side, i) {
//       switch (side) {
//         case '1':
//           sslotInfo += i + 1 + '←'
//           break
//         case '4':
//           sslotInfo += i + 1 + '↓'
//           break
//         case '3':
//           sslotInfo += i + 1 + '→'
//           break
//         case '2':
//           sslotInfo += i + 1 + '↑'
//           break
//         default:
//           break
//       }
//     })
//   }

//   return sslotInfo
// }

const CCW_REGION_ORDER = ['1', '2', '3', '4']

const SIDE_HOLE_SLOT_ARROW_BY_TYPE = {
  default: { 1: '←', 2: '↓', 3: '→', 4: '↑' },
  upDownFlip: { 1: '←', 4: '↓', 3: '→', 2: '↑' },
  leftRightFlip: { 3: '←', 2: '↓', 1: '→', 4: '↑' },
}

function getPlankSizeFromPart(part) {
  const width = Number(part?.oRect?.width ?? part?.rect?.width)
  const height = Number(part?.oRect?.height ?? part?.rect?.height)
  if (!width || !height) return null
  return { width, height }
}

function getHandleShapeBounds(shape) {
  if (!Array.isArray(shape) || !shape.length) return null
  let minX = Infinity
  let maxX = -Infinity
  let minY = Infinity
  let maxY = -Infinity
  for (let i = 0; i < shape.length; i++) {
    const p = shape[i]
    const x = Number(p.x ?? p.X)
    const y = Number(p.y ?? p.Y)
    if (Number.isNaN(x) || Number.isNaN(y)) continue
    minX = Math.min(minX, x)
    maxX = Math.max(maxX, x)
    minY = Math.min(minY, y)
    maxY = Math.max(maxY, y)
  }
  if (!Number.isFinite(minX)) return null
  return { minX, maxX, minY, maxY }
}

/** 暗拉手槽、牛角拉手外接矩形（板件坐标系） */
function getHandleTargetBounds(target) {
  const shapeBounds = getHandleShapeBounds(target?.shape)
  if (shapeBounds) {
    return shapeBounds
  }
  if (target?.pt1 && target?.pt2) {
    const x1 = Number(target.pt1.x)
    const x2 = Number(target.pt2.x)
    const y1 = Number(target.pt1.y)
    const y2 = Number(target.pt2.y)
    if ([x1, x2, y1, y2].some(Number.isNaN)) return null
    return {
      minX: Math.min(x1, x2),
      maxX: Math.max(x1, x2),
      minY: Math.min(y1, y2),
      maxY: Math.max(y1, y2),
    }
  }
  const pos = getHandleSlotPlanPositionFromCenter(target)
  if (!pos) return null
  return { minX: pos.x, maxX: pos.x, minY: pos.y, maxY: pos.y }
}

/** 暗拉手槽、牛角拉手在板件平面内的参考点 */
function getHandleSlotPlanPosition(target) {
  const bounds = getHandleTargetBounds(target)
  if (bounds) {
    return {
      x: (bounds.minX + bounds.maxX) / 2,
      y: (bounds.minY + bounds.maxY) / 2,
    }
  }
  return getHandleSlotPlanPositionFromCenter(target)
}

function getHandleSlotPlanPositionFromCenter(target) {
  if (target?.ocenter) {
    return {
      x: Number(target.ocenter.x),
      y: Number(target.ocenter.y),
    }
  }
  if (target?.center) {
    return {
      x: Number(target.center.x),
      y: Number(target.center.y),
    }
  }
  return null
}

const ADJACENT_CORNER_SIDES = {
  '1,2': true,
  '2,1': true,
  '2,3': true,
  '3,2': true,
  '3,4': true,
  '4,3': true,
  '4,1': true,
  '1,4': true,
}

/** 贴左/右时沿边长度为竖向跨度；贴下/上时为横向跨度 */
function getEdgeSpanLength(side, spanW, spanH) {
  if (side === '1' || side === '3') {
    return spanH
  }
  return spanW
}

function isAdjacentCornerSides(sideA, sideB) {
  return ADJACENT_CORNER_SIDES[`${sideA},${sideB}`] === true
}

/** 角落：比较贴两条邻边的沿边长度，更长的一侧为加工方位 */
function pickCornerSideByEdgeLength(sideA, sideB, spanW, spanH, distA, distB) {
  const lenA = getEdgeSpanLength(sideA, spanW, spanH)
  const lenB = getEdgeSpanLength(sideB, spanW, spanH)
  if (lenA > lenB) return sideA
  if (lenB > lenA) return sideB
  return distA <= distB ? sideA : sideB
}

/** 暗拉手槽 symbol === ALS */
function isAlsHandleSlot(target) {
  return target?.symbol === 'ALS'
}

/** 牛角拉手 millInfo（shape 路径，无槽 pt1/pt2） */
function isBullhornMillInfo(target) {
  return (
    Array.isArray(target?.shape) &&
    target.shape.length >= 2 &&
    !target?.pt1 &&
    !target?.pt2
  )
}

function isAlsOrMillInfoHandle(target) {
  return isAlsHandleSlot(target) || isBullhornMillInfo(target)
}

/**
 * 暗拉手槽、牛角拉手：按小板位置判定加工方位（逆时针 左→下→右→上）
 * 角落（如左下/右下）：比较贴两条邻边的沿边长度，更长的一侧为准（左下竖槽 → 1←）
 * 非角落：上下居中比左右 → 1/3；左右居中比上下 → 2/4
 */
function getHandleSlotRegionByCenterBias(target, plankWidth, plankHeight) {
  const bounds = getHandleTargetBounds(target)
  if (!bounds) return null

  const spanW = bounds.maxX - bounds.minX
  const spanH = bounds.maxY - bounds.minY
  const distList = [
    { side: '1', d: bounds.minX },
    { side: '2', d: plankHeight - bounds.maxY },
    { side: '3', d: plankWidth - bounds.maxX },
    { side: '4', d: bounds.minY },
  ].sort((a, b) => a.d - b.d)

  const nearest = distList[0]
  const second = distList[1]
  if (isAdjacentCornerSides(nearest.side, second.side)) {
    return pickCornerSideByEdgeLength(
      nearest.side,
      second.side,
      spanW,
      spanH,
      nearest.d,
      second.d
    )
  }

  const pos = {
    x: (bounds.minX + bounds.maxX) / 2,
    y: (bounds.minY + bounds.maxY) / 2,
  }
  const cx = plankWidth / 2
  const cy = plankHeight / 2
  const dx = Math.abs(pos.x - cx)
  const dy = Math.abs(pos.y - cy)

  if (dy <= dx) {
    return pos.x < cx ? '1' : '3'
  }
  const dTop = pos.y
  const dBottom = plankHeight - pos.y
  return dBottom < dTop ? '2' : '4'
}

function formatSideHoleSlotOrderFromSides(sidesPresent, type, flipPrefix = '') {
  const arrowMap =
    SIDE_HOLE_SLOT_ARROW_BY_TYPE[type] || SIDE_HOLE_SLOT_ARROW_BY_TYPE.default
  let targetInfo = flipPrefix
  let index = 0
  for (let i = 0; i < CCW_REGION_ORDER.length; i++) {
    const side = CCW_REGION_ORDER[i]
    if (sidesPresent.has(side)) {
      index++
      targetInfo += index + arrowMap[side]
    }
  }
  return targetInfo
}

/**
 * 暗拉手槽、牛角拉手按板面位置生成逆时针加工顺序
 * @param {Array} targets 暗拉手槽、牛角拉手
 * @param {Object} part 板件，需含 oRect 或 rect 宽高
 * @param {string} type 翻面类型：upDownFlip | leftRightFlip
 */
export function genAlsAndMillInfoCCWOrderByPosition(targets, part, type) {
  const handleTargets = (targets || []).filter((t) => isAlsOrMillInfoHandle(t))
  if (!handleTargets.length) return ''

  const size = getPlankSizeFromPart(part)
  const sidesPresent = new Set()
  const flipPrefix = type ? '翻面' : ''

  if (!size) {
    for (let i = 0; i < handleTargets.length; i++) {
      const side = String(handleTargets[i].cSide || handleTargets[i].side || '')
      if (CCW_REGION_ORDER.includes(side)) {
        sidesPresent.add(side)
      }
    }
    return formatSideHoleSlotOrderFromSides(sidesPresent, type, flipPrefix)
  }

  for (let i = 0; i < handleTargets.length; i++) {
    const side = getHandleSlotRegionByCenterBias(
      handleTargets[i],
      size.width,
      size.height
    )
    if (side) {
      sidesPresent.add(side)
    }
  }
  return formatSideHoleSlotOrderFromSides(sidesPresent, type, flipPrefix)
}

export function generatorSideHoleSlot(targets, type, part) {
  const positionTargets = []
  const sideTargets = []
  for (let i in targets) {
    const target = targets[i]
    if (isAlsOrMillInfoHandle(target)) {
      positionTargets.push(target)
    } else {
      sideTargets.push(target)
    }
  }

  const sidesPresent = new Set()
  for (let i = 0; i < sideTargets.length; i++) {
    const side = String(sideTargets[i].cSide || sideTargets[i].side || '')
    if (side) {
      sidesPresent.add(side)
    }
  }

  if (positionTargets.length) {
    const size = getPlankSizeFromPart(part)
    if (size) {
      for (let i = 0; i < positionTargets.length; i++) {
        const side = getHandleSlotRegionByCenterBias(
          positionTargets[i],
          size.width,
          size.height
        )
        if (side) {
          sidesPresent.add(side)
        }
      }
    } else {
      for (let i = 0; i < positionTargets.length; i++) {
        const side = String(
          positionTargets[i].cSide || positionTargets[i].side || ''
        )
        if (CCW_REGION_ORDER.includes(side)) {
          sidesPresent.add(side)
        }
      }
    }
  }

  const flipPrefix = type ? '翻面' : ''
  return formatSideHoleSlotOrderFromSides(sidesPresent, type, flipPrefix)
}

/**
 * 判断侧加工目标是孔还是槽
 * @param {Object} target
 * @returns {'hole' | 'slot'}
 */
function getSideHoleOrSlotType(target) {
  if (!target) return 'hole'
  if (target.type === 'sslot') return 'slot'
  if (target.type === 'shole') return 'hole'
  // 无 type 时：有 center 视为孔，否则视为槽
  return target.center ? 'hole' : 'slot'
}

/**
 * 同一边孔/槽展示文案：同边有槽则「槽」，否则「孔」
 * @param {Array} items
 * @returns {'孔' | '槽'}
 */
function getSideHoleSlotLabel(items) {
  const hasSlot = (items || []).some(
    (item) => getSideHoleOrSlotType(item) === 'slot'
  )
  return hasSlot ? '槽' : '孔'
}

/**
 * 逆时针方向生成侧孔侧槽信息
 * 以左边为起始边，逆时针方向查找起始边并生成箭头信息
 * @param {Array} targets 侧孔/侧槽数据
 * @param {boolean} rotateCCW 是否逆时针旋转90°，默认 true
 * @param {boolean | { showHoleSlotType?: boolean }} options
 *   - true 或 { showHoleSlotType: true }：返回带孔槽类型，如 1←孔2↓槽
 *   - 默认 false：保持旧格式，如 1←2↓
 *   同边既有孔又有槽时标「槽」
 */
export function genCCWSideHoleSlot(targets, rotateCCW = true, options = false) {
  const showHoleSlotType =
    options === true ||
    (options &&
      typeof options === 'object' &&
      options.showHoleSlotType === true)

  // 逆时针旋转90°映射：1→2, 2→3, 3→4, 4→1
  const ROTATE_CCW_MAP = { 1: '2', 2: '3', 3: '4', 4: '1' }
  const targetHash = {}
  for (let i in targets) {
    const target = targets[i]
    const rawSide = target['cSide'] ? target['cSide'] : target['side']
    const side = rotateCCW ? ROTATE_CCW_MAP[rawSide] || rawSide : rawSide
    if (!targetHash.hasOwnProperty(side)) {
      targetHash[side] = []
    }
    targetHash[side].push(target)
  }

  const SIDE_ARROW_MAP = { 1: '←', 2: '↓', 3: '→', 4: '↑' }
  // 逆时针顺序：左(1) → 下(2) → 右(3) → 上(4)
  const CCW_ORDER = ['1', '2', '3', '4']

  let startSide = '1'
  for (const side of CCW_ORDER) {
    if (targetHash.hasOwnProperty(side)) {
      startSide = side
      break
    }
  }

  const startIdx = CCW_ORDER.indexOf(startSide)
  let targetInfo = ''
  let index = 0
  for (let i = 0; i < 4; i++) {
    const side = CCW_ORDER[(startIdx + i) % 4]
    if (targetHash.hasOwnProperty(side)) {
      const arrow = SIDE_ARROW_MAP[side]
      const typeLabel = showHoleSlotType
        ? getSideHoleSlotLabel(targetHash[side])
        : ''
      targetInfo += index + 1 + arrow + typeLabel
      index++
    }
  }
  return targetInfo
}

// 值判断
function judgeUndefined(data) {
  if (!data) {
    return []
  }
  return data
}

/** 处理孔槽分流的加工设备值 */
export function dealProcessInEn(it) {
  const isProcessInEn = it.process_in_engraving
  const isProcessInEnTrun = it.process_in_engraving_to_turn
  const isProcessInAio = it.process_in_aio
  const isProcessInAioTurn = it.process_in_aio_to_turn
  it.process_in_engraving = isProcessInEnTrun
  it.process_in_engraving_to_turn = isProcessInEn
  it.process_in_aio = isProcessInAioTurn
  it.process_in_aio_to_turn = isProcessInAio
}

export function autoRollOver(plank, isAutoRoll) {
  if (store.state.ncSetting.custom_special_hole_slot_side.is_open) {
    specialRuleNormalHoleList.length = 0
    specialRuleNormalSlotList.length = 0
    matchNormalSlot.clear()
    matchNormalHole.clear()
    // 自定义特殊孔槽规则数组
    const { special_hole_slot_side } =
      store.state.ncSetting.custom_special_hole_slot_side
    //特殊孔槽自定义规则
    specialRuleMap = new Map()
    // 按优先级(索引由低到高)判断小板是否带有规则定义的特殊孔槽
    for (const obj of special_hole_slot_side) {
      const key = obj.key
      const value = obj.value === 'front' ? 1 : -1
      if (obj.type === 'hole') {
        specialRuleNormalHoleList.push({ rule: obj.rules, side: value })
      } else if (obj.type === 'slot') {
        specialRuleNormalSlotList.push({ rule: obj.rules, side: value })
      } else {
        specialRuleMap.set(key, value)
      }
    }
    // // 常规孔槽
    // for (const obj of normal_hole_slot_side) {
    //   const key = obj.key + obj.id
    //   const rules = obj.rules
    //   const value = obj.value === 'front' ? 1 : -1
    //   const info = {
    //     rules,
    //     value,
    //   }
    //   normalRuleMap.set(key, info)
    // }
  }
  var isNeed = iNeedRollOver(plank)

  // 当板件是高光板并且 high_gloss_side 不为0的情况才可进入自动翻面
  const isHighlightF =
    plank['is_high_gloss_plank'] && plank['high_gloss_side'] != 0
  // 孔槽集中面上下翻面
  const rollPlank = (plank) => {
    // 翻面板件
    recordTransform(plank, 'flipX', 0, 'autoRollOver')
    var rect = plank['rect']
    var realRect = plank['realRect']
    var holes = plank['holes']
    var sholes = plank['sholes']
    var slots = plank['slots']
    let handleSlopes = plank['handleSlopes'] ?? []
    var sslots = plank['sslots']
    var edgeInfo = plank['edgeInfo']
    var edgeTextureMap = plank['edge_texture_map']
    var thick = plank['thick']
    var oRect = plank['oRect']
    var oheight = oRect['height']
    var owidth = oRect['width']
    var curveHoles = plank['curveHoles']
    let millInfo = plank['millInfo'] ?? []
    var oriCurveHoles = plank['oriCurveHoles']
    let model_front_edge = plank['model_front_edge']
    let smoothEdge = plank['smoothEdge']
    let lightEdgeInfo = plank['lightEdgeInfo']
    let doorOpenSide = plank['doorOpenSide']
    let lineSlots = plank['lineSlots'] ?? []
    let edgePreMillingInfo = plank['edgePreMillingInfo']
    let edgeArrowMap = plank['edgeArrowMap']
    // 全部未打穿的孔槽
    const allNoThroughSlotHoles = [
      ...judgeUndefined(holes),
      ...judgeUndefined(slots),
      ...judgeUndefined(curveHoles),
      ...judgeUndefined(millInfo),
    ].filter((e) => e.deep * 1 + 0.001 < thick)
    // 是否全在同一面
    const isAllSameSide =
      allNoThroughSlotHoles.every((e) => e.side == 1) ||
      allNoThroughSlotHoles.every((e) => e.side == -1)
    // holes
    holes.forEach(function (it) {
      it.center = { x: it.center.x, y: rect.height - it.center.y }
      it.ocenter = { x: it.ocenter.x, y: oheight - it.ocenter.y }
      // 如果存在正反面都存在未打穿孔槽
      if (isAllSameSide) {
        it.side = -it.side
        dealProcessInEn(it)
      } else {
        if (
          it.deep * 1 + 0.001 < thick ||
          !store.state.ncSetting.throughHoleSlotSameSide ||
          it?.isFixedSide
        ) {
          it.side = -it.side
          dealProcessInEn(it)
        }
      }

      // 上下翻面，不修改上下两边孔的方向。
      const newHole = adjustHoleDirection(it, 0, 'flipX')
      Object.assign(it, newHole)
    })
    if (curveHoles) {
      curveHoles.forEach((item) => {
        item['path'].forEach((p) => {
          p.y = rect.height - p.y
        })
        item['native_path']?.forEach((p) => {
          p.y = rect.height - p.y
        })
        if (item.deep + 0.001 < thick) {
          item.side = -item.side
          dealProcessInEn(item)
        }
      })
    }
    //lineSlots
    lineSlots.forEach((it) => {
      it.path = it.path.map((v) => {
        v.y = rect.height - v.y
        dealLineSlotPointB(v)
        return v
      })
      it.oPath = it.oPath.map((v) => {
        v.y = oheight - v.y
        dealLineSlotPointB(v)
        return v
      })
      // oriPath 使用 realRect 坐标系
      if (it.oriPath) {
        it.oriPath = it.oriPath.map((v) => {
          v.y = realRect.height - v.y
          dealLineSlotPointB(v)
          return v
        })
      }
      it.side = -it.side
    })
    // 牛角槽
    if (millInfo) {
      const noThroughMill = millInfo.filter(
        (mill) => Number(mill.depth) + 0.001 < thick
      )
      let sameSide = noThroughMill[0] ? -noThroughMill[0].side : 0
      millInfo.forEach((item) => {
        item['shape'].forEach((p) => {
          p.y = oRect.height - p.y
        })
        if (sameSide) {
          item.side = sameSide
          dealProcessInEn(item)
        }
      })
    }

    if (oriCurveHoles) {
      oriCurveHoles.forEach((item) => {
        item['path'].forEach((p) => {
          p.y = oRect.height - p.y
        })
        item.side = -item.side
      })
    }

    sholes.forEach(function (shole) {
      var side = shole['side']
      var center = shole['center']
      var ocenter = shole['ocenter']

      switch (String(side)) {
        case '2':
          side = 4
          break
        case '4':
          side = 2
          break
      }
      center = {
        x: center.z - center.x,
        y: thick - center.y,
        z: center.z,
      }
      ocenter = { x: ocenter.x, y: oheight - ocenter.y }

      shole['side'] = side
      shole['center'] = center
      shole['ocenter'] = ocenter
    })

    // slots
    slots.forEach(function (it) {
      it.pt1 = { x: it.pt1.x, y: rect.height - it.pt1.y }
      it.opt1 = { x: it.opt1.x, y: oheight - it.opt1.y }
      it.pt2 = { x: it.pt2.x, y: rect.height - it.pt2.y }
      it.opt2 = { x: it.opt2.x, y: oheight - it.opt2.y }
      // oriPt1, oriPt2 使用 realRect 坐标系
      if (it.oriPt1) {
        it.oriPt1 = { x: it.oriPt1.x, y: realRect.height - it.oriPt1.y }
      }
      if (it.oriPt2) {
        it.oriPt2 = { x: it.oriPt2.x, y: realRect.height - it.oriPt2.y }
      }
      it.side = -it.side
      dealProcessInEn(it)
    })

    // handleSlopes
    // wc handleSlopes暂不加入孔槽集中面判断
    handleSlopes &&
      handleSlopes.forEach(function (it) {
        it.pt1 = { x: it.pt1.x, y: rect.height - it.pt1.y }
        it.opt1 = { x: it.opt1.x, y: oheight - it.opt1.y }
        it.pt2 = { x: it.pt2.x, y: rect.height - it.pt2.y }
        it.opt2 = { x: it.opt2.x, y: oheight - it.opt2.y }
        it.side = -it.side
      })

    // sslots
    sslots.forEach(function (sslot) {
      var side = sslot['side']
      var pt1 = sslot['pt1']
      var opt1 = sslot['opt1']
      var pt2 = sslot['pt2']
      var opt2 = sslot['opt2']

      switch (String(side)) {
        case '2':
          side = 4
          break
        case '4':
          side = 2
          break
      }
      // 在侧槽side不同面，z代表着板宽和板长
      // 侧槽的y代表在侧边的距上和距下的位置
      pt1 = {
        x: pt1.z - pt1.x,
        y: thick - pt1.y,
        z: pt1.z,
      }
      opt1 = { x: opt1.x, y: oheight - opt1.y }

      pt2 = {
        x: pt2.z - pt2.x,
        y: thick - pt2.y,
        z: pt2.z,
      }
      opt2 = { x: opt2.x, y: oheight - opt2.y }

      sslot['side'] = side
      sslot['pt1'] = pt1
      sslot['opt1'] = opt1
      sslot['pt2'] = pt2
      sslot['opt2'] = opt2
      if (sslot?.others?.obliqueSide) {
        sslot.others.obliqueSide = -sslot.others.obliqueSide
      }
    })

    // edgeInfo
    var left = edgeInfo.substring(
      edgeInfo.indexOf('←') + 1,
      edgeInfo.indexOf('↓')
    )
    var bottom = edgeInfo.substring(
      edgeInfo.indexOf('↓') + 1,
      edgeInfo.indexOf('→')
    )
    var right = edgeInfo.substring(
      edgeInfo.indexOf('→') + 1,
      edgeInfo.indexOf('↑')
    )
    var top = edgeInfo.substring(edgeInfo.indexOf('↑') + 1)
    edgeInfo = '←' + left + '↓' + top + '→' + right + '↑' + bottom // 左下右上 变成了左上右下 上下翻板
    // edge_texture_map - 按照与 edgeInfo 相同的上下翻板逻辑
    if (edgeTextureMap) {
      // 确保数组有4个元素，对应左、下、右、上
      var leftTexture = edgeTextureMap[1] || ''
      var bottomTexture = edgeTextureMap[2] || ''
      var rightTexture = edgeTextureMap[3] || ''
      var topTexture = edgeTextureMap[4] || ''

      // 按照上下翻板：左→左，下→上，右→右，上→下
      edgeTextureMap[1] = leftTexture // 新的左 = 原来的左
      edgeTextureMap[2] = topTexture // 新的下 = 原来的上
      edgeTextureMap[3] = rightTexture // 新的右 = 原来的右
      edgeTextureMap[4] = bottomTexture // 新的上 = 原来的下
    }
    // edgeArrowMap - 按照与 edgeInfo 相同的上下翻板逻辑
    // edgeInfo: ←left ↓top →right ↑bottom
    if (edgeArrowMap) {
      // 左、下、右、上
      let leftName = edgeArrowMap[0]
      let bottomName = edgeArrowMap[1]
      let rightName = edgeArrowMap[2]
      let topName = edgeArrowMap[3]

      edgeArrowMap[0] = leftName // 新的左 = 原来的左
      edgeArrowMap[1] = topName // 新的下 = 原来的上
      edgeArrowMap[2] = rightName // 新的右 = 原来的右
      edgeArrowMap[3] = bottomName // 新的上 = 原来的下
    }
    if (edgePreMillingInfo?.appliedSides) {
      const { left, right, top, bottom } = edgePreMillingInfo.appliedSides
      edgePreMillingInfo.appliedSides = {
        left: left,
        right: right,
        top: bottom,
        bottom: top,
      }
    }
    lightEdgeInfo = dealEdgeInfoChange(lightEdgeInfo, 'upDownFlip')
    model_front_edge = dealFormerEdgeChange(
      model_front_edge,
      'upDownFlip',
      'former'
    )
    smoothEdge = dealFormerEdgeChange(smoothEdge, 'upDownFlip', 'doorOpenSide')
    doorOpenSide = dealFormerEdgeChange(
      doorOpenSide,
      'upDownFlip',
      'doorOpenSide'
    )

    const sh = holes.filter((hole) => isOtherSideMachineHole(hole))
    const sl = slots.filter((slot) => isOtherSideMachineSlot(slot))
    let sholeInfo = generatorSideHoleSlot([
      ...sholes,
      ...sh.filter((h) => h.side == '1'),
    ])
    let sholeInfoF = generatorSideHoleSlot(
      sh.filter((h) => h.side == '-1'),
      'upDownFlip'
    )
    // 开启 侧孔机加工牛角拉手 需将牛角拉手放到侧槽信息里面
    let sideMillInfo = millInfo?.filter((mill) => isSideMachineMillInfo(mill))
    let sslotInfo = generatorSideHoleSlot(
      [
        ...sslots,
        ...sl.filter((l) => l.side == '1'),
        ...(sideMillInfo
          ? sideMillInfo?.filter((mill) => mill.side == '1')
          : []),
      ],
      '',
      plank
    )
    let sslotInfoF = generatorSideHoleSlot(
      sl.filter((l) => l.side == '-1'),
      'upDownFlip',
      plank
    )

    plank['holes'] = holes
    plank['slots'] = slots
    plank['sholes'] = sholes
    plank['sslots'] = sslots
    plank['edgeInfo'] = edgeInfo
    plank['edge_texture_map'] = edgeTextureMap
    plank['sholeInfo'] = sholeInfo
    plank['sholeInfoF'] = sholeInfoF
    plank['sslotInfo'] = sslotInfo
    plank['sslotInfoF'] = sslotInfoF
    plank['curveHoles'] = curveHoles
    plank['millInfo'] = millInfo
    plank['oriCurveHoles'] = oriCurveHoles
    plank['lightEdgeInfo'] = lightEdgeInfo
    plank['model_front_edge'] = model_front_edge
    plank['smoothEdge'] = smoothEdge
    plank['doorOpenSide'] = doorOpenSide
    plank['edgeArrowMap'] = edgeArrowMap

    // 交换plank的engraving_cut_curve和engraving_cut_curve_to_trunz
    ;[plank.engraving_cut_curve, plank.engraving_cut_curve_to_turn] = [
      plank.engraving_cut_curve_to_turn,
      plank.engraving_cut_curve,
    ]

    // path
    if (plank.hasOwnProperty('path')) {
      var o = { x: rect.width / 2, y: rect.height / 2 }

      var paths = plank['path']
      for (var i in paths) {
        var path = paths[i]
        for (var j in path) {
          var p = path[j]

          var x = p['x'] - o.x
          var y = p['y'] - o.y

          p['x'] = x + o.x
          p['y'] = -y + o.y
        }
      }
      plank['path'] = paths
    }

    // srcPath
    if (plank['srcPath'] && plank['srcPath'].length) {
      plank['srcPath'] = dealPathToBasePoint(flipPath(plank['srcPath']))
    }

    // oPath
    if (plank.hasOwnProperty('oPath')) {
      var o = { x: owidth / 2, y: oheight / 2 }

      var paths = plank['oPath']
      for (var i in paths) {
        var path = paths[i]
        for (var j in path) {
          var p = path[j]

          var x = p['x'] - o.x
          var y = p['y'] - o.y

          p['x'] = x * 1 + o.x
          p['y'] = -y + o.y
        }
      }
      plank['oPath'] = paths
    }

    // cutCurve
    if (plank['cutCurve'] && plank['cutCurve'].length) {
      var o = { x: rect.width / 2, y: rect.height / 2 }

      var lastB = -1000
      var cutCurve = plank['cutCurve']
      cutCurve.reverse()
      for (var j in cutCurve) {
        p = cutCurve[j]

        x = p['x'] - o.x
        y = p['y'] - o.y

        p['x'] = x + o.x
        p['y'] = -y + o.y

        var tmpB = lastB
        if (p.hasOwnProperty('b')) {
          lastB = p['b']
        } else {
          lastB = -1000
        }
        if (tmpB !== -1000) {
          p['b'] = tmpB
        } else {
          delete p['b']
        }
      }
      if (lastB !== -1000) {
        cutCurve[0]['b'] = lastB
      }

      var cutCurveEx = plank['cutCurveEx']
      for (var i in cutCurveEx) {
        var curveEx = cutCurveEx[i]
        lastB = -1000
        curveEx.reverse()
        for (var j in curveEx) {
          p = curveEx[j]

          x = p['x'] - o.x
          y = p['y'] - o.y

          p['x'] = x + o.x
          p['y'] = -y + o.y

          tmpB = lastB
          if (p.hasOwnProperty('b')) {
            lastB = p['b']
          } else {
            lastB = -1000
          }
          if (tmpB !== -1000) {
            p['b'] = tmpB
          } else {
            delete p['b']
          }
        }
        if (lastB !== -1000) {
          curveEx[0]['b'] = lastB
        }
      }
    }

    // realCurve
    if (plank['realCurve'] && plank['realCurve'].length) {
      var o = { x: owidth / 2, y: oheight / 2 }
      var lastB = -1000
      var path = plank['realCurve']
      path.reverse()
      for (var i in path) {
        var p = path[i]
        var x = p['x'] - o.x
        var y = p['y'] - o.y
        p['x'] = x * 1 + o.x
        p['y'] = -y + o.y

        var tmpB = lastB
        if (p.hasOwnProperty('b')) {
          lastB = p['b']
        } else {
          lastB = -1000
        }
        if (tmpB !== -1000) {
          p['b'] = tmpB
        } else {
          delete p['b']
        }
      }
      if (lastB !== -1000) {
        path[0]['b'] = lastB
      }
      plank['realCurve'] = path

      var realCurveEx = plank['realCurveEx']
      for (var i in realCurveEx) {
        var curveEx = realCurveEx[i]
        lastB = -1000
        curveEx.reverse()
        for (var j in curveEx) {
          p = curveEx[j]

          x = p['x'] - o.x
          y = p['y'] - o.y

          p['x'] = x + o.x
          p['y'] = -y + o.y

          tmpB = lastB
          if (p.hasOwnProperty('b')) {
            lastB = p['b']
          } else {
            lastB = -1000
          }
          if (tmpB !== -1000) {
            p['b'] = tmpB
          } else {
            delete p['b']
          }
          if (p.hasOwnProperty('side')) {
            if (p.depth * 1 + 0.001 < plank.thick) {
              p.side = -p.side
            }
          }
        }
        if (lastB !== -1000) {
          curveEx[0]['b'] = lastB
        }
      }
    }
    transformTextureGroup(plank, 'flipY', rollPlank)
  }
  if (isNeed && isAutoRoll && !isHighlightF) {
    rollPlank(plank)
  }
  /**
   * 高光板进行翻转
   */
  if (store.state.ncSetting.xyReverse) {
    if (plank['is_high_gloss_plank'] && plank['high_gloss_side'] > 0) {
      reversalPlank(plank)
    }
  } else {
    if (plank['is_high_gloss_plank'] && plank['high_gloss_side'] < 0) {
      reversalPlank(plank)
    }
  }
  dealSideForThroughHoleAndSlot(plank, store.state.ncSetting)
  forEachTextureChild(plank, (child) =>
    dealSideForThroughHoleAndSlot(child, store.state.ncSetting)
  )
  return plank
}

/** 特殊处理打穿孔槽所在面
 * 在自动翻版之后，针对于打穿的孔槽，单独生效特殊孔槽所在面等设置，
 */
function dealSideForThroughHoleAndSlot(part, ncSetting) {
  const { holes, slots, thick } = part
  const allThroughSlotHoles = [...holes, ...slots].filter(
    (it) => (it.deep ?? it.depth) * 1 + 0.001 >= thick && !it.isFixedSide
  )

  // 特殊孔槽
  /** 是否孔槽分流特殊孔槽优先正面 */
  const isShuntHoleSlotsFront = ncSetting.hs_on_front_aft_shunt
  /** 是否雕刻机仅下料或者仅加工正面 */
  const isEngravingShunt = ncSetting.ncHoleSlot !== 'doubleHoleSlot'
  /** 是否打穿孔槽更随未打穿 */
  const isFollowThroughHole = ncSetting.throughHoleSlotSameSide
  /** 是否开启特殊孔槽自定义加工面 */
  const isSpecialHoleSlotCustom =
    ncSetting.custom_special_hole_slot_side.is_open
  // 自定义特殊孔槽规则数组
  const { special_hole_slot_side } = ncSetting.custom_special_hole_slot_side

  if (!isFollowThroughHole) {
    if (isShuntHoleSlotsFront && isEngravingShunt) {
      allThroughSlotHoles.forEach((it) => {
        if (xyReverse) {
          if (it.side == 1) {
            it.side = -1
            dealProcessInEn(it)
          }
        } else {
          if (it.side == -1) {
            it.side = 1
            dealProcessInEn(it)
          }
        }
      })
    }
    if (isSpecialHoleSlotCustom) {
      allThroughSlotHoles.forEach((it) => {
        const isNeedRoll = judgeCustSpecialHoleAndSlot(
          [it],
          special_hole_slot_side
        )
        if (isNeedRoll && !xyReverse) {
          it.side *= -1
          dealProcessInEn(it)
        }
      })
    }

    // 如果上面两种都不满足，通孔通槽默认为正面
    if (
      !(isShuntHoleSlotsFront && isEngravingShunt) &&
      !isSpecialHoleSlotCustom
    ) {
      allThroughSlotHoles.forEach((it) => {
        if (xyReverse) {
          if (it.side == 1) {
            it.side = -1
            dealProcessInEn(it)
          }
        } else {
          if (it.side == -1) {
            it.side = 1
            dealProcessInEn(it)
          }
        }
      })
    }

    // TODO BHC 替换上面逻辑【待测试】
    // 如果上面两种都不满足，通孔通槽默认为正面，但是开启特殊规则通孔且不满足特殊规则的也要默认加工正面
    // if (!(isShuntHoleSlotsFront && isEngravingShunt)) {
    // allThroughSlotHoles.forEach((it) => {
    //   let normalRes = { state: false }
    //   if (isSpecialHoleSlotCustom) {
    //     const { special_hole_slot_side } =
    //       store.state.ncSetting.custom_special_hole_slot_side
    //     for (const obj of special_hole_slot_side) {
    //       let key = obj.key
    //       // 常规孔槽可以重复设置（索引后缀作为区分）特殊处理
    //       if (key.includes('normalHole') || key.includes('normalSlot')) {
    //         key = key.replace(/\d+$/, '')
    //       }
    //       // 判断规则是否存在 特殊孔槽的rules为 {}
    //       if (obj.type !== 'special' && obj.rules) {
    //         // 判断孔槽设置规则是否满足
    //         normalRes = judgeNormalSlotAndHole(
    //           obj.type,
    //           obj.rules,
    //           [{ diameter: it.diameter, side: it.side, symbol: it.symbol }]
    //         )
    //         console.log("normalRes", normalRes);
    //       }
    //     }
    //   }
    // if (!normalRes.state) {
    //   if (xyReverse) {
    //     it.side = -1
    //     dealProcessInEn(it)
    //   } else {
    //     it.side = 1
    //     dealProcessInEn(it)
    //   }
    // }
    // })
    // }
  }
}

/**
 * @desc 判断孔槽是否满足常规孔槽的规则
 * @param type hole | slot
 * @param rule 当前孔槽规则
 * @param plankHoleSoltInfos 当前板件的孔直径/槽长短边信息列表
 */
function judgeNormalSlotAndHole(type, rule, plankHoleSoltInfos) {
  let cn = 0
  if (type === 'hole') {
    const { compare, value } = rule
    const holeInfos = plankHoleSoltInfos.filter((it) => {
      if (
        (compare === 'gt' && it.diameter > value) ||
        (compare === 'lt' && it.diameter < value) ||
        (compare === 'eq' && it.diameter === Number(value))
      ) {
        cn += it.side
        return true
      }
    })
    // holeInfos长度为0说明没有满足条件的孔 cn的绝对值不等于满足常规孔规则的孔个数 则说明满足规则的孔正反面都有
    if (holeInfos.length === 0 || Math.abs(cn) !== holeInfos.length)
      return { state: false }

    holeInfos.forEach((it) => {
      matchNormalHole.set(it.diameter, it.side)
    })
    return { state: true, side: cn > 0 ? 1 : -1 }
  } else {
    const {
      long_side_compare,
      long_side_value,
      short_side_compare,
      short_side_value,
    } = rule
    const slotInfos = plankHoleSoltInfos.filter((it) => {
      let longCompareRes = !Boolean(long_side_compare)
      let shortCompareRes = !Boolean(short_side_compare)
      if (long_side_compare.trim()) {
        if (long_side_compare === 'gt') {
          if (it.long_side_value > long_side_value) {
            longCompareRes = true
          }
        }
        if (long_side_compare === 'lt') {
          if (it.long_side_value < long_side_value) {
            longCompareRes = true
          }
        }
        if (long_side_compare === 'eq') {
          if (it.long_side_value === Number(long_side_value)) {
            longCompareRes = true
          }
        }
      }
      if (short_side_compare.trim()) {
        if (short_side_compare === 'gt') {
          if (it.short_side_value > short_side_value) {
            shortCompareRes = true
          }
        }
        if (short_side_compare === 'lt') {
          if (it.short_side_value < short_side_value) {
            shortCompareRes = true
          }
        }
        if (short_side_compare === 'eq') {
          if (it.short_side_value === Number(short_side_value)) {
            shortCompareRes = true
          }
        }
      }
      if (longCompareRes && shortCompareRes) {
        cn += it.side
        return true
      }
      return false
    })
    if (slotInfos.length === 0 || Math.abs(cn) !== slotInfos.length) {
      return { state: false }
    }

    slotInfos.forEach((it) => {
      matchNormalSlot.set(
        `${it.long_side_value}/${it.short_side_value}`,
        it.side
      )
    })
    return { state: true, side: cn > 0 ? 1 : -1 }
  }
}
/**
 * @desc 判断自定义特殊孔槽的规则（未打穿孔槽） 优先级高于高光板外的情况
 * @param {Array} allNoThroughSlotHoles 全部未打穿的孔槽
 * @param {Array} special_hole_slot_side 特殊孔槽自定义规则
 * @author zhouchi 2024-08-27
 * @return {null || Boolean} 小板是否需要翻面
 * */
function judgeCustSpecialHoleAndSlot(
  allNoThroughSlotHoles,
  special_hole_slot_side
) {
  const strentchHingSetList = new Set([
    'STRENTCH',
    'STRENTCHTWO',
    'MIDSTRENTCH',
    'HINGE',
  ]) // 拉直槽和铰链孔
  // 将当前小板的孔槽插存储symbol和side的map中
  const holeSlotMap = new Map()
  // 存储重复槽/孔
  const repSet = new Set()
  // 存储孔直径->所在面
  const holeDiameterMap = new Map()
  // 存储槽长短边->所在面
  const slotLongShortMap = new Map()

  for (const it of allNoThroughSlotHoles) {
    // 若当前小板有同类型的孔且不在同一面,则进行标记 后续若命中规则其规则不生效
    let holeSlotName = it.symbol
    //   三合一大孔也是偏心孔
    if (it.holeType === 'bigHole' && it.symbol === '3in1Lock') {
      holeSlotName = 'CCPXHole'
    }
    // 遇到拉直器和铰链杯孔的时候全部重命名为straightener_slots_and_hinged_cup_holes
    if (strentchHingSetList.has(holeSlotName)) {
      holeSlotName = 'straightener_slots_and_hinged_cup_holes'
    }
    // 若当前小板有同类型的槽且不在同一面,则进行标记 后续若命中规则其规则不生效
    if (
      holeSlotMap.has(holeSlotName) &&
      holeSlotMap.get(holeSlotName) !== it.side
    ) {
      repSet.add(holeSlotName)
    }
    // 指的是指定的特殊孔槽 否则 说明当前是常规孔
    if (specialRuleMap.has(holeSlotName)) {
      holeSlotMap.set(holeSlotName, it.side)
    } else if (!custSpecialSet.has(holeSlotName) && !it?.shape && !it?.path) {
      const holeOrSlotInfo = {
        side: it.side,
        symbol: it.symbol,
      }
      let holeInfoList = holeSlotMap.get('normalHole')
      let slotInfoList = holeSlotMap.get('normalSlot')

      // 常规孔
      if (it.diameter) {
        // 孔直径
        holeOrSlotInfo.diameter = it.diameter
        // 避免重复 提高性能 (标记为0的孔表示正反面都有 忽略)
        if (
          holeDiameterMap.has(it.diameter) &&
          holeDiameterMap.get(it.diameter) === it.side
        ) {
          continue
        }
        holeDiameterMap.set(it.diameter, it.side)
        if (holeSlotMap.has('normalHole')) {
          holeInfoList.push(holeOrSlotInfo)
          continue
        }
        holeSlotMap.set('normalHole', [holeOrSlotInfo])
        continue
      }
      // 常规槽
      // 赋值槽长/短边
      it.length = it.length ?? Math.abs(it.pt1.x - it.pt2.x)
      holeOrSlotInfo.long_side_value = Math.max(it.length, it.width)
      holeOrSlotInfo.short_side_value = Math.min(it.length, it.width)

      // 槽长 短边组成的字符串
      const longShortStr = `${holeOrSlotInfo.long_side_value}/${holeOrSlotInfo.short_side_value}`
      // 避免重复 提高性能
      if (
        slotLongShortMap.has(longShortStr) &&
        holeDiameterMap.get(longShortStr) === it.side
      ) {
        continue
      }
      slotLongShortMap.set(longShortStr, it.side)
      if (holeSlotMap.has('normalSlot')) {
        slotInfoList.push(holeOrSlotInfo)
        continue
      }
      // 保存常规孔槽及其规则
      holeSlotMap.set('normalSlot', [holeOrSlotInfo])
    }
  }

  // // 存储通孔通槽
  // const throughSlotHoleSet = new Set()
  // // 是否存在打穿孔槽的情况
  // let isExistThrough = false
  // 存储孔槽至holeSlotMap和repSet

  // 按优先级(索引由低到高)判断小板是否带有规则定义的特殊孔槽
  for (const obj of special_hole_slot_side) {
    let key = obj.key
    // 常规孔槽可以重复设置（索引后缀作为区分） 所以特殊处理
    if (key.includes('normalHole') || key.includes('normalSlot')) {
      key = key.replace(/\d+$/, '')
    }
    const value = obj.value === 'front' ? 1 : -1
    // 若规则命中槽/孔为重复且不在同一面的情况 规则不生效
    if (repSet.has(key)) {
      continue
    }
    if (holeSlotMap.has(key)) {
      let normalRes = { state: false }
      // 判断规则是否存在 特殊孔槽的rules为 {}
      if (obj.type !== 'special' && obj.rules) {
        // 判断孔槽设置规则是否满足
        normalRes = judgeNormalSlotAndHole(
          obj.type,
          obj.rules,
          holeSlotMap.get(key)
        )
        if (!normalRes.state) continue
      }
      // 特殊
      if (typeof holeSlotMap.get(key) === 'number') {
        return holeSlotMap.get(key) !== value
      } else {
        // 常规
        return normalRes.side !== value
      }
    }
  }
  return null
}

/**
 * @desc 处理特殊孔槽规则下打穿孔槽的情况
 * @param allThroughSlotHoles 所有打穿孔槽
 */
function handleThrough(allThroughSlotHoles) {
  // 是否匹配到了特殊孔槽规则
  // 如果side为null 标表示未匹配到打穿孔槽的特殊规则 此时要按照优先级判断打穿的孔槽是否匹配到特殊规则
  // if (side === null || isRollOver === null) {
  //   for (const it of allThroughSlotHoles) {
  //     let holeSlotName = it.symbol
  //     //   三合一大孔也是偏心孔
  //     if (it.holeType === 'bigHole' && it.symbol === '3in1Lock') {
  //       holeSlotName = 'CCPXHole'
  //     }
  //     // 遇到拉直器和铰链杯孔的时候全部重命名为straightener_slots_and_hinged_cup_holes
  //     if (strentchHingSetList.has(holeSlotName)) {
  //       holeSlotName = 'straightener_slots_and_hinged_cup_holes'
  //     }
  //     if (holeSlotMap.has(holeSlotName)) {
  //       side = holeSlotMap.get(holeSlotName)
  //       break
  //     }
  //   }
  // }
  // if (side === null) return
  // 遍历所有的打穿孔槽并确定所在面

  for (const it of allThroughSlotHoles) {
    // 若当前小板有同类型的孔且不在同一面,则进行标记 后续若命中规则其规则不生效
    let holeSlotName = it.symbol
    //   三合一大孔也是偏心孔
    if (it.holeType === 'bigHole' && it.symbol === '3in1Lock') {
      holeSlotName = 'CCPXHole'
    }
    // 遇到拉直器和铰链杯孔的时候全部重命名为straightener_slots_and_hinged_cup_holes
    if (strentchHingSetList.has(holeSlotName)) {
      holeSlotName = 'straightener_slots_and_hinged_cup_holes'
    }
    if (specialRuleMap.has(holeSlotName)) {
      const side = specialRuleMap.get(holeSlotName)
      it.side = xyReverse ? -side : side
      // 有此标志的孔槽不受（只存在通孔通槽默认在大阪正面）规则的影响
      it.specialRuleFlag = true
    } // 标明当前孔槽满足特殊孔槽常规槽规则
    else if (it.type === 'slot' && !it?.shape) {
      for (const specialRuleNormalSlot of specialRuleNormalSlotList) {
        const {
          long_side_compare,
          long_side_value,
          short_side_compare,
          short_side_value,
        } = specialRuleNormalSlot.rule
        if (long_side_compare.trim()) {
          if (
            (long_side_compare === 'gt' && it.length > long_side_value) ||
            (long_side_compare === 'lt' && it.length < long_side_value) ||
            (long_side_compare === 'eq' &&
              it.length === Number(long_side_value))
          ) {
            it.side = xyReverse
              ? -specialRuleNormalSlot.side
              : specialRuleNormalSlot.side
            // 有此标志的孔槽不受（只存在通孔通槽默认在大阪正面）规则的影响
            it.specialRuleFlag = true
          } else {
            continue
          }
        }
        if (short_side_compare.trim()) {
          if (
            (short_side_compare === 'gt' && it.width > short_side_value) ||
            (short_side_compare === 'lt' && it.width < short_side_value) ||
            (short_side_compare === 'eq' &&
              it.width === Number(short_side_value))
          ) {
            it.side = xyReverse
              ? -specialRuleNormalSlot.side
              : specialRuleNormalSlot.side
            // 有此标志的孔槽不受（只存在通孔通槽默认在大阪正面）规则的影响
            it.specialRuleFlag = true
          } else {
            continue
          }
        }
        break
      }
    }
    // 标明当前孔槽满足特殊孔槽常规孔规则
    else if (it.type === 'hole' && !it?.shape) {
      for (const specialRuleNormalHole of specialRuleNormalHoleList) {
        const { value, compare } = specialRuleNormalHole.rule
        if (
          (compare === 'gt' && it.diameter > value) ||
          (compare === 'lt' && it.diameter < value) ||
          (compare === 'eq' && it.diameter === Number(value))
        ) {
          it.side = xyReverse
            ? -specialRuleNormalHole.side
            : specialRuleNormalHole.side
          // 有此标志的孔槽不受（只存在通孔通槽默认在大阪正面）规则的影响
          it.specialRuleFlag = true
          break
        }
      }
    }
  }
}

/** 检查孔槽在分流设置的状态 */

export function checkHoleSlotShuntStatus(hs, ncSetting, otherType = '') {
  /** 翻面加工是否在雕刻机 */
  const isProcessInEnTrun = hs.process_in_engraving_to_turn
  /** 当前面是否在雕刻机 */
  const isProcessInEn = hs.process_in_engraving

  /** 分流设置 */
  const holeSlotShuntSetting = ncSetting.hole_slot_engraving_process
  /** 所有的特殊孔槽*/
  const shuntKeys = Object.keys(holeSlotShuntSetting.special_hole_slot)
  /** 勾选状态的特殊孔槽key */
  const checkedShuntKeys = shuntKeys.filter((it) => {
    return holeSlotShuntSetting.special_hole_slot[it]
  })
  // 判断特殊数据处理
  if (otherType) {
    switch (otherType) {
      case 'millInfo':
        return (
          checkedShuntKeys.length &&
          checkedShuntKeys.includes('bull_horn_handle')
        )
      case 'haitangCorner':
        return (
          checkedShuntKeys.length && checkedShuntKeys.includes('haitang_corner')
        )
      default:
        return false
    }
  }
  return isProcessInEn || isProcessInEnTrun
  /** 存在疑问的逻辑，暂存、不处理 */

  /** 是否是门板 */
  const plankType = plank['type']
  const isDoorPlank =
    plankType &&
    (String(plankType).includes('door') || String(plankType).includes('Door'))
  /** 判断是孔还是槽 */
  const hsType = hs.center ? 'hole' : 'slot'

  /** 孔槽的类型标识 */
  const currentSymbol = hs.symbol
  /** 孔槽范围判断 */
  function checkHoleSlotRange() {
    const holeRangeArr = holeSlotShuntSetting.engraving_holes_range
    const slotRangeArr = holeSlotShuntSetting.engraving_slots_range
    const deep = hs.depth ?? hs.deep
    if (hsType === 'hole') {
      const isInHoleRange = holeRangeArr.some((it) => {
        const isInDeepRange = it.maxDepth > deep && it.minDepth < deep
        const isInDiameterRange =
          it.maxDiameter > hs.diameter && it.minDiameter < hs.diameter
        return isInDeepRange && isInDiameterRange
      })
      return isInHoleRange
    } else {
      const isInSlotRange = slotRangeArr.some((it) => {
        const isInDeepRange = it.maxDepth > deep && it.minDepth < deep
        const isInWidthRange = it.maxWidth > hs.width && it.minWidth < hs.width
        return isInDeepRange && isInWidthRange
      })
      return isInSlotRange
    }
  }
  /** 孔槽分流的设置 仅下料(noHoleSlot)、仅加工正面(frontHoleSlot)、正反面加工(doubleHoleSlot) */
  const engravingShunt = ncSetting.ncHoleSlot
  // 逻辑：在仅下料情况下，只要有在开料机加工就算分流的特殊孔槽，其他情况下
  // side 为反面且当前面在开料机加工就算分流特殊空槽，
  // side 为正面且翻面在开料机加工就算分流特殊孔槽

  // 判断特殊数据处理
  if (otherType) {
    switch (otherType) {
      case 'millInfo':
        return (
          checkedShuntKeys.length &&
          checkedShuntKeys.includes('bull_horn_handle')
        )
      case 'haitang':
        return (
          checkedShuntKeys.length && checkedShuntKeys.includes('haitang_corner')
        )
      default:
        return false
    }
  }

  if (engravingShunt == 'noHoleSlot') {
    return isProcessInEn || isProcessInEnTrun
  } else if (
    engravingShunt == 'frontHoleSlot' &&
    ((checkedShuntKeys.length && checkedShuntKeys.includes(currentSymbol)) ||
      checkHoleSlotRange())
  ) {
    if (currentSymbol == 'METAL') {
      if (isDoorPlank) {
        return checkedShuntKeys.includes('METALINNER')
      } else if (!isDoorPlank) {
        return false
      }
    }
    return true
  } else {
    return false
  }
}

function iNeedRollOver(plank) {
  /** 正面拉槽数量 */
  let FS = 0
  /** 反面拉槽数量 */
  let BS = 0
  /** 正面孔数量 */
  let FH = 0
  /** 反面孔数量 */
  let BH = 0
  /** 铰链孔数量 */
  let hingeNum = 0
  /** 拉直器数量 */
  let strentchNum = 0
  /** 拉直槽symble */
  const strentchList = ['STRENTCH', 'STRENTCHTWO', 'MIDSTRENTCH']
  /** 是否过滤直弧槽 */
  const shouldFilterArcStraightSlot =
    ncSettings.singleFileSetting?.processTypes.includes('arcStraightSlot')
  /** 所有的孔 */
  const holes = plank['holes'] ?? []
  /** 拉线槽 */
  const lineSlots = plank['lineSlots'] ?? []
  /** 所有的槽 */
  const slots = shouldFilterArcStraightSlot
    ? [...plank['slots'], ...lineSlots].filter(
        (slot) => slot.symbol !== 'arcStraightSlot'
      )
    : [...plank['slots'], ...lineSlots]
  /** 小板厚度 */
  const thick = plank['thick'] ?? 0
  /** 所有的异形孔 */
  const curveHoles = plank['curveHoles'] ?? []
  /** 斜封边拉手槽 */
  const handleSlopes = plank['handleSlopes'] ?? []
  /** 牛角槽 */
  const millInfo = plank['millInfo']
    ? plank['millInfo'].filter((mill) => Number(mill.depth) + 0.001 < thick)
    : []

  /** 是否孔槽分流特殊孔槽优先正面 */
  const isShuntHoleSlotsFront = ncSettings.hs_on_front_aft_shunt
  /** 是否雕刻机仅下料或者仅加工正面 */
  const isEngravingShunt = ncSettings.ncHoleSlot !== 'doubleHoleSlot'

  /** 是否异形孔在雕刻机上加工 */
  const isCurveHolesProcessInEngraving =
    plank.process_in_engraving_to_curve ?? false

  var changedValue = 0
  /** 通孔分两次打穿 */
  const throughTowSideToCut = ncSettings.throughTowSideToCut
  /** 是否xy轴互换 */
  const xyReverse = ncSettings.xyReverse
  const {
    /** 孔集中面 */
    holeConcentrated,
    /** 槽集中面 */
    apertureSlotConcentrated,
    /** 按比例分配 */
    prorate_holes_slots_of_both_side,
    /** 是否组合设备 */
    combinationEquip,
  } = ncSettings
  // TODO wc 意义不明的老代码
  // var dock5FDrill = ncSettings.dock5FDrill
  // var dock6FDrill = ncSettings.dock6FDrill
  // xyReverse = xyReverse & !(dock5FDrill || dock6FDrill)

  //xy互换时的数据统计 穿孔穿槽XY互换时反面孔/槽数量 + n 没有开启XY互换是正面 孔/槽数量 + n 为什么XY互换后穿孔穿槽在反面呢 标记
  // const holeSlotSideStatisticRe = (hsData, type = 'holes') => {
  //   hsData.forEach((it) => {
  //     if (xyReverse) {
  //       it.side = -1
  //       type == 'holes' ? BH++ : BS++
  //     } else {
  //       it.side = 1
  //       type == 'holes' ? FH++ : FS++
  //     }
  //   })
  // }

  // if (holeAllPenetrate && slotAllPenetrate && curveHolesAllPenetrate) {
  //   holeSlotSideStatisticRe(curveHoles, 'holes')
  //   // holeSlotSideStatisticRe(handleSlopes, 'slots')
  //   holeSlotSideStatisticRe(millInfo, 'slots')
  //   holeSlotSideStatisticRe(slots, 'slots')
  //   holeSlotSideStatisticRe(holes)
  //   return
  // }
  // 如果孔槽集中面在正面，此时大部分孔都在正面，但是XY互换导致翻面，此时孔槽集中面其实就在反面了，但是我们得保证孔槽集中面在正面！所以得在翻面前将孔槽统计对立面去！翻面后就仍孔槽集中面就仍然在正面了
  const holeSlotSideStatistic = (data, type = 'holes') => {
    data.forEach((it) => {
      // 如果开启过滤直弧槽且当前是槽类型，则跳过 arcStraightSlot
      if (
        shouldFilterArcStraightSlot &&
        type === 'slots' &&
        it.symbol === 'arcStraightSlot'
      )
        return
      if (Number(it.deep ?? it.depth) * 1 + 0.001 >= thick && !it.isFixedSide)
        return
      // 若孔为铰链孔，则铰链孔+1
      if (it.symbol && it.symbol == 'HINGE') hingeNum++
      if (it.symbol && strentchList.includes(it.symbol)) strentchNum++
      if (!xyReverse) {
        if (it.side > 0) type == 'holes' ? FH++ : FS++
        if (it.side < 0) type == 'holes' ? BH++ : BS++
      } else {
        if (it.side > 0) type == 'holes' ? BH++ : BS++
        if (it.side < 0) type == 'holes' ? FH++ : FS++
      }
    })
  }
  /** 开启分流特殊孔槽优先正面时，需要进行单独的统计操作 */
  const shuntHoleSlotStatistic = (
    data,
    type = 'holes',
    statisticObj,
    otherType = ''
  ) => {
    data.forEach((it) => {
      // 如果开启过滤直弧槽且当前是槽类型，则跳过 arcStraightSlot
      if (
        shouldFilterArcStraightSlot &&
        type === 'slots' &&
        it.symbol === 'arcStraightSlot'
      )
        return
      // 若孔为铰链孔，则铰链孔+1
      if (it.symbol && it.symbol == 'HINGE') hingeNum++
      if (it.symbol && strentchList.includes(it.symbol)) strentchNum++
      /** 是否设置的特殊孔槽分流 */
      const isSpecialShunt = checkHoleSlotShuntStatus(
        it,
        store.state.ncSetting,
        otherType
      )
      // 如果有一面在雕刻机上面加工，则正常统计正反面孔槽，双面都不在雕刻机上加工的不统计
      if (isSpecialShunt) {
        // 判断xy轴互换的目的是正反对调统计，使板件正常翻转，满足设置条件
        if (!xyReverse) {
          if (it.side > 0)
            type == 'holes' ? statisticObj.fh++ : statisticObj.fs++
          if (it.side < 0)
            type == 'holes' ? statisticObj.bh++ : statisticObj.bs++
        } else {
          if (it.side > 0)
            type == 'holes' ? statisticObj.bh++ : statisticObj.bs++
          if (it.side < 0)
            type == 'holes' ? statisticObj.fh++ : statisticObj.fs++
        }
      }
    })

    return statisticObj
  }

  // 所有未打穿孔槽
  let allNoThroughSlotHoles = []
  // 所用打穿孔槽
  let allThroughSlotHoles = []
  // 打穿的孔槽且固定面加工
  let allFixedSideSlotHoles = []
  const allSlotHole = [...holes, ...slots, ...curveHoles, ...millInfo]
  allSlotHole.forEach((e) => {
    if ((e.deep ?? e.depth) * 1 + 0.001 < thick) {
      allNoThroughSlotHoles.push(e)
    } else {
      if (!e.isFixedSide) {
        allThroughSlotHoles.push(e)
      } else {
        allFixedSideSlotHoles.push(e)
      }
    }
  })
  // 是否有未打穿的孔槽
  const hasNoThroughSlotHole = Boolean(allNoThroughSlotHoles.length)
  // 是否全在同一面
  const isAllSameSide =
    allNoThroughSlotHoles.every((e) => e.side == 1) ||
    allNoThroughSlotHoles.every((e) => e.side == -1)
  // 1 都在正面 -1 都在反面 0 都有
  let sameSideValue = allNoThroughSlotHoles.every((e) => e.side == 1)
    ? 1
    : allNoThroughSlotHoles.every((e) => e.side == -1)
    ? -1
    : 0
  const dealSameValue = (data, side) => {
    data.forEach(function (it) {
      if (Number(it.deep ?? it.depth) * 1 + 0.001 >= thick && !it.isFixedSide) {
        if (side !== it.side) {
          dealProcessInEn(it)
        }
        it.side = side
        // 若孔槽都在同一个面且勾选打穿孔槽所在面跟随该小板上未穿孔槽，则所有打穿的孔槽都在某一面
        if (store.state.ncSetting.throughHoleSlotSameSide && isAllSameSide) {
          it.side = sameSideValue
          if (sameSideValue !== it.side) {
            dealProcessInEn(it)
          }
          if (!hasNoThroughSlotHole) {
            it.side = side
            if (side !== it.side) {
              dealProcessInEn(it)
            }
          }
        }
      }
    })
  }

  function dealHoleSlotsSide(side = 1) {
    dealSameValue(
      holes.filter((item) => item.symbol !== 'Corner_LML'),
      side
    )
    dealSameValue(slots, side)
    dealSameValue(curveHoles, side)
    // dealSameValue(handleSlopes, side)
    dealSameValue(millInfo, side)
  }
  dealHoleSlotsSide()

  // 如果开启分流特殊孔槽优先正面，则只统计雕刻机加工孔槽正反，否则正常逻辑统计正反
  // fs、fh、bs、bh 同上方大写统计数据
  const statisticObj = { fs: 0, fh: 0, bs: 0, bh: 0 }
  if (isShuntHoleSlotsFront && !combinationEquip) {
    shuntHoleSlotStatistic(holes, 'holes', statisticObj)
    shuntHoleSlotStatistic(slots, 'slots', statisticObj)
    shuntHoleSlotStatistic(millInfo, 'slots', statisticObj, 'millInfo')
    shuntHoleSlotStatistic(curveHoles, 'holes', statisticObj, 'curveHoles')
    // TODO wc 海棠角的处理
    // shuntHoleSlotStatistic(
    //   handleSlopes.filter((slo) => slo.symbol == 'haitangCorner'),
    //   'slots',
    //   statisticObj,
    //   'haitangCorner'
    // )
    // 海棠角、斜封边拉手同处理
    shuntHoleSlotStatistic(handleSlopes, 'slots', statisticObj)
    if (isCurveHolesProcessInEngraving) {
      curveHoles.forEach((it) => {
        // 若孔为铰链孔，则铰链孔+1
        if (it.symbol && it.symbol == 'HINGE') hingeNum++
        if (it.symbol && strentchList.includes(it.symbol)) strentchNum++
        if (!xyReverse) {
          if (it.side > 0) statisticObj.fh++
          if (it.side < 0) statisticObj.bh++
        } else {
          if (it.side > 0) statisticObj.bh++
          if (it.side < 0) statisticObj.fh++
        }
      })
    }
  }

  holeSlotSideStatistic(holes, 'holes')
  holeSlotSideStatistic(slots, 'slots')
  // holeSlotSideStatistic(handleSlopes, 'slots')
  holeSlotSideStatistic(millInfo, 'slots')
  holeSlotSideStatistic(curveHoles, 'holes')

  const { fs, fh, bs, bh } = statisticObj
  // 如果开启分流特殊孔槽优先正面且没有开启按比例分配就使用分流数据
  plank['needRoll'] =
    isShuntHoleSlotsFront &&
    !combinationEquip &&
    Boolean(fs + fh + bs + bh) &&
    (fs != bs || fh != bh) &&
    !prorate_holes_slots_of_both_side
      ? Boolean(fs + fh && bs + bh)
      : Boolean(FS + FH && BS + BH)
  // 打开自定义特殊孔槽的情况并且不是高光板
  if (
    store.state.ncSetting.custom_special_hole_slot_side.is_open &&
    !(plank['is_high_gloss_plank'] && plank['high_gloss_side'] != 0)
  ) {
    // 最后处理未打穿孔槽未匹配到特殊孔槽规则 但是 通孔通槽匹配到特殊看规则的情况
    Promise.resolve().then(() => {
      handleThrough(allThroughSlotHoles)
    })
    // 自定义特殊孔槽规则数组
    const { special_hole_slot_side } =
      store.state.ncSetting.custom_special_hole_slot_side
    // 如果xy互换,此时已经需要把孔槽全部翻转到对应面,所以我们这的翻转逻辑需要逆思考
    // allNoThroughSlotHoles

    const isRollOver = judgeCustSpecialHoleAndSlot(
      [...allNoThroughSlotHoles, ...allFixedSideSlotHoles],
      special_hole_slot_side
    )
    if (isRollOver !== null) {
      return xyReverse ? !isRollOver : isRollOver
    }
  }
  if (prorate_holes_slots_of_both_side) {
    return false
  } else if (
    isShuntHoleSlotsFront &&
    !combinationEquip &&
    isEngravingShunt &&
    (Boolean(bs + bh) || Boolean(fs + fh))
  ) {
    // 正面槽和反面槽相同时，判断正反面孔数量，反面多就需要翻，一样多和正面多不翻
    if (fs == bs) {
      return fh < bh
    } else {
      // 正反面槽数量不同时，反面槽多就需要翻
      return fs < bs
    }
  } else if (FS == BS) {
    // 如果槽正反面数量一致, 则只需要考虑孔的分布情况
    // 孔槽集中面在反面
    if (store.state.ncSetting.holeConcentrated == 'back') {
      if (FH > BH) return true
    } else {
      // 孔槽集中面是正面 正面孔数量小于反面孔的数量
      if (FH < BH) return true
    }
  } else {
    // 如果槽正反面数量不一致, 则只需要考虑槽的分布情况
    if (store.state.ncSetting.apertureSlotConcentrated == 'back') {
      if (FS > BS) return true
    } else {
      if (FS < BS) return true
    }
  }
  return false
}

// 提取上面的方法  翻转单个板件
export function reversalPlank(plank) {
  recordTransform(plank, 'flipX', 0, 'reversalPlank')
  var rect = plank['rect']
  var realRect = plank['realRect']
  var holes = plank['holes']
  var sholes = plank['sholes']
  var slots = plank['slots']
  let handleSlopes = plank['handleSlopes'] ?? []
  var sslots = plank['sslots']
  var edgeInfo = plank['edgeInfo']
  var edgeTextureMap = plank['edge_texture_map']
  var thick = plank['thick']
  var oRect = plank['oRect']
  var oheight = oRect['height']
  var owidth = oRect['width']
  var curveHoles = plank['curveHoles']
  let millInfo = plank['millInfo']
  var oriCurveHoles = plank['oriCurveHoles']
  let model_front_edge = plank['model_front_edge']
  let smoothEdge = plank['smoothEdge']
  let lightEdgeInfo = plank['lightEdgeInfo']
  const lineSlots = plank['lineSlots'] ?? []
  // 获取门板开启方向
  let doorOpenSide = plank['doorOpenSide']
  let edgeArrowMap = plank['edgeArrowMap']

  // 交换板件的正反面雕刻路径
  ;[plank.engraving_cut_curve, plank.engraving_cut_curve_to_turn] = [
    plank.engraving_cut_curve_to_turn,
    plank.engraving_cut_curve,
  ]

  // 线槽处理
  lineSlots.forEach((it) => {
    it.path = it.path.map((v) => {
      v.y = rect.height - v.y
      dealLineSlotPointB(v)
      return v
    })
    it.oPath = it.oPath.map((v) => {
      v.y = oheight - v.y
      dealLineSlotPointB(v)
      return v
    })
    it.side = -it.side
  })
  // holes
  holes.forEach(function (it) {
    it.center = { x: it.center.x, y: rect.height - it.center.y }
    it.ocenter = { x: it.ocenter.x, y: oheight - it.ocenter.y }
    it.side = -it.side
    // 上下翻面
    const newHole = adjustHoleDirection(it, 0, 'flipX')
    Object.assign(it, newHole)
    dealProcessInEn(it)
  })

  if (curveHoles) {
    curveHoles.forEach((item) => {
      item['path'].forEach((p) => {
        p.y = rect.height - p.y
      })
      item['native_path']?.forEach((p) => {
        p.y = rect.height - p.y
      })
      item.side = -item.side
    })
  }
  if (millInfo) {
    millInfo.forEach((item) => {
      const path = item['shape']
      path.forEach((p) => {
        p.y = oRect.height - p.y
      })
      item.side = -item.side
    })
  }

  if (oriCurveHoles) {
    oriCurveHoles.forEach((item) => {
      item['path'].forEach((p) => {
        p.y = oRect.height - p.y
      })
      item.side = -item.side
    })
  }

  sholes.forEach(function (shole) {
    var side = shole['side']
    var center = shole['center']
    var ocenter = shole['ocenter']

    switch (String(side)) {
      case '2':
        side = 4
        break
      case '4':
        side = 2
        break
    }
    center = {
      x: (center.z ? center.z : 0) - center.x,
      y: thick - center.y,
      z: center.z ? center.z : 0,
    }
    ocenter = { x: ocenter.x, y: oheight - ocenter.y }

    shole['side'] = side
    shole['center'] = center
    shole['ocenter'] = ocenter
  })

  // slots
  slots.forEach(function (it) {
    it.pt1 = { x: it.pt1.x, y: rect.height - it.pt1.y }
    it.opt1 = { x: it.opt1.x, y: oheight - it.opt1.y }
    it.pt2 = { x: it.pt2.x, y: rect.height - it.pt2.y }
    it.opt2 = { x: it.opt2.x, y: oheight - it.opt2.y }
    // oriPt1, oriPt2 使用 realRect 坐标系
    if (it.oriPt1) {
      it.oriPt1 = { x: it.oriPt1.x, y: realRect.height - it.oriPt1.y }
    }
    if (it.oriPt2) {
      it.oriPt2 = { x: it.oriPt2.x, y: realRect.height - it.oriPt2.y }
    }
    it.side = -it.side
    dealProcessInEn(it)
  })

  // handleSlopes
  handleSlopes.forEach(function (it) {
    it.pt1 = { x: it.pt1.x, y: rect.height - it.pt1.y }
    it.opt1 = { x: it.opt1.x, y: oheight - it.opt1.y }
    it.pt2 = { x: it.pt2.x, y: rect.height - it.pt2.y }
    it.opt2 = { x: it.opt2.x, y: oheight - it.opt2.y }
    it.side = -it.side
  })

  // sslots
  sslots.forEach(function (sslot) {
    var side = sslot['side']
    var pt1 = sslot['pt1']
    var opt1 = sslot['opt1']
    var pt2 = sslot['pt2']
    var opt2 = sslot['opt2']

    switch (String(side)) {
      case '2':
        side = 4
        break
      case '4':
        side = 2
        break
    }

    pt1 = {
      x: pt1.z - pt1.x,
      y: pt1.y,
      z: pt1.z,
    }
    opt1 = { x: opt1.x, y: oheight - opt1.y }

    pt2 = {
      x: pt2.z - pt2.x,
      y: pt2.y,
      z: pt2.z,
    }
    opt2 = { x: opt2.x, y: oheight - opt2.y }

    sslot['side'] = side
    sslot['pt1'] = pt1
    sslot['opt1'] = opt1
    sslot['pt2'] = pt2
    sslot['opt2'] = opt2
    if (sslot?.others?.obliqueSide) {
      sslot.others.obliqueSide = -sslot.others.obliqueSide
    }
  })

  // edgeInfo
  var left = edgeInfo.substring(
    edgeInfo.indexOf('←') + 1,
    edgeInfo.indexOf('↓')
  )
  var bottom = edgeInfo.substring(
    edgeInfo.indexOf('↓') + 1,
    edgeInfo.indexOf('→')
  )
  var right = edgeInfo.substring(
    edgeInfo.indexOf('→') + 1,
    edgeInfo.indexOf('↑')
  )
  var top = edgeInfo.substring(edgeInfo.indexOf('↑') + 1)
  edgeInfo = '←' + left + '↓' + top + '→' + right + '↑' + bottom // 左下右上 变成了 左上右下 上下翻板

  // edge_texture_map - 按照与 edgeInfo 相同的上下翻板逻辑
  if (edgeTextureMap) {
    // 确保数组有4个元素，对应左、下、右、上
    var leftTexture = edgeTextureMap[1] || ''
    var bottomTexture = edgeTextureMap[2] || ''
    var rightTexture = edgeTextureMap[3] || ''
    var topTexture = edgeTextureMap[4] || ''

    // 按照上下翻板：左→左，下→上，右→右，上→下
    edgeTextureMap[1] = leftTexture // 新的左 = 原来的左
    edgeTextureMap[2] = topTexture // 新的下 = 原来的上
    edgeTextureMap[3] = rightTexture // 新的右 = 原来的右
    edgeTextureMap[4] = bottomTexture // 新的上 = 原来的下
  }

  // edgeArrowMap - 按照与 edgeInfo 相同的上下翻板逻辑
  // edgeInfo: ←left ↓top →right ↑bottom
  if (edgeArrowMap) {
    // 左、下、右、上
    let leftName = edgeArrowMap[0]
    let bottomName = edgeArrowMap[1]
    let rightName = edgeArrowMap[2]
    let topName = edgeArrowMap[3]

    edgeArrowMap[0] = leftName // 新的左 = 原来的左
    edgeArrowMap[1] = topName // 新的下 = 原来的上
    edgeArrowMap[2] = rightName // 新的右 = 原来的右
    edgeArrowMap[3] = bottomName // 新的上 = 原来的下
  }

  lightEdgeInfo = dealEdgeInfoChange(lightEdgeInfo, 'upDownFlip')
  model_front_edge = dealFormerEdgeChange(
    model_front_edge,
    'upDownFlip',
    'former'
  )
  smoothEdge = dealFormerEdgeChange(smoothEdge, 'upDownFlip', 'doorOpenSide')
  doorOpenSide = dealFormerEdgeChange(
    doorOpenSide,
    'upDownFlip',
    'doorOpenSide'
  )

  const sh = holes.filter((hole) => isOtherSideMachineHole(hole))
  const sl = slots.filter((slot) => isOtherSideMachineSlot(slot))
  let sholeInfo = generatorSideHoleSlot([
    ...sholes,
    ...sh.filter((h) => h.side == '1'),
  ])
  let sholeInfoF = generatorSideHoleSlot(
    sh.filter((h) => h.side == '-1'),
    'upDownFlip'
  )
  // 开启 侧孔机加工牛角拉手 需将牛角拉手放到侧槽信息里面
  let sideMillInfo = millInfo?.filter((mill) => isSideMachineMillInfo(mill))
  let sslotInfo = generatorSideHoleSlot(
    [
      ...sslots,
      ...sl.filter((l) => l.side == '1'),
      ...(sideMillInfo ? sideMillInfo?.filter((mill) => mill.side == '1') : []),
    ],
    '',
    plank
  )
  let sslotInfoF = generatorSideHoleSlot(
    sl.filter((l) => l.side == '-1'),
    'upDownFlip',
    plank
  )

  plank['holes'] = holes
  plank['slots'] = slots
  plank['sholes'] = sholes
  plank['sslots'] = sslots
  plank['edgeInfo'] = edgeInfo
  plank['edge_texture_map'] = edgeTextureMap
  plank['sholeInfo'] = sholeInfo
  plank['sholeInfoF'] = sholeInfoF
  plank['sslotInfo'] = sslotInfo
  plank['sslotInfoF'] = sslotInfoF
  plank['lightEdgeInfo'] = lightEdgeInfo
  plank['model_front_edge'] = model_front_edge
  plank['smoothEdge'] = smoothEdge
  plank['doorOpenSide'] = doorOpenSide
  plank['oriCurveHoles'] = oriCurveHoles
  plank['curveHoles'] = curveHoles
  plank['millInfo'] = millInfo
  plank['edgeArrowMap'] = edgeArrowMap
  holes.forEach((hole) => {
    if (Number(hole.deep) + 0.001 > thick && !hole.isFixedSide) {
      if (!hole?.specialRuleFlag) {
        hole.side = 1
      } else {
        let holeSlotName = hole.symbol
        if (hole.holeType === 'bigHole' && hole.symbol === '3in1Lock') {
          holeSlotName = 'CCPXHole'
        }
        hole.side = specialRuleMap.get(holeSlotName) ?? -hole.side
      }
    }
  })
  slots.forEach((slot) => {
    if (Number(slot.deep) + 0.001 > thick) {
      if (!slot?.specialRuleFlag) {
        slot.side = 1
      } else {
        slot.side = specialRuleMap.get(slot.symbol) ?? -slot.side
      }
    }
  })
  if (curveHoles) {
    curveHoles.forEach((cHole) => {
      if (Number(cHole.deep) + 0.001 > thick) {
        cHole.side = 1
      }
    })
  }
  // path
  if (plank.hasOwnProperty('path') && plank['path']) {
    var o = { x: rect.width / 2, y: rect.height / 2 }

    var paths = plank['path']
    for (var i in paths) {
      var path = paths[i]
      for (var j in path) {
        var p = path[j]

        var x = p['x'] - o.x
        var y = p['y'] - o.y

        p['x'] = x + o.x
        p['y'] = -y + o.y
      }
    }
    plank['path'] = paths
  }

  // oPath
  if (plank.hasOwnProperty('oPath') && plank['oPath']) {
    var o = { x: owidth / 2, y: oheight / 2 }

    var paths = plank['oPath']
    for (var i in paths) {
      var path = paths[i]
      for (var j in path) {
        var p = path[j]

        var x = p['x'] - o.x
        var y = p['y'] - o.y

        p['x'] = x * 1 + o.x
        p['y'] = -y + o.y
      }
    }
    plank['oPath'] = paths
  }

  // cutCurve
  if (plank.hasOwnProperty('cutCurve') && plank['cutCurve']) {
    var o = { x: rect.width / 2, y: rect.height / 2 }

    var lastB = -1000
    var cutCurve = plank['cutCurve']
    cutCurve.reverse()
    for (var j in cutCurve) {
      p = cutCurve[j]

      x = p['x'] - o.x
      y = p['y'] - o.y

      p['x'] = x + o.x
      p['y'] = -y + o.y

      var tmpB = lastB
      if (p.hasOwnProperty('b')) {
        lastB = p['b']
      } else {
        lastB = -1000
      }
      if (tmpB !== -1000) {
        p['b'] = tmpB
      } else {
        delete p['b']
      }
    }
    if (lastB !== -1000) {
      cutCurve[0]['b'] = lastB
    }

    var cutCurveEx = plank['cutCurveEx']
    for (var i in cutCurveEx) {
      var curveEx = cutCurveEx[i]
      lastB = -1000
      curveEx.reverse()
      for (var j in curveEx) {
        p = curveEx[j]

        x = p['x'] - o.x
        y = p['y'] - o.y

        p['x'] = x + o.x
        p['y'] = -y + o.y

        tmpB = lastB
        if (p.hasOwnProperty('b')) {
          lastB = p['b']
        } else {
          lastB = -1000
        }
        if (tmpB !== -1000) {
          p['b'] = tmpB
        } else {
          delete p['b']
        }
      }
      if (lastB !== -1000) {
        curveEx[0]['b'] = lastB
      }
    }
  }

  // realCurve
  if (plank.hasOwnProperty('realCurve') && plank['realCurve']) {
    var o = { x: owidth / 2, y: oheight / 2 }
    var lastB = -1000
    var path = plank['realCurve']
    path.reverse()
    for (var i in path) {
      var p = path[i]
      var x = p['x'] - o.x
      var y = p['y'] - o.y
      p['x'] = x * 1 + o.x
      p['y'] = -y + o.y

      var tmpB = lastB
      if (p.hasOwnProperty('b')) {
        lastB = p['b']
      } else {
        lastB = -1000
      }
      if (tmpB !== -1000) {
        p['b'] = tmpB
      } else {
        delete p['b']
      }
    }
    if (lastB !== -1000) {
      path[0]['b'] = lastB
    }
    plank['realCurve'] = path

    var realCurveEx = plank['realCurveEx']
    for (var i in realCurveEx) {
      var curveEx = realCurveEx[i]
      lastB = -1000
      curveEx.reverse()
      for (var j in curveEx) {
        p = curveEx[j]

        x = p['x'] - o.x
        y = p['y'] - o.y

        p['x'] = x + o.x
        p['y'] = -y + o.y

        tmpB = lastB
        if (p.hasOwnProperty('b')) {
          lastB = p['b']
        } else {
          lastB = -1000
        }
        if (tmpB !== -1000) {
          p['b'] = tmpB
        } else {
          delete p['b']
        }
      }
      if (lastB !== -1000) {
        curveEx[0]['b'] = lastB
      }
    }
  }

  // srcPath
  if (plank['srcPath'] && plank['srcPath'].length) {
    plank['srcPath'] = dealPathToBasePoint(flipPath(plank['srcPath']))
  }
  plank.finalExtendDisMap = getFlipObject(plank.finalExtendDisMap, 'upDown')

  if (plank.edgePreMillingInfo) {
    const { appliedSides } = plank.edgePreMillingInfo
    const { top, right, bottom, left } = appliedSides
    // 上下翻板，预铣值的 appliedSides 做处理
    plank.edgePreMillingInfo.appliedSides = {
      top: bottom,
      right,
      bottom: top,
      left,
    }
  }
  transformTextureGroup(plank, 'flipY', reversalPlank)
}

// 左右翻板
const dealPoint = (pointObj, field, width) => {
  pointObj[field] = { x: width - pointObj[field].x, y: pointObj[field].y }
}
const dealPath = (shape, width) => {
  let lastB = -1000
  shape.reverse()
  for (const curPoint of shape) {
    const tmpB = lastB
    curPoint.x = width - curPoint.x
    if (curPoint.hasOwnProperty('b')) {
      lastB = curPoint['b']
    } else {
      lastB = -1000
    }
    if (tmpB !== -1000) {
      curPoint['b'] = tmpB
    } else {
      delete curPoint['b']
    }
  }

  if (lastB !== -1000) {
    shape[0]['b'] = lastB
  }
}
const dirMap = {
  1: 3,
  2: 2,
  3: 1,
  4: 4,
}

// 用于获取侧槽侧空需要那个值来减去当前x轴
function getLongKey(side) {
  return side == 1 || side == 3 ? 'height' : 'width'
}
export function rolloverPlank(plank, isReverePlank) {
  recordTransform(
    plank,
    'flipY',
    0,
    isReverePlank ? 'reverePlank' : 'rolloverPlank'
  )
  let {
    rect: { width: width, height: height },
    realRect: { width: realWidth, height: realHeight },
    holes,
    sholes,
    slots,
    handleSlopes,
    sslots,
    thick,
    oRect: { width: oWidth, height: oHeight },
    curveHoles,
    millInfo,
    oriCurveHoles,
    edgeInfo,
    edge_texture_map,
    model_front_edge,
    smoothEdge,
    lightEdgeInfo,
    doorOpenSide,
    oPath,
    path,
    unionPath,
    cutCurve,
    cutCurveEx,
    realCurve,
    realCurveEx,
    lineSlots,
    edgePreMillingInfo,
    edgeArrowMap,
  } = plank
  holes.forEach((it) => {
    dealPoint(it, 'center', width)
    dealPoint(it, 'ocenter', oWidth)
    it.side = -it.side
    // 左右翻面对z扣孔的方向做处理
    const newHole = adjustHoleDirection(it, 0, 'flipY')
    Object.assign(it, newHole)
    dealProcessInEn(it)
  })

  sholes.forEach((it) => {
    it.center.y = thick - it.center.y

    const k = getLongKey(it.side)
    const long = plank.oRect[k]
    it.center.x = long - it.center.x

    it.ocenter.x = oWidth - it.ocenter.x
    it.side = dirMap[it.side]
  })

  slots.forEach((it) => {
    dealPoint(it, 'pt1', width)
    dealPoint(it, 'opt1', oWidth)
    dealPoint(it, 'pt2', width)
    dealPoint(it, 'opt2', oWidth)
    // oriPt1, oriPt2 使用 realRect 坐标系（realWidth）
    if (it.oriPt1) {
      dealPoint(it, 'oriPt1', realWidth)
    }
    if (it.oriPt2) {
      dealPoint(it, 'oriPt2', realWidth)
    }
    it.side = -it.side
    dealProcessInEn(it)
  })

  handleSlopes &&
    handleSlopes.forEach((it) => {
      dealPoint(it, 'pt1', width)
      dealPoint(it, 'opt1', oWidth)
      dealPoint(it, 'pt2', width)
      dealPoint(it, 'opt2', oWidth)
      it.side = -it.side
    })

  sslots.forEach((it) => {
    it.pt1.y = thick - it.pt1.y
    it.pt2.y = thick - it.pt2.y
    const k = getLongKey(it.side)
    const long = plank.oRect[k]
    it.pt1.x = long - it.pt1.x
    it.pt2.x = long - it.pt2.x

    it.opt1.x = oWidth - it.opt1.x
    it.opt2.x = oWidth - it.opt2.x
    it.side = dirMap[it.side]
    if (it?.others?.obliqueSide) {
      it.others.obliqueSide = -it.others.obliqueSide
    }
  })

  if (lineSlots) {
    lineSlots.forEach((it) => {
      const { path, oPath, oriPath, polygonArr = [] } = it
      if (path) {
        path.forEach((p) => {
          p.x = width - p.x
          dealLineSlotPointB(p)
        })
      }
      if (oPath) {
        oPath.forEach((p) => {
          p.x = oWidth - p.x
          dealLineSlotPointB(p)
        })
      }
      // oriPath 使用 realRect 坐标系（realWidth）
      if (oriPath) {
        oriPath.forEach((p) => {
          p.x = realWidth - p.x
          dealLineSlotPointB(p)
        })
      }
      if (polygonArr) {
        polygonArr.forEach((polygon) => {
          dealPath(polygon, width)
        })
      }
      it.side = -it.side
    })
  }

  if (path) {
    path.forEach((it) => {
      dealPath(it, width)
    })
  }

  if (unionPath) {
    unionPath.forEach((it) => {
      dealPath(it, width)
    })
  }

  if (oPath) {
    oPath.forEach((it) => {
      dealPath(it, oWidth)
    })
  }

  if (cutCurve) {
    dealPath(cutCurve, width)
  }

  if (cutCurveEx) {
    cutCurveEx.forEach((it) => {
      dealPath(it, width)
    })
  }

  if (realCurve) {
    dealPath(realCurve, oWidth)
  }

  if (realCurveEx) {
    realCurveEx.forEach((it) => {
      dealPath(it, oWidth)
      for (const curPoint of it) {
        if (curPoint.hasOwnProperty('side')) {
          if (curPoint.depth * 1 + 0.001 < plank.thick) {
            curPoint.side = -curPoint.side
          }
        }
      }
    })
  }

  if (curveHoles) {
    curveHoles.forEach((it) => {
      dealPath(it.path, width)
      dealPath(it['native_path'] ?? [], width)
      if (it.oPath) {
        dealPath(it.oPath, oWidth)
      }
      it.side = -it.side
    })
  }
  if (millInfo) {
    millInfo.forEach((it) => {
      dealPath(it.shape, oWidth)
      if (it.oPath) {
        dealPath(it.oPaplankth, oWidth)
      }
      it.side = -it.side
    })
  }

  if (oriCurveHoles) {
    oriCurveHoles.forEach((it) => {
      dealPath(it.path, oWidth)
      if (it.oPath) {
        dealPath(it.oPath, oWidth)
      }
      it.side = -it.side
    })
  }
  const sh = holes.filter((hole) => isOtherSideMachineHole(hole))
  const sl = slots.filter((slot) => isOtherSideMachineSlot(slot))
  plank.sholeInfo = generatorSideHoleSlot([
    ...sholes,
    ...sh.filter((h) => h.side == '1'),
  ])
  plank.sholeInfoF = generatorSideHoleSlot(
    sh.filter((h) => h.side == '-1'),
    'leftRightFlip'
  )
  // 开启 侧孔机加工牛角拉手 需将牛角拉手放到侧槽信息里面
  let sideMillInfo = millInfo?.filter((mill) => isSideMachineMillInfo(mill))
  plank.sslotInfo = generatorSideHoleSlot(
    [
      ...sslots,
      ...sl.filter((l) => l.side == '1'),
      ...(sideMillInfo ? sideMillInfo?.filter((mill) => mill.side == '1') : []),
    ],
    '',
    plank
  )
  plank.sslotInfoF = generatorSideHoleSlot(
    sl.filter((l) => l.side == '-1'),
    'leftRightFlip',
    plank
  )
  plank.edgeInfo = dealEdgeInfoChange(edgeInfo, 'leftRightFlip') //左右翻板 左下右上 应该就是 右下左上
  // edge_texture_map与edgeInfo相同的逻辑
  if (edge_texture_map) {
    const leftTexture = edge_texture_map[1] || ''
    const bottomTexture = edge_texture_map[2] || ''
    const rightTexture = edge_texture_map[3] || ''
    const topTexture = edge_texture_map[4] || ''
    edge_texture_map[1] = rightTexture // 新的左 = 原来的右
    edge_texture_map[2] = bottomTexture
    edge_texture_map[3] = leftTexture // 新的右 = 原来的左
    edge_texture_map[4] = topTexture
    plank.edge_texture_map = edge_texture_map
  }
  // edgeArrowMap 与 edgeInfo 相同的左右翻逻辑：←right ↓bottom →left ↑top
  if (edgeArrowMap) {
    const leftName = edgeArrowMap[0]
    const bottomName = edgeArrowMap[1]
    const rightName = edgeArrowMap[2]
    const topName = edgeArrowMap[3]
    edgeArrowMap[0] = rightName // 新的左 = 原来的右
    edgeArrowMap[1] = bottomName // 新的下 = 原来的下
    edgeArrowMap[2] = leftName // 新的右 = 原来的左
    edgeArrowMap[3] = topName // 新的上 = 原来的上
    plank.edgeArrowMap = edgeArrowMap
  }
  if (edgePreMillingInfo?.appliedSides) {
    const { left, right, top, bottom } = edgePreMillingInfo.appliedSides
    edgePreMillingInfo.appliedSides = {
      left: right,
      right: left,
      top,
      bottom,
    }
  }
  plank.lightEdgeInfo = dealEdgeInfoChange(lightEdgeInfo, 'leftRightFlip')
  plank.model_front_edge = dealFormerEdgeChange(
    model_front_edge,
    'leftRightFlip',
    'former'
  )
  plank.smoothEdge = dealFormerEdgeChange(
    smoothEdge,
    'leftRightFlip',
    'doorOpenSide'
  )
  plank.doorOpenSide = dealFormerEdgeChange(
    doorOpenSide,
    'leftRightFlip',
    'doorOpenSide'
  )
  if (plank.finalExtendDisMap) {
    plank.finalExtendDisMap = getFlipObject(plank.finalExtendDisMap)
  }

  if (isReverePlank) {
    plank.reverePlank = true
  }
  // 合并骨骼门翻面后 原始的 5 块单板也需要翻面
  if (judgeIsMergeFrameDoor(plank)) {
    plank.frame_door_children.forEach((child) =>
      rolloverPlank(child, isReverePlank)
    )
  }
  transformTextureGroup(plank, 'flipX', (child) =>
    rolloverPlank(child, isReverePlank)
  )
}
/**
 * 此方法用于按比例分配孔槽
 * 此文件不调用，调用文件为layoutTool.js
 * @param {*} plank 大板
 * @returns
 */
export function allocationHoleSlot(plank) {
  if (!plank.parts) return
  // 高光板板件不能进行按比例分配
  if (plank.parts[0] && plank.parts[0].is_high_gloss_plank) return
  const {
    processChainAndHoleOnBigPlaneBack,
    prorate_holes_slots_of_both_side,
  } = store.state.ncSetting
  if (!prorate_holes_slots_of_both_side) return
  const strentchSlot = ['STRENTCH', 'STRENTCHTWO', 'MIDSTRENTCH'] // 拉直槽
  const hingeHole = ['HINGE'] // 铰链孔
  // 记录总的孔槽数量
  let holeSlotTotalNum = 0
  // 目前还不会用到这个，先留着
  // eslint-disable-next-line
  let frontAio = 0
  let oppositeAio = 0
  const result = []
  const special_hole_slot_side =
    store.state.ncSetting.custom_special_hole_slot_side.special_hole_slot_side
  const specialSet = new Set()
  store.state.ncSetting.custom_special_hole_slot_side.is_open &&
    special_hole_slot_side?.forEach((it) => {
      specialSet.add(it.key)
    })
  plank.parts.forEach((part) => {
    if (!part.slots && !part.holes) return
    // 对纹不参与按比例分配
    if (isTextureAlignmentPlank(part)) return
    const obj = {}
    const { holes, slots } = part

    const isExistStraightener = specialSet.has(
      'straightener_slots_and_hinged_cup_holes'
    )
    // 开启铰链孔/拉直器反面加工则排除有铰链孔和拉直器的板 或 特殊孔槽有拉直器的也不做处理 特殊
    if (processChainAndHoleOnBigPlaneBack || isExistStraightener) {
      const hinge = holes.filter((it) => hingeHole.includes(it.symbol))
      const strentch = slots.filter((it) => strentchSlot.includes(it.symbol))
      if (hinge.length || strentch.length) return
    }
    holeSlotTotalNum += holes?.length ?? 0
    holeSlotTotalNum += slots?.length ?? 0
    const holeSlot = [...holes, ...slots]
    obj.part = part
    obj.holeSlot = holeSlot
    result.push(obj)
  })
  if (!result.length) return
  result.forEach((it) => {
    // 板件正面孔槽占比
    it.partHSZ =
      (it.holeSlot.filter((it) => {
        // 特殊孔槽规则的通孔通槽不计算在内

        if (it?.specialRuleFlag) {
          holeSlotTotalNum--
        }

        return it.side === 1 && !it?.specialRuleFlag
      }).length /
        holeSlotTotalNum) *
      100
    // 板件反面孔槽占比 特殊孔槽规则中的通孔通槽不计算在内
    it.partHSF =
      (it.holeSlot.filter((it) => {
        return it.side === -1 && !it?.specialRuleFlag
      }).length /
        holeSlotTotalNum) *
      100
    // 反面与正面差值 得到翻转可以增加/减少多少翻面比例
    it.oppositeDifference = (it.partHSF - it.partHSZ) * -1
    // 总的正面孔槽比例
    frontAio += it.partHSZ
    // 总的反面孔槽比例
    oppositeAio += it.partHSF
  })
  // 执行分配
  executeAllocation(oppositeAio, result, specialSet, plank.thick)
}
/**
 * 执行分配
 * @param {*} oppositeAio 反面孔槽占比
 * @param {*} result 处理的孔槽数据集合
 * @param {*} specialSet 特殊孔槽规则集合
 * @returns
 */
function executeAllocation(oppositeAio, result, specialSet, thick) {
  let { percentage_of_back_hole_slot: pbs } = store.state.ncSetting
  pbs = +pbs
  // 需要进行翻转的板件
  const needFlipPart = []
  const positive = result.filter((it) => it.oppositeDifference > 0)
  const negative = result.filter((it) => it.oppositeDifference < 0)
  let idx = 0
  let count = 0
  let type
  while (count < result.length) {
    if (pbs > oppositeAio) {
      type = 'add'
    } else if (pbs < oppositeAio) {
      type = 'sub'
    } else {
      break
    }
    // 防止出现无限循环
    count++
    const collect = type === 'add' ? positive : negative
    const { oppositeDifference, part, holeSlot } = collect[idx] ?? {}
    if (!part) break
    const f =
      Math.abs(pbs - (oppositeAio + oppositeDifference)) >
      Math.abs(pbs - oppositeAio)
    if (f) break
    oppositeAio += oppositeDifference
    let isPush = true
    // 判断是否将此小板加入翻版列表中 小板存在符合特殊孔槽规则的 未打穿孔槽 不翻版 xxxx

    for (const it of holeSlot) {
      if ((it.deep ?? it.depth) * 1 + 0.001 >= thick && !it.isFixedSide)
        continue
      let holeSlotName = it.symbol
      if (it.holeType === 'bigHole' && it.symbol === '3in1Lock') {
        holeSlotName = 'CCPXHole'
      }
      // 标明当前孔槽满足特殊孔槽规则
      if (specialSet.has(holeSlotName)) {
        isPush = false
        break
      }
      // 标明当前孔槽满足特殊孔槽常规槽规则
      if (it.type === 'slot' && !it?.shape && !it?.path) {
        it.length = it.length ?? Math.abs(it.pt1.x - it.pt2.x)
        if (
          matchNormalSlot.has(
            `${Math.max(it.length, it.width)}/${Math.min(it.length, it.width)}`
          )
        ) {
          isPush = false
          break
        }
      }
      // 标明当前孔槽满足特殊孔槽常规孔规则
      if (
        it.type === 'hole' &&
        !it?.shape &&
        !it?.path &&
        matchNormalHole.has(it.diameter)
      ) {
        isPush = false
        break
      }
    }

    // 有特殊孔槽规则并且孔槽未打穿的板子不翻转
    isPush && needFlipPart.push(part)
    idx++
    const isBreak = type === 'add' ? pbs <= oppositeAio : pbs >= oppositeAio
    if (isBreak) {
      break
    }
  }
  // 翻转板件
  needFlipPart.forEach((part) => {
    reversalPlank(part)
  })
}

function findPlateData(datas, plate) {
  for (var i in datas) {
    var data = datas[i]
    if (data['plkId'] === plate['plate_info']['plKId']) {
      return data
    }
  }
}

//搜集补件的板子
function collectPatchPlanks(plates, planks) {
  var tmpPlanks = []

  for (var i in plates) {
    var plate = plates[i]
    var fData = findPlateData(planks, plate)
    if (fData) {
      tmpPlanks.push(fData)
    }
  }
  return tmpPlanks
}

function collectPlanks(data, planks, roomInfo, otherData, axis) {
  var children = data['children']
  if (data.hasOwnProperty('partName')) {
    if (data['partName'] === 'Plank') {
      data['roomName'] = roomInfo['name']
      if (data['matCode'].includes('占位板')) {
        //占位板不生产
        return
      }

      for (var j in otherData) {
        data[j] = otherData[j]
      }
      planks.push(data)
    } else if (
      data['partName'] === 'SingleDoor' &&
      data['style'].includes('占位板')
    ) {
      data['children'] = []
      data['roomName'] = roomInfo['name']

      if (data['matCode'].includes('占位板')) {
        //占位板不生产
        return
      }
      planks.push(data)
    }
  }
  if (children) {
    for (var i in children) {
      var otData = {}
      if (data['partName'] === 'WineRack') {
        otData['cellInfo'] = data['cellInfo']
      }
      if (data['drawerStyle']) {
        otData['drawerStyle'] = data['drawerStyle']
      }

      collectPlanks(children[i], planks, roomInfo, otData, axis)
    }
  }
}

//删除重复点
function deletRepetitivePoint(points) {
  var result = []
  for (var i = 0; i < points.length; ++i) {
    var curPt = points[i]
    if (i > 0) {
      var lastPt = points[i - 1]
      if (lastPt.x === curPt.x && lastPt.y === curPt.y) {
        continue
      }
    }
    result.push(curPt)
  }

  return result
}

function getBound(points) {
  var minx = Number.MAX_VALUE
  var miny = Number.MAX_VALUE
  var maxx = Number.MIN_VALUE
  var maxy = Number.MIN_VALUE

  if (!points || points.length < 1) {
    return null
  }

  points.forEach(function (pt) {
    minx = Math.min(minx, pt.x)
    miny = Math.min(miny, pt.y)
    maxx = Math.max(maxx, pt.x)
    maxy = Math.max(maxy, pt.y)
  })

  return {
    minx: minx,
    miny: miny,
    maxx: maxx,
    maxy: maxy,
  }
}

function dealWithLastCurve(
  lastCurve,
  iCoord,
  texDir,
  sizes,
  edgeInfo,
  dir,
  pThick
) {
  var hvd = dir.split('_')
  var coord = iCoord.split('_')

  var coordH = coord[0]
  var coordV = coord[1]
  var coordD = coord[2]

  var signH = coordH[0] >= 3 ? -1 : 1
  var signV = coordV[0] >= 3 ? -1 : 1

  var preVertex = JSON.parse(JSON.stringify(lastCurve['vertex']))
  preVertex = deletRepetitivePoint(preVertex)
  var vertex = JSON.parse(JSON.stringify(preVertex))
  var overtex = JSON.parse(JSON.stringify(preVertex))
  var extras = JSON.parse(JSON.stringify(lastCurve['extras']))
  var oExtras = JSON.parse(JSON.stringify(lastCurve['extras']))
  var lastRect = lastCurve['lastRect']
  if (lastRect) {
    var w = Number(lastRect['w']).toFixed(3)
    var h = Number(lastRect['h']).toFixed(3)
  } else {
    var bound = getBound(preVertex)
    w = Number(bound.maxx - bound.minx).toFixed(3)
    h = Number(bound.maxy - bound.miny).toFixed(3)
  }

  //处理结果
  var result = {}
  var oexHoles = []
  var oexSlots = []
  var exHoles = []
  var exSlots = []

  var realCurve = JSON.parse(JSON.stringify(overtex))
  var exCurve = []
  // return
  var curve = libCurve.newCurve()
  curve.points = overtex
  var points = curve.getPolygon(true) // 处理圆弧数据
  rotatePath(points, coord, hvd)

  var cw = w
  var ch = h
  if (texDir === 'reverse') {
    cw = h
    ch = w
  }

  for (var i in points) {
    points[i].x += cw / 2
    points[i].y += ch / 2
  }

  result['oPath'] = [points]

  // 异形编辑挖洞处理
  for (i in oExtras) {
    var oex = oExtras[i]

    var tmpWd = w
    var tmpHg = h
    var type = ''
    var isCurve = false
    var isThrough = ''
    var xdepth = 0
    for (var j in oex) {
      var exPt = oex[j]
      exPt['x'] += (tmpWd / 2) * signH
      exPt['y'] += (tmpHg / 2) * signV

      isThrough = exPt.through

      //孔位的深度大于板厚的时候，孔位深度值=板厚
      if (
        pThick &&
        Math.abs(exPt.depth * 1 - pThick) > 0 &&
        isThrough === '是'
      ) {
        xdepth = pThick
      } else {
        xdepth = exPt.depth * 1
      }

      if (exPt.disType === 'hole') {
        //圆孔为通孔时且圆孔直径大于30，当做异形处理
        if (xdepth >= pThick && Math.abs(exPt['r']) > 15) {
          type = 'curve'
        } else {
          type = 'hole'
        }
      } else if (exPt.disType === 'rect') {
        //方孔为通孔时，当做异形处理
        if (xdepth >= pThick) {
          type = 'curve'
        } else {
          type = 'slot'
        }
      }
    }

    if (xdepth === 0) {
      continue
    }

    if (type === 'hole') {
      rotatePath(oex, coord, hvd)
      var hole = changePathToHoleOrSlot(oex, 'hole', pThick, xdepth, isThrough)
      if (hole) {
        oexHoles.push(hole)
      }
    } else if (type === 'slot') {
      rotatePath(oex, coord, hvd)
      var slot = changePathToHoleOrSlot(oex, 'slot', pThick, xdepth, isThrough)
      if (slot) {
        oexSlots.push(slot)
      }
    } else {
      curve.points = oex
      points = curve.getPolygon(true)
      rotatePath(points, coord, hvd)
      result['oPath'].push(points)
    }
  }

  //---------------------以上 oPath 带封边---------------------------------------------
  var wd = sizes['width']
  var hg = sizes['height']
  var owd = sizes['owidth']
  var ohg = sizes['oheight']
  vertex.forEach((v) => {})
  // return
  // texDir如果是横纹x,y交换竖纹就直接求
  // edgeInfo, 第一个和第三个为x值, 第二个和第四个为竖纹
  // vertex中, 最大x坐标和最小x坐标, 取两个x坐标的长度减去封边信息中x的值再除以长度, 得到x的比例
  // y坐标同理, 最大y和最小y, 取长度减去封边信息组中y的值再除以长度, 得到y的比例
  var sc = getLastCurveScaleFactor(vertex, edgeInfo, texDir)
  var sx = sc.sx
  var sy = sc.sy

  for (var i in vertex) {
    var pt = vertex[i]
    pt.x = pt.x * sx
    pt.y = pt.y * sy
    vertex[i] = pt
  }
  var cutCurve = deepCopy(vertex)
  curve.points = vertex
  points = curve.getPolygon(true)
  rotatePath(points, coord, hvd)

  bound = getBound(points)
  var minx = bound.minx
  var miny = bound.miny

  for (i in points) {
    points[i].x -= minx
    points[i].y -= miny
  }

  result['path'] = [points]
  result['exHoles'] = []
  result['exSlots'] = []
  result['depth'] = []

  //处理异形挖孔
  for (var k in extras) {
    var ex = extras[k]
    if (!ex) continue

    type = ''
    tmpWd = sc.wd
    tmpHg = sc.hg
    xdepth = 0
    isThrough = ''
    for (i in ex) {
      pt = ex[i]
      isThrough = pt.through

      //孔位的深度大于板厚的时候，孔位深度值=板厚
      if (pThick && Math.abs(pt.depth * 1 - pThick) > 0 && isThrough === '是') {
        xdepth = pThick
      } else {
        xdepth = pt.depth * 1
      }

      if (pt.disType === 'hole') {
        //圆孔为通孔时且圆孔直径大于30，当做异形处理
        if (xdepth >= pThick && Math.abs(pt['r']) > 15) {
          type = 'curve'
        } else {
          type = 'hole'
        }
        break
      } else if (pt.disType === 'rect') {
        //方孔为通孔时，当做异形处理
        if (xdepth >= pThick) {
          type = 'curve'
        } else {
          type = 'slot'
        }
        break
      }
    }

    if (xdepth === 0) {
      continue
    }
    if (type === 'hole') {
      moveExPath(ex, coord, hvd, edgeInfo, minx, miny)
      hole = changePathToHoleOrSlot(ex, 'hole', pThick, xdepth, isThrough)
      if (hole) {
        exHoles.push(hole)
      }
    } else if (type === 'slot') {
      moveExPath(ex, coord, hvd, edgeInfo, minx, miny)
      slot = changePathToHoleOrSlot(ex, 'slot', pThick, xdepth, isThrough)
      if (slot) {
        exSlots.push(slot)
      }
    } else {
      //收集没有转换的异形孔槽
      var tmpEx = []
      for (var ei in ex) {
        var tmpPt = {
          x: ex[ei].x,
          y: ex[ei].y,
        }
        if (ex[ei].b) {
          tmpPt['b'] = mFixed(ex[ei].b)
        }
        tmpEx.push(tmpPt)
      }
      dealWithCurve(tmpEx, coord, hvd, true)
      exCurve.push(tmpEx)

      curve.points = ex
      var expath = curve.getPolygon(true)
      rotatePath(expath, coord, hvd)
      for (var t in expath) {
        expath[t]['x'] -= minx
        expath[t]['y'] -= miny
      }
      result['path'].push(expath)
      if (!ex[0].depth) {
        result['depth'].push(pThick)
      } else {
        if (
          pThick &&
          Math.abs(ex[0].depth * 1 - pThick) > 0 &&
          ex[0]['through'] === '是'
        ) {
          result['depth'].push(pThick)
        } else {
          result['depth'].push(ex[0].depth)
        }
      }
    }
  }

  mergeHoles(exHoles, oexHoles)
  mergeSlots(exSlots, oexSlots)

  result['exHoles'] = exHoles
  result['exSlots'] = exSlots

  //---------------------以上 path 不带封边---------------------------------------------

  var cutBound = dealWithCurve(cutCurve, coord, hvd)
  var minValue = dealWithCurve(realCurve, coord, hvd)
  var cutExCurve = deepCopy(exCurve)
  var realExCurve = deepCopy(exCurve)

  for (i in cutExCurve) {
    ex = cutExCurve[i]
    for (ei in ex) {
      pt = ex[ei]
      pt['x'] = mFixed(pt['x'] - cutBound[0], 3)
      pt['y'] = mFixed(pt['y'] - cutBound[1], 3)
    }
  }

  for (i in realExCurve) {
    ex = realExCurve[i]
    for (ei in ex) {
      pt = ex[ei]
      pt['x'] = mFixed(pt['x'] - minValue[0], 3)
      pt['y'] = mFixed(pt['y'] - minValue[1], 3)
    }
  }

  result['cutCurve'] = cutCurve
  result['cutCurveEx'] = cutExCurve
  result['realCurve'] = realCurve
  result['realCurveEx'] = realExCurve

  return result
}

function mFixed(num, n) {
  if (typeof n != 'number') {
    n = 2
  }
  var result = num
  if (typeof result != 'number') {
    return 0
  }

  var a = Math.pow(10, n)
  result = Math.round(num * a) / a

  return result
}

function dealWithCurve(curve, coord, hvd, flag) {
  dealWithRealCurve(curve, coord, hvd)
  if (flag) {
    return [0, 0]
  }
  var bound = getBound(curve)
  var minx = bound.minx
  var miny = bound.miny

  for (var i in curve) {
    curve[i].x -= minx
    curve[i].y -= miny
  }

  if (!checkSequence(curve)) {
    var lastB = -1000
    curve.reverse()
    for (var i in curve) {
      var p = curve[i]
      var tmpB = lastB
      if (p.hasOwnProperty('b')) {
        lastB = p['b']
      } else {
        lastB = -1000
      }
      if (tmpB !== -1000) {
        p['b'] = -tmpB
      } else {
        delete p['b']
      }
    }
    if (lastB !== -1000) {
      curve[0]['b'] = -lastB
    }
  }
  return [minx, miny]
}

function moveExPath(path, coord, hvd, edgeInfo, minx, miny) {
  var left = Number(
    edgeInfo.substring(edgeInfo.indexOf('←') + 1, edgeInfo.indexOf('↓'))
  )
  var bottom = Number(
    edgeInfo.substring(edgeInfo.indexOf('↓') + 1, edgeInfo.indexOf('→'))
  )
  var right = Number(
    edgeInfo.substring(edgeInfo.indexOf('→') + 1, edgeInfo.indexOf('↑'))
  )
  var top = Number(edgeInfo.substring(edgeInfo.indexOf('↑') + 1))

  rotatePath(path, coord, hvd)
  pathOffSet(path, -(left - right) / 2, (bottom - top) / 2)
  for (var t in path) {
    path[t]['x'] -= minx
    path[t]['y'] -= miny
  }
}

function pathOffSet(path, ox, oy) {
  for (var i in path) {
    var pt = path[i]
    pt.x += ox
    pt.y += oy
  }
}

//合并孔
function mergeHoles(exHoles, oexHoles) {
  if (exHoles.length !== oexHoles.length) {
    return
  }

  for (var i = 0; i < exHoles.length; ++i) {
    var hole = exHoles[i]
    var oholes = oexHoles[i]

    hole['ocenter'] = oholes['center']
  }
}

//合并槽
function mergeSlots(exSlots, oexSlots) {
  if (exSlots.length !== oexSlots.length) {
    return
  }
  for (var i = 0; i < exSlots.length; ++i) {
    var slot = exSlots[i]
    var oslot = oexSlots[i]

    slot['opt1'] = oslot['pt1']
    slot['opt2'] = oslot['pt2']
  }
}

//把圆形，方形路径转换成孔槽
function changePathToHoleOrSlot(path, type, thick, xdepth, isThrough) {
  var result = {}

  var side = 1
  xdepth *= 1
  if (xdepth && isThrough === '否') {
    if (xdepth >= thick || xdepth <= -thick) {
      xdepth = thick
    }
    thick = Math.abs(xdepth)
    if (xdepth >= 0) {
      side = 1
    } else {
      side = -1
    }
  }

  var bound = getBound(path)
  var minX = bound.minx
  var minY = bound.miny
  var maxX = bound.maxx
  var maxY = bound.maxy

  if (type === 'hole') {
    var xDis = maxX - minX
    var yDis = maxY - minY
    var center = {
      x: (minX + maxX) / 2,
      y: (minY + maxY) / 2,
    }
    var diameter = (xDis + yDis) / 2

    if (diameter <= 0.001) {
      return null
    }

    result = {
      type: 'hole',
      deep: thick * 1,
      side: side,
      center: center,
      diameter: diameter * 1,
      holeType: 'exHole',
    }
  } else if (type === 'slot') {
    if (maxX - minX < maxY - minY) {
      var width = maxX - minX
      var length = maxY - minY
      var pt1 = {
        x: (maxX + minX) / 2,
        y: minY,
      }
      var pt2 = {
        x: (maxX + minX) / 2,
        y: maxY,
      }
    } else {
      width = maxY - minY
      length = maxX - minX
      pt1 = {
        x: minX,
        y: (maxY + minY) / 2,
      }
      pt2 = {
        x: maxX,
        y: (maxY + minY) / 2,
      }
    }

    if (width <= 0.001 || length <= 0.001) {
      return null
    }

    result = {
      type: 'slot',
      pt1: pt1,
      pt2: pt2,
      deep: thick * 1,
      side: side,
      width: width * 1,
      length: length * 1,
      slotType: 'exSlot',
    }
  }

  return result
}

function dealWithRealCurve(path, coord, hvd) {
  var hDir = hvd[0]
  var vDir = hvd[1]
  var dDir = hvd[2]

  var coordH = coord[0]
  var coordV = coord[1]
  var coordD = coord[2]

  var signH = coordH[0] >= 3 ? -1 : 1
  var signV = coordV[0] >= 3 ? -1 : 1

  for (var i in path) {
    var pt = path[i]

    var tmpPt = {}
    tmpPt[coordH % 3] = pt.x * signH
    tmpPt[coordV % 3] = pt.y * signV

    var retPt = {
      x: tmpPt[hDir % 3],
      y: tmpPt[vDir % 3],
    }
    if (pt.b) {
      if ((signH === 1 && signV === 1) || (signH === -1 && signV === -1)) {
        retPt['b'] = -pt.b
      } else {
        retPt['b'] = pt.b
      }
    }

    path[i] = retPt
  }

  if (!checkSequence(path)) {
    var lastB = -1000
    path.reverse()
    for (var i in path) {
      var p = path[i]
      var tmpB = lastB
      if (p.hasOwnProperty('b')) {
        lastB = p['b']
      } else {
        lastB = -1000
      }
      if (tmpB !== -1000) {
        p['b'] = -tmpB
      } else {
        delete p['b']
      }
    }
    if (lastB !== -1000) {
      path[0]['b'] = -lastB
    }
  }
}

function rotatePath(path, coord, hvd) {
  var hDir = hvd[0]
  var vDir = hvd[1]
  var dDir = hvd[2]

  var coordH = coord[0]
  var coordV = coord[1]
  var coordD = coord[2]

  var signH = coordH[0] >= 3 ? -1 : 1
  var signV = coordV[0] >= 3 ? -1 : 1

  for (var i in path) {
    var pt = path[i]

    var tmpPt = {}
    tmpPt[coordH % 3] = pt.x * signH
    tmpPt[coordV % 3] = pt.y * signV

    var retPt = {
      x: tmpPt[hDir % 3],
      y: tmpPt[vDir % 3],
    }
    path[i] = retPt
  }
}

//验证两个数是否近似相等
function isEqual(a, b) {
  a *= 1
  b *= 1
  var res = a - b
  res = Math.abs(res)
  if (res <= 0.01) {
    return true
  } else return false
}

//计算酒格的path // 忽略
function getWineRackPlankPath(width, height, depth, cellInfo) {
  var polygon
  var pthick, pspacing, widthOffset, deepOffset
  var wineRackOffset = cellInfo.tbOffset

  var ox = cellInfo.ox
  var oy = cellInfo.oy
  var hNum = cellInfo.hNum
  var vNum = cellInfo.vNum

  if (cellInfo.hasOwnProperty('hNum')) {
    var fHeight = Number(height)
    if (cellInfo.name === '方酒格') {
      fHeight += 2 * wineRackOffset
    }

    if (isEqual(fHeight, cellInfo.w)) {
      //传来的是横板,使用hspacing,hnum;
      pthick = cellInfo.thick
      pspacing = cellInfo.hSpacing
      widthOffset = cellInfo.widthOffset
      deepOffset = cellInfo.deepOffset

      polygon = TBFZ.calCubeWinplanks(
        width,
        height,
        depth,
        hNum,
        vNum,
        'v',
        widthOffset,
        deepOffset,
        wineRackOffset,
        ox,
        oy
      )
    } else if (isEqual(fHeight, cellInfo.h)) {
      //传来的是竖板,使用vSpacing,vNum
      pthick = cellInfo.thick
      pspacing = cellInfo.vSpacing
      widthOffset = cellInfo.widthOffset
      deepOffset = cellInfo.deepOffset
      polygon = TBFZ.calCubeWinplanks(
        width,
        height,
        depth,
        hNum,
        vNum,
        'h',
        widthOffset,
        deepOffset,
        wineRackOffset,
        ox,
        oy
      )
    }
  } else if (cellInfo.hasOwnProperty('nh')) {
    pthick = cellInfo.thick
    pspacing = cellInfo.spacing
    widthOffset = cellInfo.widthOffset
    deepOffset = cellInfo.deepOffset

    height = Number(height)
    height += 2 * wineRackOffset
    polygon = TBFZ.calPlanks(
      pthick,
      pspacing,
      width,
      height,
      deepOffset,
      widthOffset,
      wineRackOffset
    )
  } else if (cellInfo.hasOwnProperty('name') && cellInfo.name === 'X酒架') {
    pthick = cellInfo.thick
    widthOffset = cellInfo.widthOffset
    deepOffset = cellInfo.deepOffset
    var path = [
      { x: 0, y: 0 },
      { x: width, y: 0 },

      { x: width, y: height / 2 - pthick / 2 - widthOffset },
      {
        x: width - (width / 2 + deepOffset),
        y: height / 2 - pthick / 2 - widthOffset,
      },
      {
        x: width - (width / 2 + deepOffset),
        y: height / 2 + pthick / 2 + widthOffset,
      },
      { x: width, y: height / 2 + pthick / 2 + widthOffset },

      { x: width, y: height },

      { x: 0, y: height },
    ]

    var edge = wineRackOffset

    var pl = path.length

    for (var k in path) {
      var pt = path[k]
      if (k == 0) {
        pt.x += edge
        pt.y += edge
      } else if (k == 1) {
        pt.x -= edge
        pt.y += edge
      } else if (k == pl - 2) {
        pt.x -= edge
        pt.y -= edge
      } else if (k == pl - 1) {
        pt.x += edge
        pt.y -= edge
      } else {
        if (pt.x == path[1].x + edge) pt.x -= edge
      }
    }

    path[0].x += edge
    path[0].y += edge

    var pathTg = [
      { x: 0, y: 0 },
      { x: width, y: 0 },

      { x: width, y: height / 2 - pthick / 2 - widthOffset + edge },
      {
        x: width - (width / 2 + deepOffset) + edge,
        y: height / 2 - pthick / 2 - widthOffset + edge,
      },
      {
        x: width - (width / 2 + deepOffset) + edge,
        y: height / 2 + pthick / 2 + widthOffset - edge,
      },
      { x: width, y: height / 2 + pthick / 2 + widthOffset - edge },

      { x: width, y: height },

      { x: 0, y: height },
    ]

    polygon = {
      poly: path,
      fullPoly: pathTg,
    }
  } else {
    height = height + 4 * wineRackOffset
    if (cellInfo.h == height) {
      pthick = cellInfo.thick
      pspacing = cellInfo.vSpacing
      widthOffset = cellInfo.widthOffset
      deepOffset = cellInfo.deepOffset
      polygon = TBFZ.calPlanks(
        pthick,
        pspacing,
        width,
        height + 4 * wineRackOffset,
        deepOffset,
        widthOffset,
        wineRackOffset
      )
    }
  }

  var array = [],
    arr2 = []
  if (polygon) {
    array.push(polygon.poly)
    arr2.push(polygon.fullPoly)
  }

  var minX = 100000,
    minY = 100000
  for (var i in array[0]) {
    minX = Math.min(minX, array[0][i]['x'])
    minY = Math.min(minY, array[0][i]['y'])
  }
  for (var i in array[0]) {
    array[0][i]['x'] -= minX
    array[0][i]['y'] -= minY
  }

  var result = {}
  result['path'] = array
  result['oPath'] = arr2
  result['edgeInfo'] = '←0↓0→0↑0'
  result['sholeInfo'] = ''
  result['sslotInfo'] = ''
  result['fullSize'] = Qt.size(width, height)

  return result
}

function plankOtherInfo(result, unqId, roomInfo) {
  var remark = roomInfo['remark']
  var orderNo = roomInfo['order_code']
  var address = roomInfo['buyer_address']
  var userName = roomInfo['pname']
  var createTime = roomInfo['create_time']
  var customerName = roomInfo['customer_name']
  var oId = roomInfo['oId']

  result['oId'] = oId
  result['remark'] = remark
  result['address'] = address
  result['orderNo'] = orderNo
  result['userName'] = userName
  result['createTime'] = createTime
  result['customer_name'] = customerName
}

//判断顺时针还是逆时针
function checkSequence(iPath) {
  var path = deepCopy(iPath)
  var n = path.length
  var s = path[0].y * (path[n - 1].x - path[1].x)
  path[n] = path[0]
  for (var i = 1; i < n; ++i) {
    s += path[i].y * (path[i - 1].x - path[i + 1].x)
  }
  return s > 0
}
